<!-- eslint-disable vue/no-mutating-props -->
<template>
  <div :class="[detailsWidgetData.detailsType && detailsWidgetData.detailsType === 'pcLine' ? 'details-table-link' : 'details-table-all']" :ref="detailsWidgetData.title + '_' + '2'">
    <template v-if="detailsWidgetData.detailsType && detailsWidgetData.detailsType === 'pcLine'">
      <div v-for="(lists, listsIndex) in formdata ? formdata : []"
           :key="detailsWidgetData.title + listsIndex"
           class="table-link-block">
        <div class="table-link-block-label">
          {{ listsIndex < 9 ? '0' : '' }}{{ listsIndex + 1 }}
        </div>
        <div class="link-delete">
             <el-checkbox v-model="checkObj[listsIndex]" v-if="isInput&&detailsWidgetData.per==1||!isInput&&!detailsWidgetData.detailsNum&&detailsWidgetData.per==1||modifyId" @change="checkFun(listsIndex)"></el-checkbox>
             <i
              v-if="detailsWidgetData.ocrinfo && detailsWidgetData.ocrinfo.switch && isInput && showScan(lists)"
              @click="scanOcr(listsIndex)"
              class="iconfont icon-saoyisao-"
             ></i>
              <i v-if="!detailsWidgetData.pagination && ((detailsWidgetData.per && Number(detailsWidgetData.per) !== 2) || modifyId || websiteIsOpen)" class="iconfont icon-a-shanchu2x" @click="delWidget(listsIndex)" />
            </div>
        <div v-for="(containerList, containerListIndex) in getLinkContainerList()"
              :key="containerListIndex + 'b'"
              class="table-link-block-t">
          <template v-for="list in containerList" :key="list.title + '13'">
            <div :class="['table-link-block-list', layout === 2 || layout === 1 || layout === 4 ? 'link-list-tb' : 'link-list-lr']" :style="getLinkContainerWidth(list)" v-show="getHide(list) && list.per !== 3">
              <div v-if="!list.labelConfig || !list.labelConfig.isNameShow" class="like-list-name">
                {{ list.name }}
                <span v-if="list.required === 'required'" class="required">*</span>
                <span v-if="list.type === 'file' && (lists[list.title + '_' + list.type] || []).length > 1 && (layout === 2 || layout === 1 || layout === 4)" class="file-label-down" @click.stop="fileDown(list, listsIndex)">
                  <i class="iconfont icon-xiazai" />
                  打包下载
                </span>
              </div>
              <div :class="['like-list-input', (list.type !== 'image' && list.type !== 'file' && list.type !== 'relation-check') && list.per === 2 ? 'like-list-input-b' : '', list.type === 'text' && list.per === 2 && list.isLink ? 'text-link' : '']" :style="[list.type === 'relation-user' && list.per === 2 && lists[list.title + '_' + list.type] && lists[list.title + '_' + list.type].length > 0 ? {paddingTop: '5px'} : '', list.type === 'text' && list.format && list.format.value !== 'routine' && list.format.markedRed && (list.format.value === 'number'||list.format.value === 'currency') && lists[list.title + '_' + list.type] < 0 ? {color: 'red'} : '']" @click="openLinkText(lists[list.title + '_' + list.type], list)">
                <template v-if="list.type === 'text'">
                  <template v-if="Number(list.per) === 2 || getUpcontroll(list) || websiteIsOpen">
                    <template v-if="list.format && list.format.value !== 'routine'">
                      <!-- 货币符号 -->
                      <template v-if="(list.format.value==='currency'||list.format.value==='accounting') && list.format.currency !== '万元'">
                        {{list.format.currency}}
                      </template>
                      {{sliceEncrypt(numberFormat(lists[list.title + '_' + list.type],list.format), list.encrypt)}}
                      <!-- 百分比符号、自定义符号 -->
                      <template v-if="list.format.value==='percentage'">%</template>
                      <template v-else-if="list.format.value==='number'">{{list.format.customSymbols}}</template>
                      <template v-else-if="isWYFN(list)">{{list.format.currency}}</template>
                    </template>
                    <template v-else>
                      {{sliceEncrypt(lists[list.title + '_' + list.type],list.encrypt)}}
                    </template>
                  </template>
                    <template v-else>
                      <div v-if="list.queryOnly && list.dataconfig && list.dataconfig.setUpValue && list.dataconfig.setUpValue === 3" class="on-show" style="pointer-events:none;">
                        <div class="on-show-show on-show-left" style="pointer-events:none;">
                          <i class="iconfont icon-shujuchaxun" />
                          {{list.placeholder}}
                        </div>
                      </div>
                      <el-autocomplete
                        style="width: 100%;"
                        size="large"
                        popper-class="select-text"
                        :class="[
                          classFun(list, lists[list.title + '_' + list.type],lists),
                          'input-details',
                          list.queryOnly && list.dataconfig && list.dataconfig.setUpValue && list.dataconfig.setUpValue === 3 ? 'on-show-pointer' : ''
                        ]"
                        :maxlength="list.sizeLimit && list.sizeLimit > 0 && list.sizeLimit !== 'Infinity' ? list.sizeLimit : undefined"
                        v-model="lists[list.title + '_' + list.type]"
                        @focus="autocompleteTextFun(list, true, listsIndex); conditionLink(list); setAi(list, listsIndex)"
                        @input="autoinputFun($event, list, listsIndex)"
                        @blur="approvalProcess(list, listsIndex); conditionLinkObj = null; setAi(null)"
                        @select="approvalProcess(list, listsIndex)"
                        :fetch-suggestions="querySearchAsync"
                        :placeholder="list.placeholder"
                        :readonly="list.type === 'text' && Number(list.disSearch) === 1"
                      ></el-autocomplete>
                    </template>
                    <div
                      class="details-textarea-right"
                      v-if="list.sizeLimit && list.sizeLimit !== 'Infinity'"
                    >{{lists[list.title + '_' + list.type] ? lists[list.title + '_' + list.type].length : 0}}/{{list.sizeLimit}}</div>
                </template>
                <template v-else-if="list.type === 'number'">
                  <template
                    v-if="Number(list.per) === 2 || getUpcontroll(list) || websiteIsOpen"
                  >
                    <!-- 用来数据联动、计算 -->
                    <el-input-number 
                      style="display: none;"
                      size="large"
                      @change="approvalProcess(list, listsIndex)"
                      @input="approvalProcess(list,listsIndex); arithmetic(list,listsIndex)"
                      v-model="lists[list.title + '_' + list.type]" 
                    ></el-input-number>
                    <div
                      class="right-block-number"
                      v-if="list.format && list.format.value !== 'routine'"
                      :style="{
                        color: list.format.markedRed &&
                        (list.format.value === 'number'||list.format.value === 'currency') &&
                        lists[list.title + '_' + list.type] < 0 ? 'red': '',
                        justifyContent: list.format.value==='accounting'?'space-between':''
                      }">
                      <span>
                        <!-- 货币符号 -->
                        <template v-if="(list.format.value==='currency'||list.format.value==='accounting') && list.format.currency !== '万元'">
                          {{list.format.currency}}
                        </template>
                      </span>
                      <span>
                        {{numberFormat(lists[list.title + '_' + list.type],list.format)}}
                        <!-- 百分比符号、自定义符号 -->
                        <template v-if="list.format.value==='percentage'">%</template>
                        <template v-else-if="list.format.value==='number'">{{list.format.customSymbols}}</template>
                        <template v-else-if="isWYFN(list)">{{list.format.currency}}</template>
                      </span>
                    </div>
                    <div v-else>
                      {{lists[list.title + '_' + list.type]}}
                    </div>
                  </template>
                  <el-input-number
                    v-model="lists[list.title + '_' + list.type]"
                    :class="'input-details ' + classFun(list, lists[list.title + '_' + list.type])"
                    v-else
                    :controls="true"
                    controls-position="right"
                    :step="list.step"
                    label="描述文字"
                    style="width:100%"
                    size="large"
                    :placeholder="list.placeholder||'请输入'"
                    @keyup="numDecimal($event,list.format.value!=='routine'?list.format.decimal:null)"
                    @change="approvalProcess(list, listsIndex)"
                    @input="approvalProcess(list,listsIndex); arithmetic(list,listsIndex)"
                    @blur="arithmetic(list,listsIndex)"
                  ></el-input-number>
                </template>
                <template v-else-if="list.type === 'textarea'">
                  <template v-if="Number(list.per) === 2 || getUpcontroll(list) || websiteIsOpen">
                    <span
                      v-html="lists[list.title + '_' + list.type]"
                      style="white-space: pre-wrap;min-height:16px;display:block;"
                    ></span>
                  </template>
                  <template v-else>
                    <div v-if="list.queryOnly && list.dataconfig && list.dataconfig.setUpValue && list.dataconfig.setUpValue === 3" class="on-show" style="pointer-events:none;">
                      <div class="on-show-show on-show-left" style="pointer-events:none;">
                        <i class="iconfont icon-shujuchaxun" />
                        {{list.placeholder}}
                      </div>
                    </div>
                    <el-dropdown
                      trigger="click"
                      width="360"
                      style="width:100%;"
                      placement="bottom-start"
                      :class="list.queryOnly && list.dataconfig && list.dataconfig.setUpValue && list.dataconfig.setUpValue === 3 ? 'on-show-pointer' : ''"
                      @command="handleCommand"
                      v-if="list.sels || (list.dataconfig && Number(list.dataconfig.setUpValue) === 1 || Number(list.dataconfig.setUpValue === 3))"
                    >
                    <span>
                      <el-input
                        type="textarea"
                        :class="'input-details ' + classFun(list, lists[list.title + '_' + list.type])"
                        :autosize="{ minRows: 1, maxRows: 6}"
                        :maxlength="list.sizeLimit && list.sizeLimit > 0 && list.sizeLimit !== 'Infinity' ? list.sizeLimit : undefined"
                        @focus="selschange(true, list, listsIndex); conditionLink(list); setAi(list, listsIndex)"
                        @blur="setAi(null)"
                        @change="approvalProcess(list, listsIndex)"
                        v-model="lists[list.title + '_' + list.type]"
                        :placeholder="list.placeholder"
                      ></el-input>
                    </span>
                      <template #dropdown>
                        <el-dropdown-menu style="max-height:80%;overflow-y:auto;" v-if="list.sels!='[]'">
                          <el-dropdown-item
                            v-for="(popoverList, popIndex) in JSON.parse(list.sels||'[]')"
                            :key="popIndex"
                            v-show="new RegExp(escapeRegex(lists[list.title + '_' + list.type] ? lists[list.title + '_' + list.type] : '')).test(popoverList)"
                            :command="{item2: list, popoverList: popoverList, scopeIndex: listsIndex}"
                          >
                            <div
                              class="popover-list"
                              style="max-width: 800px;line-height: 20px;padding-bottom: 10px;"
                            >{{popoverList}}</div>
                          </el-dropdown-item>
                        </el-dropdown-menu>
                      </template>
                    </el-dropdown>
                    <el-input
                      type="textarea"
                      v-else
                      :class="'input-details ' + classFun(list, lists[list.title + '_' + list.type])"
                      :autosize="{ minRows: 1, maxRows: 6}"
                      :maxlength="list.sizeLimit && list.sizeLimit > 0 && list.sizeLimit !== 'Infinity' ? list.sizeLimit : undefined"
                      @focus="setAi(list, listsIndex)"
                      @blur="setAi(null)"
                      v-model="lists[list.title + '_' + list.type]"
                      :placeholder="list.placeholder"
                      @change="approvalProcess(list, listsIndex)"
                    ></el-input>
                    <div
                      class="details-textarea-right"
                      v-if="list.sizeLimit && list.sizeLimit !== 'Infinity'"
                    >{{lists[list.title + '_' + list.type] ? lists[list.title + '_' + list.type].length : 0}}/{{list.sizeLimit}}</div>
                  </template>
                </template>
                <template v-else-if="list.type === 'radio'">
                  <span v-if="Number(list.per) === 2 || getUpcontroll(list) || websiteIsOpen"
                    :class="['list-block', list.selsItemColor && list.selsItemColor[lists[list.title + '_' + list.type]] ? 'list-block-active' : '', list.types && Number(list.types) === 6 ? 'no-back' : '']"
                    :style="list.selsItemColor && list.selsItemColor[lists[list.title + '_' + list.type]] ? {backgroundColor:list.selsItemColor?list.selsItemColor[lists[list.title + '_' + list.type]]:'#4e86ff',color:'#fff'} : ''"
                  >
                    <template v-if="list.types && Number(list.types) === 5">
                      {{ getRadioProvinces(lists[list.title + '_' + list.type], list) }}
                    </template>
                    <radioXing v-else-if="list.types && Number(list.types) === 6" :sels="objSels(list.sels ? list.sels : [], list)" :value="lists[list.title + '_' + list.type]" @upXing="val => upXing(val, list, listsIndex)" :edit="false" />
                    <template v-else>
                      {{lists[list.title + '_' + list.type] === 'others其他' && list.others ? othersObj[detailsWidgetData.title + '_' + detailsWidgetData.type][listsIndex][list.title + '_' + list.type] : getRadioLabel(lists[list.title + '_' + list.type], objSels(list.sels ? list.sels : [], list))}}
                    </template>
                  </span>
                  <template v-else>
                    <div v-if="list.queryOnly && list.dataconfig && list.dataconfig.setUpValue && list.dataconfig.setUpValue === 1" class="on-show" style="pointer-events:none;">
                      <div class="on-show-show on-show-left" style="pointer-events:none;">
                        <i class="iconfont icon-shujuchaxun" />
                        {{list.placeholder}}
                      </div>
                    </div>
                    <el-radio-group v-model="lists[list.title + '_' + list.type]"
                                    @change="approvalProcess(list, listsIndex)"
                                    v-if="list.types && Number(list.types) === 1">
                      <template v-for="sels in objSels(list.sels ? list.sels : [], list)">
                        <el-radio v-if="!list.isHideObj || !list.isHideObj[sels.value || sels]" :label="sels.value || sels" :key="sels.value">
                          <span
                            class="radiovalue"
                            v-if="list.selsItemColor"
                            :style="{backgroundColor:list.selsItemColor[sels.value || sels],color:list.selsItemColor[sels.value || sels]?'#fff':''}"
                          >{{sels.label || sels}}</span>
                          <template v-else>
                            {{ sels.label || sels }}
                          </template>
                        </el-radio>
                      </template>
                      <el-radio label="others其他" v-if="list.others">其他</el-radio>
                    </el-radio-group>
                    <div v-else-if="list.types && Number(list.types) === 2" class="radio-list">
                      <template v-for="(its, indexIts) in objSels(list.sels ? list.sels : [], list)">
                        <div v-if="!list.isHideObj || !list.isHideObj[its.value || its]"
                            :key="indexIts + (its.value || its)"
                            class="radio-list-imgs"
                            :style="getButtonBlock(its.value || its, list, '', listsIndex)"
                            @click="setRadio({val: its.value || its, item: list, index: listsIndex})">
                          <el-image v-if="list.selsItemImg && list.selsItemImg[its.value || its]"
                                    class="radio-list-img"
                                    :src="$imgurl + list.selsItemImg[its.value || its] + '?accesstoken=' + token"></el-image>
                          <div v-else class="radio-list-img">
                            <i class="el-icon-picture-outline no-icon"></i>
                          </div>
                          <div class="radio-list-text ellipsis" :style="getButtonStyle(its.value || its, list, '', listsIndex)">{{its.label || its}}</div>
                        </div>
                      </template>
                    </div>
                    <div v-else-if="list.types && Number(list.types) === 3" class="radio-list" style="margin-bottom:-10px;">
                      <template v-for="(its, indexIts) in objSels(list.sels ? list.sels : [], list)">
                        <div v-if="!list.isHideObj || !list.isHideObj[its.value || its]"
                          :key="indexIts + (its.value || its)"
                          @click="setCheck({val: its.value || its, item: list, index: listsIndex})"
                          :style="getRadioStyle(its, list, listsIndex)"
                          class="radio-list-button">
                          {{its.label || its}}
                        </div>
                      </template>
                    </div>
                    <div class="radio-switch" v-else-if="list.types && Number(list.types) === 4">
                      <template v-if="list.switchStyle && list.switchStyle === 3">
                        <el-checkbox v-model="lists[list.title + '_' + list.type]"
                                    :true-label="getSwitchColor({ele: list, type: 'active',isGet: true})"
                                    :false-label="getSwitchColor({ele: list, type: 'inactive',isGet: true})"
                                    @change="approvalProcess(list, lists[list.title + '_' + list.type], formdata)" />
                      </template>
                      <el-switch v-else 
                        :active-value="getSwitchColor({ele: list, type: 'active',isGet: true})"
                        :inactive-value="getSwitchColor({ele: list, type: 'inactive',isGet: true})"
                        :active-color="getSwitchColor({ele: list, type: 'active'})"
                        :inactive-color="getSwitchColor({ele: list, type: 'inactive'})"
                        :inactive-text="list.switchStyle === 1 ? '' : getSwitchColor({ele: list, type: 'inactive', isGet: true})"
                        :active-text="list.switchStyle === 1 ? '' : getSwitchColor({ele: list, type: 'active', isGet: true})"
                        v-model="lists[list.title + '_' + list.type]"
                        @change="approvalProcess(list, lists[list.title + '_' + list.type], formdata)"
                      />
                    </div>
                    <multilevel v-else-if="list.types && Number(list.types) === 5" :config="list.multilevelConfig" :formdata="lists[list.title + '_' + list.type]" @update:formdata="handleFormdataUpdata(list, $event)" @change="approvalProcess(list, listsIndex)" :placeholder="list.placeholder" />
                    <radioXing v-else-if="list.types && Number(list.types) === 6" :sels="objSels(list.sels ? list.sels : [], list)" :value="lists[list.title + '_' + list.type]" :edit="true" @upXing="val => upXing(val, list, listsIndex)" />
                    <el-select
                      v-else
                      v-model="lists[list.title + '_' + list.type]"
                      :class="[
                        'input-select select-details ',
                        classFun(list, lists[list.title + '_' + list.type]),
                        list.queryOnly && list.dataconfig && list.dataconfig.setUpValue && list.dataconfig.setUpValue === 1 ? 'on-show-pointer' : ''
                      ]"
                      :placeholder="list.placeholder"
                      style="width: 100%;"
                      size="large"
                      filterable
                      color="#f00"
                      @focus="conditionLink(list)"
                      @change="approvalProcess(list, listsIndex)"
                      @visible-change="radioBlurChange(list.title + '_' + list.type+'_'+listsIndex, $event, list, listsIndex)"
                    >
                      <template #prefix>
                        <div style="display:none;min-height:28px;margin-top:1px;background:#ffffff;height:calc(100% - 2px);" v-if="lists[list.title + '_' + list.type]!=='others其他'&&!radioBlur[list.title + '_' + list.type+'_'+listsIndex] && list.types !== 2 && lists[list.title + '_' + list.type]">
                          <span class="ridiotagstyle ellipsis ellipsis1" :style="{'backgroundColor':list.selsItemColor&&list.selsItemColor[lists[list.title + '_' + list.type]],'color':list.selsItemColor&&list.selsItemColor[lists[list.title + '_' + list.type]]?'#fff':'#333'}">
                            {{getRadioLabel(lists[list.title + '_' + list.type], objSels(list.sels ? list.sels : [], list))}}
                          </span>
                        </div>
                      </template>
                      <template v-for="sels in objSels(list.sels ? list.sels : [], list)">
                        <el-option v-if="!list.isHideObj || !list.isHideObj[sels.value || sels]"
                          :key="sels.value || sels"
                          :label="sels.label || sels"
                          :value="sels.value || sels"
                        >
                          <div v-if="list.types === 2" class="radio-img">
                            <el-image  v-if="list.selsItemImg && getImgRadio(list, sels.value || sels)"
                                      :src="getImgRadio(list, sels.value || sels)"
                                      :preview-src-list="[getImgRadio(list, sels.value || sels)]"
                                      fit="scale-down"
                                      @click.stop
                                      class="radio-imgs">
                              <template #error>
                                <div class="image-slot">
                                  <i class="el-icon-picture-outline"></i>
                                </div>
                              </template>
                            </el-image>
                            <span :style="getRadioTypes(list, sels.value || sels)">{{sels.label || sels}}</span>
                          </div>
                          <span
                            v-else-if="list.selsItemColor"
                            :style="getRadioTypes(list, sels.value || sels)"
                          >{{sels.label || sels}}</span>
                        </el-option>
                      </template>
                      <el-option key="其他" label="其他" value="others其他" v-if="list.others">
                        <span :style="{padding:'4px 8px',borderRadius:'10px'}">其他</span>
                      </el-option>
                    </el-select>
                    <template
                      v-if="list.others && lists[list.title + '_' + list.type] === 'others其他'"
                    >
                      <br />
                      <input
                        type="text"
                        v-model="othersObj[detailsWidgetData.title + '_' + detailsWidgetData.type][listsIndex][list.title + '_' + list.type]"
                        :class="'select-details ' + classFun(list, lists[list.title + '_' + list.type], othersObj[detailsWidgetData.title + '_' + detailsWidgetData.type][listsIndex][list.title + '_' + list.type])"
                        placeholder="请输入内容"
                        class="other-class"
                      />
                    </template>
                  </template>
                </template>
                <template v-else-if="list.type === 'checkbox'">
                  <template v-if="Number(list.per) === 2 || getUpcontroll(list) || websiteIsOpen">
                    <!-- color:list.selsItemColor&&list.selsItemColor[checkList]?'#fff':'#333' -->
                    <span
                      :class="['list-block', list.selsItemColor && list.selsItemColor[checkList] ? 'list-block-active' : '']"
                      v-for="checkList in lists[list.title + '_' + list.type]||[]"
                      :key="checkList"
                      :style="{backgroundColor:list.selsItemColor?list.selsItemColor[checkList]:'#4e86ff',color:'#fff'}"
                    >{{checkList}}</span>
                  </template>
                  <template v-else>
                    <el-checkbox-group v-model="lists[list.title + '_' + list.type]"
                     @change="approvalProcess(list, listsIndex)"
                     v-if="list.types && list.types === 1">
                     <template v-for="sels in objSels(list.sels ? list.sels : [], list)">
                        <el-checkbox v-if="!list.isHideObj || !list.isHideObj[sels.value || sels]" :label="sels" :key="sels.value || sels">
                          <span class="checkboxvalue"
                            v-if="list.selsItemColor"
                            :style="{backgroundColor:list.selsItemColor[sels],color:list.selsItemColor[sels]?'#fff':''}"
                          >{{sels}}</span>
                        </el-checkbox>
                     </template>
                    </el-checkbox-group>
                    <div v-else-if="list.types && list.types === 2" class="radio-list">
                      <template v-for="(its, indexIts) in objSels(list.sels ? list.sels : [], list)">
                        <div v-if="!list.isHideObj || !list.isHideObj[its.value || its]"
                            :key="indexIts + (its.value || its)"
                            class="radio-list-imgs"
                            :style="getButtonBlock(its.value || its, list, true, listsIndex)"
                            @click="setCheck({val: its.value || its, item: list, index: listsIndex})">
                          <el-image v-if="list.selsItemImg && list.selsItemImg[its.value || its]"
                                    class="radio-list-img"
                                    :src="$imgurl + list.selsItemImg[its.value || its] + '?accesstoken=' + token"></el-image>
                          <div v-else class="radio-list-img">
                            <i class="el-icon-picture-outline no-icon"></i>
                          </div>
                          <div class="radio-list-text ellipsis" :style="getButtonStyle(its.value || its, list, true, listsIndex)">{{its.label || its}}</div>
                        </div>
                      </template>
                    </div>
                    <div v-else-if="list.types && list.types === 3" class="radio-list" style="margin-bottom:-10px;">
                      <template v-for="(its, indexIts) in objSels(list.sels ? list.sels : [], list)">
                        <div v-if="!list.isHideObj || !list.isHideObj[its.value || its]"
                          :key="indexIts + (its.value || its)"
                          @click="setCheck({val: its.value || its, item: list, index: listsIndex})"
                          :style="getRadioStyle(its.value || its, list, listsIndex)"
                          class="radio-list-button">
                          {{its.label || its}}
                        </div>
                      </template>
                    </div>
                    <el-select
                      v-model="lists[list.title + '_' + list.type]"
                      v-else
                      filterable
                      :class="'select-details check-inp check-inpA ' + classFun(list, lists[list.title + '_' + list.type])"
                      @focus="conditionLink(list)"
                      @change="approvalProcess(list, listsIndex)"
                      multiple
                      :placeholder="list.placeholder"
                      style="width: 100%"
                      size="large"
                      @visible-change="selschange($event, list, listsIndex)"
                    >
                      <template #prefix>
                        <span style="line-height:normal;display:contents;">
                          <template v-if="lists[list.title + '_' + list.type] && lists[list.title + '_' + list.type].length > 0">
                            <template v-for="sels in lists[list.title + '_' + list.type]" :key="sels.label">
                              <span class="demo-tag-details" :style="{'backgroundColor':list.selsItemColor ? list.selsItemColor[sels] : ''}">{{sels}}</span>
                            </template>
                          </template>
                          <!-- 如果没有数据则显示 placeholder -->
                          <template v-else>
                            <span style="padding-left: 5px;">{{list.placeholder}}</span>
                          </template>
                        </span>
                      </template>
                      <template v-for="sels in objSels(list.sels ? list.sels : [], list)">
                        <el-option
                          v-if="!list.isHideObj || !list.isHideObj[sels.value || sels]"
                          :key="list.title + sels"
                          :label="sels"
                          :value="sels"
                        >
                          <span
                            v-if="list.selsItemColor"
                            :style="{backgroundColor:list.selsItemColor[sels],color:list.selsItemColor[sels]?'#fff':'',padding:'4px 8px',borderRadius:'10px'}"
                          >{{sels}}</span>
                        </el-option>
                      </template>
                    </el-select>
                  </template>
                </template>
                <template v-else-if="list.type === 'date'">
                  <template
                    v-if="Number(list.per) === 2 || getUpcontroll(list) || websiteIsOpen"
                  >
                    <template v-if="list.match && list.match == 'yyyy-MM'">
                      {{ getTimeYM(lists[list.title + '_' + list.type]) }}
                    </template>
                    <template v-else-if="list.match && list.match === 'yyyy-MM-dd HH:mm' && list.timeList && list.timeList.open">
                      {{getTimeYMD(lists[list.title + '_' + list.type])}}  
                    </template>
                    <template v-else-if="list.match && list.match === 'HH:mm'">
                      {{ getTimeHHmm(lists[list.title + '_' + list.type]) }}
                    </template>
                    <template v-else>
                      {{lists[list.title + '_' + list.type]}}
                    </template>
                    <template v-if="lists[list.title + '_' + list.type] && list.match === 'yyyy-MM-dd ww'">
                      &nbsp;&nbsp;
                      星期{{timeWeek(lists[list.title + '_' + list.type])}}
                    </template>
                    <template v-if="list.match && list.match == 'yyyy-MM-dd HH:mm' && list.timeList && list.timeList.open && list.timeList.options.length > 0">
                      &nbsp;&nbsp;
                      {{getTimeLabel(lists[list.title + '_' + list.type], list.timeList.options)}}
                    </template>
                  </template>
                  <div v-else class="time-block">
                    <el-date-picker
                      v-model="lists[list.title + '_' + list.type]"
                      :class="'input-details ' + classFun(list, lists[list.title + '_' + list.type])"
                      type="date"
                      placeholder="选择日期"
                      format="YYYY-MM-DD"
                      :picker-options="pickerOptionsLimit(list)"
                      :default-value="nextMonthFun(list.limit || '')"
                      value-format="YYYY-MM-DD"
                      style="width: 100%;"
                      size="large"
                      v-if="list.match === 'yyyy-MM-dd' || list.match === 'yyyy-MM-dd ww'"
                      @change="approvalProcess(list, listsIndex)"
                    ></el-date-picker>
                    <div v-else-if="list.match && list.match == 'yyyy-MM'" class="time-y-m">
                      <el-date-picker
                        v-model="lists[list.title + '_' + list.type]"
                        type="month"
                        format="YYYY-MM-DD"
                        class="input-details"
                        value-format="YYYY-MM-DD"
                        style="width: 100%;"
                        size="large"
                        :default-value="nextMonthFun(list.limit || '')"
                        @change="approvalProcess(list, listsIndex)"
                        :picker-options="pickerOptionsLimit(list)"
                        placeholder="选择月">
                      </el-date-picker>
                      <div class="time-y-m-text">
                        {{ getTimeYM(lists[list.title + '_' + list.type]) }}
                      </div>
                    </div>
                    <timePicker v-else-if="list.match && list.match == 'yyyy-MM-dd HH:mm' && list.timeList && list.timeList.open && list.timeList.options.length > 0" :formdata="lists" @update:formdata="handleFormdataUpdata(list, $event)" :config="list" :modifyId="modifyId" @change="approvalProcess(list, listsIndex)" />
                    <!--
                    <div v-else-if="list.match && list.match == 'yyyy-MM-dd HH:mm' && list.timeList && list.timeList.open && list.timeList.options.length > 0" class="time-y-m time-md-m">
                      
                      <el-date-picker
                        popper-class="time-zjy-widget-one-layer"
                        v-model="lists[list.title + '_' + list.type]"
                        :class="'input-details ' + classFun(list, lists[list.title + '_' + list.type])"
                        type="date"
                        placeholder="选择日期时间"
                        style="width: 100%;"
                        :picker-options="pickerOptionsLimit(list)"
                        :default-value="nextMonthFun(list.limit || '')"
                        format="YYYY-MM-DD HH:mm"
                        value-format="YYYY-MM-DD HH:mm"
                        @change="(val) => {setTimeDefault(val, list, lists);approvalProcess(list, listsIndex)}"
                      ></el-date-picker>
                      
                      <div class="time-y-m-text">
                        {{ getTimeYMD(lists[list.title + '_' + list.type]) }}
                      </div>
                      <div class="time-md">
                        <el-select v-model="timeWidthObj[list.title + '_' + list.type + '_' + listsIndex]" @change="(val) => getItt(lists, list, val, 1, listsIndex)" placeholder=" ">
                          <el-option v-for="(itt, ittInd) in list.timeList.options" :key="ittInd + list.title" :value="itt.value" :label="itt.label" />
                        </el-select>
                        <div class="time-md-text">{{getTimeLabel(lists[list.title + '_' + list.type], list.timeList.options, list.timeList.defaultValue) || '请选择'}}</div>
                      </div>
                    </div>
                    -->
                    <div v-else-if="list.match && list.match === 'HH:mm'" class="time-y-m time-md-m time-text-color">
                      <el-time-picker
                          @change="approvalProcess(list, listsIndex)"
                          value-format="HH:mm"
                          format="HH:mm"
                          style="width: 100%;"
                          v-model="lists[list.title + '_' + list.type]"
                          :picker-options="{ format: 'HH:mm' }"
                          :disabled="list.exhibiIs"
                          :default-value="nextMonthFun(list.limit || '')"
                          placeholder="任意时间点">
                      </el-time-picker>
                      <div class="time-y-m-text">
                        {{ getTimeHHmm(lists[list.title + '_' + list.type]) }}
                      </div>
                    </div>
                    <el-date-picker
                      v-model="lists[list.title + '_' + list.type]"
                      :class="'input-details ' + classFun(list, lists[list.title + '_' + list.type])"
                      :picker-options="pickerOptionsLimit(list)"
                      type="datetime"
                      placeholder="选择日期时间"
                      style="width: 100%;"
                      size="large"
                      :default-value="nextMonthFun(list.limit || '')"
                      format="YYYY-MM-DD HH:mm:ss"
                      value-format="YYYY-MM-DD HH:mm:ss"
                      @change="approvalProcess(list, listsIndex)"
                      v-else-if="list.match && list.match === 'yyyy-MM-dd HH:mm:ss'"
                    ></el-date-picker>
                    <el-date-picker
                      v-model="lists[list.title + '_' + list.type]"
                      :class="'input-details ' + classFun(list, lists[list.title + '_' + list.type])"
                      :picker-options="pickerOptionsLimit(list)"
                      type="datetime"
                      placeholder="选择日期时间"
                      style="width: 100%;"
                      size="large"
                      :default-value="nextMonthFun(list.limit || '')"
                      format="YYYY-MM-DD HH:mm"
                      value-format="YYYY-MM-DD HH:mm"
                      @change="approvalProcess(list, listsIndex)"
                      v-else
                    ></el-date-picker>
                    <div v-if="lists[list.title + '_' + list.type] && list.match === 'yyyy-MM-dd ww'" class="time-week">星期{{timeWeek(lists[list.title + '_' + list.type])}}</div>
                  </div>
                </template>
                <template v-else-if="list.type === 'relation-user'">
                  <template v-if="Number(list.per) === 2 || getUpcontroll(list) || websiteIsOpen">
                    <span
                      class="relationUserStyle"
                      v-for="relU in lists[list.title + '_' + list.type] || []"
                      :key="relU.organizationId"
                    >
                      <relationUserInfo v-if="list.isMoreInfo" :moreInfo="list.moreInfoArr" :checkedInfo="list.checkKey" :info="relU" :isNewInfo="list.isNewData" />
                      <template v-else>{{ relU.realname }}</template>
                    </span>
                    {{ (lists[list.title + '_' + list.type] || []).length === 0 ? '&nbsp;' : '' }}
                  </template>
                  <!-- 快速录入 -->
                  <div v-else-if="list.isEnterChoice" style="position: relative">
                    <user-drop-down
                      :data="list"
                      :formdata="lists[list.title + '_' + list.type]"
                      :placeholder="list.placeholder==''?'输入添加联系人':list.placeholder"
                      :isDetaild="true"
                      :itemInfo="list"
                      @userCheck="param=>{userCheckCallback(list,listsIndex,lists[list.title + '_' + list.type],param)}"
                      @closeFlow="(index)=>{handleCloseFlow(list,index,listsIndex)}"
                    >
                    </user-drop-down>
                  </div>
                  <div :class="list.dataShow ? 'relation-user-wrap relation-default aaa' : 'relation-user-wrap'" :ref="'relationUserRef_' + list.title" v-else>
                    <p
                      style="cursor: pointer;"
                      class="relation-user"
                      :class="classFun(list, lists[list.title + '_' + list.type]) + ' el-upload__text'"
                      @click="relationUserChoice(list, listsIndex, lists[list.title + '_' + list.type])"
                    >
                      <template
                        v-if="!lists[list.title + '_' + list.type] || lists[list.title + '_' + list.type] && lists[list.title + '_' + list.type].length === 0"
                      >{{list.placeholder == '' ? '选择添加联系人' : list.placeholder}}</template>
                      <template v-for="(relU,index2) in lists[list.title + '_' + list.type]">
                        <el-tag
                          type="info"
                          closable
                          :key="relU.organizationId"
                          :disable-transitions="false"
                          @click="editUser(relU, list, $event)"
                          @close="handleCloseFlow(list, index2, listsIndex)"
                           v-if="(lists[list.title + '_' + list.type] && index2==0) || isExpand(listsIndex)"
                        >{{relU.realname}}</el-tag>
                      </template>
                      <span
                        class="relationUserStyle"
                        v-if="lists[list.title + '_' + list.type] && lists[list.title + '_' + list.type].length > 1 && !isExpand(listsIndex)"
                      >等{{lists[list.title + '_' + list.type].length}}人</span>
                      <span 
                        v-if="(lists[list.title + '_' + list.type] && lists[list.title + '_' + list.type].length > 1) && !isExpand(listsIndex)" 
                        style="color: #4E86FF; font-size: 12px;"
                        @click.stop="expandUser(listsIndex, true)">展开 <i class="iconfont icon-shuangjiantouyou" style="font-size: 12px;" /></span>
                      <span 
                        v-if="(lists[list.title + '_' + list.type] && lists[list.title + '_' + list.type].length > 1) && isExpand(listsIndex)" 
                        style="color: #4E86FF; font-size: 12px;"
                        @click.stop="expandUser(listsIndex, false)">收起 <i class="iconfont icon-shuangjiantouzuo" style="font-size: 12px;" /></span>
                        <el-input
                          v-if="lists[list.title + '_' + list.type] && lists[list.title + '_' + list.type].length < 2"
                          style="width: 100px;"
                          :placeholder="lists[list.title + '_' + list.type].length > 0 ? '' : (list.placeholder==''?'选择添加联系人':list.placeholder)"
                          :autofocus="false"
                          ref="input"
                          v-model="linkedWd[list.title + '_' + list.type + '_' + listsIndex]"
                          @keyup.enter="relationUserChoice(list, listsIndex, lists[list.title + '_' + list.type],'defaultSearch', linkedWd[list.title + '_' + list.type + '_' + listsIndex])"
                          readonly
                        >
                        </el-input>                        
                    </p>
                    <div class="fast-btn">
                      <a href="javascript:;" title="组织查找"><i class="iconfont icon-zuzhijigou"></i></a>
                      <a v-if="list.singleIsUser !== 0" href="javascript:;" title="批量查找" @click="showBatchSearch(list, listsIndex)"><i class="iconfont icon-kuaisuchazhao"></i></a>
                    </div>                   
                    <!-- 下拉框 -->
                    <linked-drop-down
                      v-if="list.dataShow"
                      :ref="'linkedDropDownRef_' + list.title"
                      :formdata="lists[list.title + '_' + list.type]"
                      :isDetaild="true"
                      :itemInfo="list"
                      @userCheck="param=>{userCheckCallback(list,listsIndex,lists[list.title + '_' + list.type],param)}"
                      @closeFlow="(index)=>{handleCloseFlow(list,index,listsIndex)}"
                    >
                    </linked-drop-down>
                  </div>
                </template>
                <template v-else-if="list.type === 'image'">
                  <div
                    class="img-flex"
                    v-if="Number(list.per) === 2 || getUpcontroll(list) || websiteIsOpen"
                  >
                    <div
                      v-for="imgList in lists[list.title + '_' + list.type] || []"
                      class="table-img-list"
                      :key="imgList.url"
                    >
                      <el-image
                        class="list-img"
                        :src="imgList.url || imgUrlHandle(imgList.response)"
                        :z-index="99999"
                        :append-to-body="true"
                        :preview-src-list="[imgUrlHandle(imgList.response)] || (lists[list.title + '_' + list.type] || []).map(val=>{return val.url})"
                      ></el-image>
                    </div>
                  </div>
                  <el-form-item
                    @click="listCli(listsIndex, list.containerListIndex)"
                    v-else
                    @mousemove="listCliRemo(listsIndex, list.containerListIndex)"
                    style="margin-bottom: 0px;"
                  >
                    <div v-if="list.signature === true" class="signa-box">
                      <el-button class="signabtn"  @click="showSigna(list,listsIndex)">点击签名</el-button>
                      <div class="signaPic" v-for="(list1, index) in lists[list.title + '_' + list.type]" :key="index">
                        <el-image
                          fit="cover"
                          :src="list1.url || ($url + list1.response + '?accesstoken=' + token)"></el-image>
                          <a class="btn-delete" title="删除签名" @click="deleteSign(list1,list,listsIndex)"></a>
                      </div>
                    </div>
                    <el-upload
                      v-else
                      :action="$url+'/userfile/upload?accesstoken='+token"
                      ref="upload"
                      :disabled="!upDataFile"
                      :file-list="lists[list.title + '_' + list.type]"
                      :class="'img-file-class ' + classFun(list, lists[list.title + '_' + list.type])"
                      class="file-img-up"
                      :on-progress="handleProgress"
                      list-type="picture-card"
                      :on-preview="handlePreview"
                      :on-success="handleSuccess"
                      :on-error="handleError"
                      :on-remove="handleRemove"
                      :limit="Number(list.upNumber)"
                      :on-exceed="(file, fileList)=>{return handleExceed(file, fileList, list)}"
                      :before-upload="beforeImgUpload"
                      :multiple="true"
                    >
                      <template #trigger>
                        <div
                          class="el-upload__text"
                          style="background: none;border:none;"
                        >
                          <i
                            class="WSiconfont WSicon-fwbcharutupian"
                            style="color:#4284BA;font-size: 14px"
                          ></i>
                          {{list.placeholder == '' ? '选择上传图片' : list.placeholder}}
                        </div>
                      </template>
                    </el-upload>
                  </el-form-item>
                </template>
                <template v-else-if="list.type === 'file'">
                  <template v-if="Number(list.per) === 2 || getUpcontroll(list) || websiteIsOpen">
                    <div
                      class="a-list-download"
                      v-for="(fileList, fileListIndex) in lists[list.title + '_' + list.type] || []"
                      :key="fileListIndex"
                    >
                      <div class="ellipsis">
                        <a
                          class="a-list"
                          href="javascript:volid(0);"
                          @click="file_pvw(fileList)"
                          :title="fileList.realname ? fileList.realname : fileList.name"
                        >{{fileList.realname ? fileList.realname : fileList.name}}</a>
                      </div>
                      <div
                        :style="(fileList.url.indexOf('.pdf') > 0 || fileList.url.indexOf('.PDF') > 0) && list.signet ? 'min-width:80px' : 'min-width:30px'"
                        style="text-align:right"
                      >
                        <template
                          v-if="(fileList.url.indexOf('.pdf') > 0 || fileList.url.indexOf('.PDF') > 0) && list.signet"
                        >
                          <span
                            v-if="fileList.signet&&fileList.signet.isArchived"
                            @click="ondocfileconf({key: fileListIndex, item: list, details:{index: listsIndex, type: detailsWidgetData.type, title: detailsWidgetData.title}})"
                          >已归档</span>
                          <span v-else-if="fileList.signet&&fileList.signet.isRejectSign">已作废</span>
                          <el-dropdown @command="handleSignet" v-else>
                            <span class="el-dropdown-link">
                              签章
                              <i class="el-icon-arrow-down el-icon--right"></i>
                            </span>
                            <template #dropdown>
                              <el-dropdown-menu>
                                <el-dropdown-item
                                  :command="{key: fileListIndex, item: list, command:'a', details:{index: listsIndex, type: detailsWidgetData.type, title: detailsWidgetData.title}}"
                                >签章</el-dropdown-item>
                                <el-dropdown-item
                                  :command="{key: fileListIndex, item: list, command:'b', details:{index: listsIndex, type: detailsWidgetData.type, title: detailsWidgetData.title}}"
                                  v-if="fileList.signet"
                                >作废</el-dropdown-item>
                              </el-dropdown-menu>
                            </template>
                          </el-dropdown>
                        </template>
                        <a class="a-list-download-span" @click="handleFileDown(fileList)">下载</a>
                        <a class="a-list-download-span" v-if="list.isFileEdit" @click="handleFileDown(fileList, true)">编辑</a>
                        <i 
                          v-if="list.fileDocument && (list.fileDocument === 'music' || list.fileDocument === 'video')" 
                          @click="playFun(fileList, list.fileDocument)"
                          :style="{color: themeConfig.headColor}" class="iconfont icon-bofang play" />
                      </div>
                    </div>
                    <span v-if="(lists[list.title + '_' + list.type] || []).length > 1 && !(layout === 2 || layout === 1 || layout === 4)" class="file-label-down" @click.stop="fileDown(list, listsIndex)" style="float:right;">
                      <i class="iconfont icon-xiazai" />
                      打包下载
                    </span>
                    <div
                      style="text-align:center"
                      v-if="list.signet&&lists[list.title + '_' + list.type].length>0"
                    >
                      <el-dropdown @command="handleListSignet">
                        <el-button size="small" type="primary" style="width:170px">
                          批量操作
                          <i class="el-icon-caret-bottom el-icon--right"></i>
                        </el-button>
                        <template #dropdown>
                          <el-dropdown-menu>
                            <el-dropdown-item
                              :command="{item: list, command:'a', details:{index: listsIndex, type: detailsWidgetData.type, title: detailsWidgetData.title}}"
                              v-if="list.signet && list.signetWay"
                            >签章</el-dropdown-item>
                            <el-dropdown-item
                              :command="{item: list, command:'b', details:{index: listsIndex, type: detailsWidgetData.type, title: detailsWidgetData.title}}"
                            >文档签署完毕，归档</el-dropdown-item>
                          </el-dropdown-menu>
                        </template>
                      </el-dropdown>
                    </div>
                  </template>
                  <el-form-item
                    @click="listCli(listsIndex, list.containerListIndex, list, lists[list.title + '_' + list.type])"
                    v-else
                    @mousemove="listCliRemo(listsIndex, list.containerListIndex)"
                    style="margin-bottom: 0px;"
                  >
                    <el-upload
                      :action="$url+'/userfile/upload?accesstoken='+token"
                      ref="upload"
                      style="width: 100%"
                      :disabled="!upDataFile"
                      :file-list="lists[list.title + '_' + list.type]"
                      :class="'img-file-class file-class ' + classFun(list, lists[list.title + '_' + list.type])"
                      :on-progress="handleProgress"
                      list-type="text"
                      :limit="list.upNumber"
                      :on-preview="handlePreview"
                      :on-success="handleSuccess"
                      :on-error="handleError"
                      :on-remove="handleRemove"
                      :before-upload="(val) => beforeFileUpload(val, list)"
                      :multiple="true">
                      <div class="el-upload__text">
                        <el-icon><Link /></el-icon>
                        {{list.placeholder == '' ? '选择添加附件' : list.placeholder}}
                      </div>
                    </el-upload>
                  </el-form-item>
                </template>
                <template v-else-if="list.type === 'relation-check'">
                  <div v-if="lists[list.title + '_' + list.type] && typeof lists[list.title + '_' + list.type] === 'object' && lists[list.title + '_' + list.type].data.length > 0" :ref="list.title + '_' + listsIndex" style="display:flex;align-items:center;min-width:30px;">
                    <div v-if="relevancyShowObj[list.title + '_' + list.type + '_' + listsIndex]"
                      class="rel-dialog">
                      <div class="rel-all-dialog"></div>
                      <div class="rel-all-up" :style="{transform: 'translate('+ relevancyAddress.x + 'px,' + relevancyAddress.y +'px)', width: (relevancyAddress.w || '') + 'px'}">
                          <p class="relation-user"
                            :class="'relation-radio-class el-upload__text ' + classFun(list, lists[list.title + '_' + list.type])"
                            @click="relationRadio(list, 2, listsIndex)"
                            style="cursor: pointer;border:1px solid #DCDCDC;"
                          >
                            <span style="color:#4284BA">
                              <i
                                class="WSiconfont WSicon-fwbbiaoge"
                                style="margin-right: 3px;font-size: 14px"
                              ></i>
                              {{list.placeholder == '' ? '选择添加关联表单' : list.placeholder}}
                            </span>
                          </p>
                          <span class="rel-all-close" @click="openRelUp(list, listsIndex)">确定</span>
                      </div>
                    </div>

                    <tableRead :config="list" :formdata="lists[list.title + '_' + list.type]" />
                    <div v-if="!(Number(list.per) === 2 || websiteIsOpen)"
                        @click="openRelUp(list, listsIndex)"
                        class="rel-button-up" style="margin-left:2px;min-width:30px;">修改</div>
                  </div>
                  <template v-else>
                    <template
                      v-if="Number(list.per) === 2 || getUpcontroll(list) || websiteIsOpen"
                    >{{lists[list.title + '_' + list.type] || '&nbsp;'}}</template>
                    <p v-else
                      class="relation-user"
                      :class="'relation-radio-class el-upload__text ' + classFun(list, lists[list.title + '_' + list.type])"
                      @click="relationRadio(list, 2, listsIndex)"
                      style="cursor: pointer;border:1px solid #DCDCDC;"
                    >
                      <span v-if="!lists[list.title + '_' + list.type] || lists[list.title + '_' + list.type] && lists[list.title + '_' + list.type].data && lists[list.title + '_' + list.type].data.length === 0" style="color:#4284BA">
                        <i
                          class="WSiconfont WSicon-fwbbiaoge"
                          style="margin-right: 3px;font-size: 14px"
                        ></i>
                        {{list.placeholder == '' ? '选择添加关联表单' : list.placeholder}}
                      </span>
                      <template v-else>{{lists[list.title + '_' + list.type]}}</template>
                    </p>
                  </template>
                </template>
                <template v-else-if="list.type === 'new-rel-radio'">
                  <template
                    v-if="Number(list.per) === 2 || getUpcontroll(list) || websiteIsOpen"
                  >{{lists[list.title + '_' + list.type] || '&nbsp;'}}</template>
                  <div
                    v-else
                    :class="'button-rel ' + classFun(list, lists[list.title + '_' + list.type])"
                    :ref="list.title + '_' + listsIndex"
                  >
                  <div v-if="relevancyShowObj[list.title + '_' + list.type + '_' + listsIndex]"
                      class="rel-dialog">
                    <div class="rel-all-dialog"></div>
                      <div class="rel-all-up" :style="{transform: 'translate('+ relevancyAddress.x + 'px,' + relevancyAddress.y +'px)'}">
                        <div class="rel-all-up-ate">
                          <new-rel-radio
                            :relRadio="list"
                            :newIndex="detailsIndex"
                            :isMom="false"
                            :bindVal="lists"
                            :detailsType="detailsWidgetData.title + '_' + detailsWidgetData.type"
                            :scopeIndex="listsIndex"
                            :userHide="userHide"
                            :formdata="formdatas"
                            :approvalId="approvalId"
                            :AuditList="AuditList"
                            @onRelCondition="onRelCondition"
                            @onLinkageNewRel="onLinkageNewRel"
                          ></new-rel-radio>
                          <i
                            class="WSiconfont WSicon-fwbbiaoge icon-rel"
                            @click="relationRadio(list, 1, {x: listsIndex,y: index})"
                          ></i>
                        </div>
                        <span class="rel-all-close" @click="openRelUp(list, listsIndex)">确定</span>
                      </div>
                    </div>
                    <div v-if="lists[list.title + '_' + list.type] || lists[list.title + '_' + list.type]"
                      class="rel-button-up"
                      @click="openRelUp(list, listsIndex)">
                      {{ list.placeholder }}
                    </div>
                    <template v-else>
                      <el-popover
                        placement="bottom-start"
                        width="296"
                        @show="openRel(list.title + 'rel')"
                        trigger="click">
                        <div style="height:230px;background-color:#ffffff;">
                          <new-rel-radio
                            :id="list.title + 'rel'"
                            :ref="list.title + 'rel'"
                            :relRadio="list"
                            :newIndex="detailsIndex"
                            :isMom="false"
                            :bindVal="lists"
                            :detailsType="detailsWidgetData.title + '_' + detailsWidgetData.type"
                            :scopeIndex="listsIndex"
                            :userHide="userHide"
                            :formdata="formdatas"
                            :approvalId="approvalId"
                            :isFocus="true"
                            :AuditList="AuditList"
                            @onRelCondition="onRelCondition"
                            @onLinkageNewRel="onLinkageNewRel"
                          ></new-rel-radio>
                          <i
                            style="top:32px;right:13px;"
                            class="WSiconfont WSicon-fwbbiaoge icon-rel"
                            @click="relationRadio(list, 1, {x: listsIndex,y: index})"
                          ></i>
                        </div>
                        <template #reference>
                          <div class="rel-select rel-selectA">选择</div>
                        </template>
                      </el-popover>
                    </template>
                  </div>
                </template>
              </div>
            </div>
            <!-- list.per !== 3 && getHide(list) &&  --> 
            <template v-if="list.list && list.list.length > 0 && list.type !== 'relation-check' && (list.type !== 'new-rel-radio' || list.type === 'new-rel-radio' && (relShowObj[list.title + '_' + list.type] || !list.isRel))">
              <div v-for="item in list.list" :key="item.title" :class="['table-link-block-list', layout === 2 || layout === 1 || layout === 4 ? 'link-list-tb' : 'link-list-lr']" :style="getLinkContainerWidth(item)" v-show="getHide(item) && item.per !== 3">
                <div v-if="!item.labelConfig || !item.labelConfig.isNameShow" class="like-list-name">
                  {{ item.name }}
                  <span v-if="item.required === 'required'" class="required">*</span>
                </div>
                <div :class="['like-list-input', (list.type !== 'image' && list.type !== 'file' && list.type !== 'relation-check') && item.per === 2 ? 'like-list-input-b' : '']">
                  <div class="on-show" v-if="item.onShow">
                    <div class="on-show-show"
                        v-show="!onShowObj[listsIndex + (item.title + '_' + item.type)]"
                        @click="setOnShow(listsIndex, item, onShowObj[listsIndex + (item.title + '_' + item.type)])">
                      <i class="iconfont icon-dakaiyanjing" />
                      {{list.placeholder}}
                    </div>
                    <i class="iconfont icon-guanbiyanjing on-show-close"
                      @click="setOnShow(listsIndex, item, onShowObj[listsIndex + (item.title + '_' + item.type)])" />
                  </div>
                  <template v-if="item.type === 'text'">
                    <template v-if="item.per === 2 || getUpcontroll(item)">
                      <span v-if="item.format && item.format.value !== 'routine'" :class="item.isLink ? 'text-link' : ''" @click="item.isLink ? openLinkText(lists[item.title + '_' + item.type], item) : ''">
                        {{sliceEncrypt(lists[item.title + '_' + item.type],item.encrypt)}}

                        <!-- 货币符号 -->
                        <template v-if="(item.format.value==='currency'||item.format.value==='accounting') && item.format.currency !== '万元'">
                          {{item.format.currency}}
                        </template>
                        {{sliceEncrypt(numberFormat(lists[item.title + '_' + item.type],item.format), item.encrypt)}}
                        <!-- 百分比符号、自定义符号 -->
                        <template v-if="item.format.value==='percentage'">%</template>
                        <template v-else-if="item.format.value==='number'">{{item.format.customSymbols}}</template>
                        <template v-else-if="isWYFN(item)">{{item.format.currency}}</template>
                      </span>
                      <span v-else-if="item.isLink" class="text-link" @click="openLinkText(lists[item.title + '_' + item.type], item)">
                        {{sliceEncrypt(lists[item.title + '_' + item.type],item.encrypt)}}
                      </span>
                      <template v-else>
                        {{sliceEncrypt(lists[item.title + '_' + item.type],item.encrypt)}}
                      </template>
                    </template>
                    <template v-else>
                      <div v-if="item.queryOnly && item.dataconfig && item.dataconfig.setUpValue && item.dataconfig.setUpValue === 3" class="on-show" style="pointer-events:none;">
                        <div class="on-show-show on-show-left" style="pointer-events:none;">
                          <i class="iconfont icon-shujuchaxun" />
                          {{item.placeholder}}
                        </div>
                      </div>
                      <el-autocomplete
                        style="width: 100%;"
                        size="large"
                        popper-class="select-text"
                        :class="[
                          classFun(item, lists[item.title + '_' + item.type]),
                          'input-details',
                          item.queryOnly && item.dataconfig && item.dataconfig.setUpValue && item.dataconfig.setUpValue === 3 ? 'on-show-pointer' : ''
                        ]"
                        v-model="lists[item.title + '_' + item.type]"
                        @focus="autocompleteFun(item); conditionLink(item); setAi(item, listsIndex)"
                        @input="autoinputFun($event, item, listsIndex)"
                        @blur="approvalProcess(item, listsIndex,list.containerListIndex); conditionLinkObj = null; setAi(null)"
                        @select="approvalProcess(item, listsIndex,list.containerListIndex)"
                        :fetch-suggestions="querySearchAsync"
                        :placeholder="item.placeholder"
                        :readonly="item.type === 'text' && Number(item.disSearch) === 1"
                      ></el-autocomplete>
                    </template>
                  </template>
                  <template v-if="item.type === 'textarea'">
                    <template v-if="item.per === 2 || getUpcontroll(item)">
                      <span
                        v-html="lists[item.title + '_' + item.type]"
                        style="white-space: pre-wrap;"
                      ></span>
                    </template>
                    <template v-else>
                      <div v-if="item.queryOnly && item.dataconfig && item.dataconfig.setUpValue && item.dataconfig.setUpValue === 3" class="on-show" style="pointer-events:none;">
                        <div class="on-show-show on-show-left" style="pointer-events:none;">
                          <i class="iconfont icon-shujuchaxun" />
                          {{item.placeholder}}
                        </div>
                      </div>
                      <el-dropdown
                        trigger="click"
                        v-if="item.sels || item.dataconfig && item.dataconfig.linked && item.dataconfig.linked.conditional.length === 0 && item.dataconfig.linked.resultdata.length > 0"
                        placement="bottom-start"
                        :class="item.queryOnly && item.dataconfig && item.dataconfig.setUpValue && item.dataconfig.setUpValue === 3 ? 'on-show-pointer' : ''"
                        @command="handleCommand"
                        width="360"
                      >
                        <span>
                          <el-input
                            type="textarea"
                            :class="classFun(item, lists[item.title + '_' + item.type])"
                            :autosize="{ minRows: 1}"
                            :maxlength="item.sizeLimit && item.sizeLimit > 0 ? item.sizeLimit : undefined"
                            @focus="conditionLink(item); setAi(item, listsIndex)"
                            @blur="setAi(null)"
                            @change="approvalProcess(item, listsIndex,index)"
                            v-model="lists[item.title + '_' + item.type]"
                            :placeholder="item.placeholder"
                          ></el-input>
                        </span>
                        <template #dropdown>
                          <el-dropdown-menu style="max-height: 80%;overflow-y:auto;">
                            <el-dropdown-item
                              v-for="(popoverList, popIndex) in item.sels ? JSON.parse(item.sels) : []"
                              :key="popIndex"
                              v-show="new RegExp(escapeRegex(lists[item.title + '_' + item.type] ? lists[item.title + '_' + item.type] : '')).test(popoverList)"
                              :command="{item2: item, popoverList: popoverList, scopeIndex: listsIndex}"
                            >
                              <div
                                class="popover-list"
                                style="max-width: 800px;line-height: 20px;padding-bottom: 10px;"
                              >{{popoverList}}</div>
                            </el-dropdown-item>
                          </el-dropdown-menu>
                        </template>
                      </el-dropdown>
                      <el-input
                        type="textarea"
                        v-else
                        :maxlength="item.sizeLimit && item.sizeLimit > 0 ? item.sizeLimit : undefined"
                        :class="[
                          classFun(item, lists[item.title + '_' + item.type]),
                          item.queryOnly && item.dataconfig && item.dataconfig.setUpValue && item.dataconfig.setUpValue === 3 ? 'on-show-pointer' : ''
                      ]"
                        @focus="conditionLink(item); setAi(item, listsIndex)"
                        @blur="setAi(null)"
                        :autosize="{ minRows:1, maxRows: 100}"
                        @change="approvalProcess(item, listsIndex,list.containerListIndex)"
                        v-model="lists[item.title + '_' + item.type]"
                        :placeholder="item.placeholder"
                      ></el-input>
                      <div
                        class="details-textarea-right"
                        v-if="item.sizeLimit && item.sizeLimit !== 'Infinity'"
                      >{{lists[item.title + '_' + item.type] ? lists[item.title + '_' + item.type].length : 0}}/{{item.sizeLimit}}</div>
                    </template>
                  </template>
                  <template v-if="item.type === 'date'">
                    <template
                      v-if="item.per === 2 || getUpcontroll(item)"
                    >
                      <template v-if="item.match && item.match == 'yyyy-MM'">
                        {{ getTimeYM(lists[item.title + '_' + item.type]) }}
                      </template>
                      <template v-else-if="item.match && item.match === 'yyyy-MM-dd HH:mm' && item.timeList && item.timeList.open">
                        {{getTimeYMD(lists[item.title + '_' + item.type])}}  
                      </template>
                      <template v-else-if="item.match && item.match === 'HH:mm'">
                        {{getTimeHHmm(lists[item.title + '_' + item.type])}}  
                      </template>
                      <template v-else>
                        {{lists[item.title + '_' + item.type]}}
                      </template>
                      <template v-if="lists[item.title + '_' + item.type] && item.match === 'yyyy-MM-dd ww'">
                        &nbsp;&nbsp;
                        星期{{timeWeek(lists[item.title + '_' + item.type])}}
                      </template>
                      <template v-if="item.match && item.match == 'yyyy-MM-dd HH:mm' && item.timeList && item.timeList.open && item.timeList.options.length > 0">
                        &nbsp;&nbsp;
                        {{getTimeLabel(lists[item.title + '_' + item.type], item.timeList.options)}}
                      </template>
                    </template>
                    <div v-else class="time-block">
                      <el-date-picker
                        v-model="lists[item.title + '_' + item.type]"
                        type="date"
                        placeholder="选择日期"
                        format="YYYY-MM-DD"
                        value-format="YYYY-MM-DD"
                        style="width: 100%;"
                        size="large"
                        :class="classFun(item, lists[item.title + '_' + item.type])"
                        v-if="item.match === 'yyyy-MM-dd' || item.match === 'yyyy-MM-dd ww'"
                        :default-value="nextMonthFun(item.limit || '')"
                        :picker-options="pickerOptionsLimit(item)"
                        @change="approvalProcess(item, listsIndex,list.containerListIndex)"
                      ></el-date-picker>
                      <div v-else-if="item.match && item.match == 'yyyy-MM'" class="time-y-m">
                        <el-date-picker
                          v-model="lists[item.title + '_' + item.type]"
                          type="month"
                          format="YYYY-MM-DD"
                          class="input-details"
                          value-format="YYYY-MM-DD"
                          style="width: 100%;"
                          size="large"
                          :default-value="nextMonthFun(item.limit || '')"
                          @change="approvalProcess(item, listsIndex,list.containerListIndex)"
                          :picker-options="pickerOptionsLimit(item)"
                          placeholder="选择月">
                        </el-date-picker>
                        <div class="time-y-m-text">
                          {{ getTimeYM(lists[item.title + '_' + item.type]) }}
                        </div>
                      </div>
                      <timePicker v-else-if="item.match && item.match == 'yyyy-MM-dd HH:mm' && item.timeList && item.timeList.open && item.timeList.options.length > 0" :config="list" :formdata="lists" @update:formdata="handleFormdataUpdata(item, $event)" :modifyId="modifyId" @change="approvalProcess(item, listsIndex, list.containerListIndex)" />
                      <!--
                      <div v-else-if="item.match && item.match == 'yyyy-MM-dd HH:mm' && item.timeList && item.timeList.open && item.timeList.options.length > 0" class="time-y-m time-md-m">
                      
                        <el-date-picker
                          popper-class="time-zjy-widget-one-layer"
                          v-model="lists[item.title + '_' + item.type]"
                          :class="classFun(item, lists[item.title + '_' + item.type])"
                          type="date"
                          placeholder="选择日期时间"
                          style="width: 100%;"
                          :default-value="nextMonthFun(item.limit || '')"
                          :picker-options="pickerOptionsLimit(item)"
                          @change="(val) => {setTimeDefault(val, item, lists); approvalProcess(item, listsIndex, list.containerListIndex)}"
                          format="YYYY-MM-DD HH:mm"
                          value-format="YYYY-MM-DD HH:mm"
                        ></el-date-picker>
                        
                        <div class="time-y-m-text">
                          {{ getTimeYMD(lists[item.title + '_' + item.type]) }}
                        </div>
                        <div class="time-md">
                          <el-select v-model="timeWidthObj[item.title + '_' + item.type + '_1_' + listsIndex]" @change="(val) => getItt(lists, item, val, 2, listsIndex, list.containerListIndex)" placeholder=" ">
                            <el-option v-for="(itt, ittInd) in item.timeList.options" :key="ittInd + list.title" :value="itt.value" :label="itt.label" />
                          </el-select>
                          <div class="time-md-text">{{getTimeLabel(lists[item.title + '_' + item.type], item.timeList.options, item.timeList.defaultValue) || '请选择'}}</div>
                        </div>
                      </div>
                      -->
                      <div v-else-if="item.match && item.match === 'HH:mm'" class="time-y-m time-md-m time-text-color">
                        <el-time-picker
                            @change="approvalProcess(item, listsIndex,list.containerListIndex)"
                            value-format="HH:mm"
                            format="HH:mm"
                            style="width: 100%;"
                            v-model="lists[item.title + '_' + item.type]"
                            :picker-options="{ format: 'HH:mm' }"
                            :disabled="item.exhibiIs"
                            placeholder="任意时间点">
                        </el-time-picker>
                        <div class="time-y-m-text">
                          {{ getTimeHHmm(lists[item.title + '_' + item.type]) }}
                        </div>
                      </div>
                      <el-date-picker
                        v-model="lists[item.title + '_' + item.type]"
                        type="datetime"
                        placeholder="选择日期时间"
                        style="width: 100%;"
                        size="large"
                        :class="classFun(item, lists[item.title + '_' + item.type])"
                        format="YYYY-MM-DD HH:mm:ss"
                        value-format="YYYY-MM-DD HH:mm:ss"
                        :default-value="nextMonthFun(item.limit || '')"
                        :picker-options="pickerOptionsLimit(item)"
                        @change="approvalProcess(item, listsIndex,list.containerListIndex)"
                        v-else-if="item.match && item.match == 'yyyy-MM-dd HH:mm:ss'"
                      ></el-date-picker>
                      <el-date-picker
                        v-model="lists[item.title + '_' + item.type]"
                        type="datetime"
                        placeholder="选择日期时间"
                        style="width: 100%;"
                        size="large"
                        :class="classFun(item, lists[item.title + '_' + item.type])"
                        format="YYYY-MM-DD HH:mm"
                        value-format="YYYY-MM-DD HH:mm"
                        :default-value="nextMonthFun(item.limit || '')"
                        :picker-options="pickerOptionsLimit(item)"
                        @change="approvalProcess(item, listsIndex,list.containerListIndex)"
                        v-else
                      ></el-date-picker>
                      <div v-if="lists[item.title + '_' + item.type] && item.match === 'yyyy-MM-dd ww'" class="time-week">星期{{timeWeek(lists[item.title + '_' + item.type])}}</div>
                    </div>
                  </template>
                  <template v-if="item.type === 'number'">
                    <template
                      v-if="item.per === 2 || getUpcontroll(item)"
                    >{{lists[item.title + '_' + item.type]}}</template>
                    <el-input-number
                      v-else
                      v-model="lists[item.title + '_' + item.type]"
                      :class="classFun(item, lists[item.title + '_' + item.type])"
                      :controls="false"
                      :step="item.step"
                      label="描述文字"
                      style="width:100%"
                      size="large"
                      @change="approvalProcess(item, listsIndex,list.containerListIndex)"
                    ></el-input-number>
                  </template>
                  <template v-if="item.type === 'radio'">
                    <template v-if="item.per === 2 || getUpcontroll(item)">
                      <span
                        :class="['list-block', item.selsItemColor && item.selsItemColor[lists[item.title + '_' + item.type]] ? 'list-block-active' : '', item.types && Number(item.types) === 6 ? 'no-back' : '']"
                        :style="item.selsItemColor && item.selsItemColor[lists[item.title + '_' + item.type]] ? {backgroundColor:item.selsItemColor? item.selsItemColor[lists[item.title + '_' + item.type]] : '#fff',color:item.selsItemColor&&item.selsItemColor[lists[item.title + '_' + item.type]] ? '#fff' : '#333'} : ''"
                      >
                        <template v-if="item.types && Number(item.types) === 5">
                          {{ getRadioProvinces(lists[item.title + '_' + item.type], item) }}
                        </template>
                        <radioXing v-else-if="item.types && Number(item.types) === 6" :sels="objSels(item.sels, item)" :value="lists[item.title + '_' + item.type]" @upXing="val => upXing(val, item, listsIndex)" :edit="false" />
                        <template v-else>
                          {{lists[item.title + '_' + item.type] === 'others其他' && item.others ? othersObj[detailsWidgetData.title + '_' + detailsWidgetData.type][listsIndex][item.title + '_' + item.type] : getRadioLabel(lists[item.title + '_' + item.type], objSels(item.sels, item))}}
                        </template>
                      </span>
                    </template>
                    <template v-else>
                      <div v-if="item.queryOnly && item.dataconfig && item.dataconfig.setUpValue && item.dataconfig.setUpValue === 1" class="on-show" style="pointer-events:none;">
                        <div class="on-show-show on-show-left" style="pointer-events:none;">
                          <i class="iconfont icon-shujuchaxun" />
                          {{item.placeholder}}
                        </div>
                      </div>
                      <el-radio-group v-model="lists[item.title + '_' + item.type]"
                                    @change="approvalProcess(item, listsIndex,list.containerListIndex)"
                                    v-if="item.types && Number(item.types) === 1">
                        <template v-for="sels in objSels(item.sels, item)">
                          <el-radio v-if="!item.isHideObj || !item.isHideObj[sels.value || sels]" :label="sels.value || sels" :key="sels.value">
                            <span
                              class="radiovalue"
                              v-if="item.selsItemColor"
                              :style="{backgroundColor:item.selsItemColor[sels.value || sels],color:item.selsItemColor[sels.value || sels]?'#fff':''}"
                            >{{sels.label || sels}}</span>
                            <template v-else>
                              {{ sels.label || sels }}
                            </template>
                          </el-radio>
                        </template>
                        <el-radio label="others其他" v-if="item.others">其他</el-radio>
                      </el-radio-group>
                      <div v-else-if="item.types && Number(item.types) === 2" class="radio-list">
                        <template v-for="(its, indexIts) in objSels(item.sels, item)">
                          <div v-if="!item.isHideObj || !item.isHideObj[its.value || its]"
                              :key="indexIts + (its.value || its)"
                              class="radio-list-imgs"
                              :style="getButtonBlock(its.value || its, item, '', listsIndex)"
                              @click="setRadio({val: its.value || its, item: item, index: listsIndex})">
                            <el-image v-if="item.selsItemImg && item.selsItemImg[its.value || its]"
                                      class="radio-list-img"
                                      :src="$imgurl + item.selsItemImg[its.value || its] + '?accesstoken=' + token"></el-image>
                            <div v-else class="radio-list-img">
                              <i class="el-icon-picture-outline no-icon"></i>
                            </div>
                            <div class="radio-list-text ellipsis" :style="getButtonStyle(its.value || its, item, '', listsIndex)">{{its.label || its}}</div>
                          </div>
                        </template>
                      </div>
                      <div v-else-if="item.types && Number(item.types) === 3" class="radio-list" style="margin-bottom:-10px;">
                        <template v-for="(its, indexIts) in objSels(item.sels, item)">
                          <div v-if="!item.isHideObj || !item.isHideObj[its.value || its]"
                            :key="indexIts + (its.value || its)"
                            @click="setCheck({val: its.value || its, item: item, index: listsIndex})"
                            :style="getRadioStyle(its, item, listsIndex)"
                            class="radio-list-button">
                            {{its.label || its}}
                          </div>
                        </template>
                      </div>
                      <div class="radio-switch" v-else-if="item.types && Number(item.types) === 4">
                        <template v-if="item.switchStyle && item.switchStyle === 3">
                          <el-checkbox v-model="lists[item.title + '_' + item.type]"
                                      :true-label="getSwitchColor({ele: item, type: 'active',isGet: true})"
                                      :false-label="getSwitchColor({ele: item, type: 'inactive',isGet: true})"
                                      @change="approvalProcess(item, lists[item.title + '_' + item.type], formdata)" />
                        </template>
                        <el-switch 
                          :active-value="getSwitchColor({ele: item, type: 'active',isGet: true})"
                          :inactive-value="getSwitchColor({ele: item, type: 'inactive',isGet: true})"
                          :active-color="getSwitchColor({ele: item, type: 'active'})"
                          :inactive-color="getSwitchColor({ele: item, type: 'inactive'})"
                          :inactive-text="item.switchStyle === 1 ? '' : getSwitchColor({ele: item, type: 'inactive', isGet: true})"
                          :active-text="item.switchStyle === 1 ? '' : getSwitchColor({ele: item, type: 'active', isGet: true})"
                          v-model="lists[item.title + '_' + item.type]"
                          @change="approvalProcess(item, lists[item.title + '_' + item.type], formdata)"
                        />
                      </div>
                      <multilevel v-else-if="item.types && Number(item.types) === 5" :config="item.multilevelConfig" :formdata="lists[item.title + '_' + item.type]" @update:formdata="handleFormdataUpdata(item, $event)" @change="approvalProcess(item, listsIndex,list.containerListIndex)" :placeholder="item.placeholder" />
                      <radioXing v-else-if="item.types && Number(item.types) === 6" :sels="objSels(item.sels, item)" :value="lists[item.title + '_' + item.type]" :edit="true" @upXing="val => upXing(val, item, listsIndex, list.containerListIndex)" />
                      <el-select
                        v-else
                        filterable
                        v-model="lists[item.title + '_' + item.type]"
                        :class="[
                          'input-select input-details select-details ',
                          classFun(item, lists[item.title + '_' + item.type]),
                          item.queryOnly && item.dataconfig && item.dataconfig.setUpValue && item.dataconfig.setUpValue === 1 ? 'on-show-pointer' : ''
                        ]"
                        :placeholder="item.placeholder"
                        style="width: 100%;"
                        size="large"
                        @focus="conditionLink(item)"
                        @change="approvalProcess(item, listsIndex,list.containerListIndex)"
                        @visible-change="radioBlurChange(list.title+'_'+list.type+'_'+listsIndex, $event)"
                      >
                        <template #prefix>
                          <div style="display:none;min-height:28px;margin-top:1px;background:#ffffff;height:calc(100% - 2px);" v-if="lists[item.title + '_' + item.type] && lists[item.title + '_' + item.type]!=='others其他'&&!radioBlur[list.title+'_'+list.type+'_'+listsIndex] && (!item.types || item.types !== 2)">
                            <span class="ridiotagstyle ellipsis ellipsis2" :style="{'backgroundColor':item.selsItemColor&&item.selsItemColor[lists[item.title + '_' + item.type]],'color':item.selsItemColor&&item.selsItemColor[lists[item.title + '_' + item.type]]?'#fff':'#333'}">
                              {{ getRadioLabel(lists[item.title + '_' + item.type], objSels(item.sels, item)) }}
                            </span>
                          </div>
                        </template>
                        <template v-for="sels in objSels(item.sels, item)">
                          <el-option
                            v-if="!item.isHideObj || !item.isHideObj[sels.value || sels]"
                            :key="sels.id"
                            :label="sels.label || sels"
                            :value="sels.value || sels"
                          >
                            <div v-if="item.types && item.types === 2" class="radio-img">
                              <el-image  v-if="item.selsItemImg && getImgRadio(item, sels.value || sels)"
                                        :src="getImgRadio(item, sels.value || sels)"
                                        :preview-src-list="[getImgRadio(item, sels.value || sels)]"
                                        fit="scale-down"
                                        @click.stop
                                        class="radio-imgs">
                                <template #error>
                                  <div class="image-slot">
                                    <i class="el-icon-picture-outline"></i>
                                  </div>
                                </template>
                              </el-image>
                              <span :style="getRadioTypes(item, sels.value || sels)">{{sels.label || sels}}</span>
                            </div>
                            <span
                              v-else-if="item.selsItemColor"
                              :style="getRadioTypes(item, sels.value || sels)"
                            >{{sels}}</span>
                          </el-option>  
                        </template>
                        <el-option key="其他" label="其他" value="others其他" v-if="item.others">
                          <span :style="{padding:'4px 8px',borderRadius:'10px'}">其他</span>
                        </el-option>
                      </el-select>
                      <template
                        v-if="item.others && lists[item.title + '_' + item.type] === 'others其他'"
                      >
                        <br />
                        <input
                          type="text"
                          v-model="othersObj[detailsWidgetData.title + '_' + detailsWidgetData.type][listsIndex][item.title + '_' + item.type]"
                          :class="classFun(item, lists[item.title + '_' + item.type], othersObj[detailsWidgetData.title + '_' + detailsWidgetData.type][listsIndex][item.title + '_' + item.type])"
                          placeholder="请输入内容"
                          class="other-class"
                        />
                      </template>
                    </template>
                  </template>
                  <template v-if="item.type === 'checkbox'">
                    <template v-if="item.per === 2 || getUpcontroll(item)">
                      <span
                        :class="['list-block', item.selsItemColor && item.selsItemColor[list] ? 'list-block-active' : '']"
                        v-for="list in lists[item.title + '_' + item.type] || []"
                        :key="list.id"
                        :style="{backgroundColor:item.selsItemColor? item.selsItemColor[list] : '#fff',color:item.selsItemColor&&item.selsItemColor[list] ? '#fff' : '#333'}"
                      >{{list}}</span>
                    </template>
                    <template v-else>
                      <el-checkbox-group v-model="lists[item.title + '_' + item.type]"
                      @change="approvalProcess(item, listsIndex,list.containerListIndex)"
                      v-if="item.types && item.types === 1">
                      <template v-for="sels in objSels(item.sels, item)">
                          <el-checkbox v-if="!item.isHideObj || !item.isHideObj[sels.value || sels]" :label="sels" :key="sels.value || sels">
                            <span class="checkboxvalue"
                              v-if="item.selsItemColor"
                              :style="{backgroundColor:item.selsItemColor[sels],color:item.selsItemColor[sels]?'#fff':''}"
                            >{{sels}}</span>
                          </el-checkbox>
                      </template>
                      </el-checkbox-group>
                      <div v-else-if="item.types && item.types === 2" class="radio-list">
                        <template v-for="(its, indexIts) in objSels(item.sels, item)">
                          <div v-if="!item.isHideObj || !item.isHideObj[its.value || its]"
                              :key="indexIts + (its.value || its)"
                              class="radio-list-imgs"
                              :style="getButtonBlock(its.value || its, item, true, listsIndex)"
                              @click="setCheck({val: its.value || its, item: item, index: listsIndex})">
                            <el-image v-if="item.selsItemImg && item.selsItemImg[its.value || its]"
                                      class="radio-list-img"
                                      :src="$imgurl + item.selsItemImg[its.value || its] + '?accesstoken=' + token"></el-image>
                            <div v-else class="radio-list-img">
                              <i class="el-icon-picture-outline no-icon"></i>
                            </div>
                            <div class="radio-list-text ellipsis" :style="getButtonStyle(its.value || its, item, true, listsIndex)">{{its.label || its}}</div>
                          </div>
                        </template>
                      </div>
                      <div v-else-if="item.types && item.types === 3" class="radio-list" style="margin-bottom:-10px;">
                        <template v-for="(its, indexIts) in objSels(item.sels, item)">
                          <div v-if="!item.isHideObj || !item.isHideObj[its.value || its]"
                            :key="indexIts + (its.value || its)"
                            @click="setCheck({val: its.value || its, item: item, index: listsIndex})"
                            :style="getRadioStyle(its.value || its, item, listsIndex)"
                            class="radio-list-button">
                            {{its.label || its}}
                          </div>
                        </template>
                      </div>
                      <el-select
                        v-else
                        filterable
                        v-model="lists[item.title + '_' + item.type]"
                        :class="'select-details check-inp check-inpB ' + classFun(item, lists[item.title + '_' + item.type])"
                        @focus="conditionLink(item)"
                        @change="approvalProcess(item, listsIndex,list.containerListIndex)"
                        multiple
                        placeholder="请选择"
                        style="width: 100%"
                        size="large"
                      >
                        <template #prefix>
                          <span style="line-height:normal;display:contents;">
                            <template v-if="lists[item.title + '_' + item.type] && lists[item.title + '_' + item.type].length > 0">
                              <template v-for="sels in lists[item.title + '_' + item.type]" :key="sels.label">
                                <span class="demo-tag-details" :style="{'backgroundColor':item.selsItemColor ? item.selsItemColor[sels] : '','marginTop':'5px'}">{{sels}}</span>
                              </template>
                            </template>
                            <!-- 如果没有数据则显示 placeholder -->
                            <template v-else>
                              <span style="padding-left: 5px;">{{item.placeholder}}</span>
                            </template>
                          </span>
                        </template>
                        <template v-for="sels in objSels(item.sels, item)">
                          <el-option
                            v-if="!item.isHideObj || !item.isHideObj[sels.value || sels]"
                            :key="sels"
                            :label="sels"
                            :value="sels"
                          >
                            <span
                              v-if="item.selsItemColor"
                              :style="{backgroundColor:item.selsItemColor[sels],color:item.selsItemColor[sels]?'#fff':'',padding:'4px 8px',borderRadius:'10px'}"
                            >{{sels}}</span>
                          </el-option>  
                        </template>
                      </el-select>
                    </template>
                  </template>
                  <template v-if="item.type === 'relation-user'">
                    <template v-if="item.per === 2 || getUpcontroll(item)">
                      <span
                        :key="relU.organizationId"
                        v-for="relU in lists[item.title + '_' + item.type] || []"
                      >{{relU.realname}}</span>
                      {{ (lists[item.title + '_' + item.type] || []).length === 0 ? '&nbsp;' : '' }}
                    </template>
                    <template v-else>
                      <template
                        v-if="lists[item.title + '_' + item.type] && lists[item.title + '_' + item.type].length !== 0"
                      >
                        <div
                          class="relation-user"
                          @click="relationUserChoice(item, listsIndex, lists[item.title + '_' + item.type])"
                          style="cursor: pointer;"
                        >
                          <template
                            v-for="(relU,index3) in lists[item.title + '_' + item.type]"
                          >
                            <el-tag
                              type="info"
                              :key="relU.organizationId"
                              closable
                              :disable-transitions="false"
                              @close="handleCloseFlow(item, index3, listsIndex)"
                              v-if="index3==0"
                            >{{relU.realname}}</el-tag>
                          </template>
                          <span
                            v-if="lists[item.title + '_' + item.type].length > 1"
                          >等{{lists[item.title + '_' + item.type].length}}人</span>
                        </div>
                      </template>
                      <div
                        v-else
                        :class="classFun(item, lists[item.title + '_' + item.type])"
                      >
                        <div
                          class="relation-user"
                          @click="relationUserChoice(item, listsIndex, lists[item.title + '_' + item.type])"
                        >
                          <span>
                            <i
                              class="iconfont icon-lianxirenkongjianxuanzerenyuan"
                              style="margin-right: 5px"
                            ></i>
                            {{item.placeholder == '' ? '选择添加联系人' : item.placeholder}}
                          </span>
                        </div>
                      </div>
                    </template>
                  </template>
                  <template v-if="item.type === 'image'">
                    <div
                      class="img-flex"
                      v-if="Number(item.per) === 2 || getUpcontroll(item) || websiteIsOpen"
                    >
                      <div
                        v-for="imgList in lists[item.title + '_' + item.type] || []"
                        class="table-img-list"
                        :key="imgList.url"
                      >
                        <el-image
                          class="list-img"
                          :src="imgList.url || imgUrlHandle(imgList.response)"
                          :z-index="99999"
                          :append-to-body="true"
                          :preview-src-list="[imgUrlHandle(imgList.response)] || (lists[item.title + '_' + item.type] || []).map(val=>{return val.url})"
                        ></el-image>
                      </div>
                    </div>

                    <el-form-item
                      @click="listCli(listsIndex, list.containerListIndex)"
                      v-else
                      @mousemove="listCliRemo(listsIndex, list.containerListIndex)"
                      style="margin-bottom: 0px;"
                    >
                      <div v-if="item.signature === true" class="signa-box">
                        <el-button class="signabtn"  @click="showSigna(item,listsIndex)">点击签名</el-button>
                        <div v-for="(list1, index) in lists[item.title + '_' + item.type]" :key="index">
                          <el-image
                            fit="cover"
                            :src="list1.url || ($url + list1.response + '?accesstoken=' + token)" class="signaPic" ></el-image>
                        </div>
                      </div>
                      <el-upload
                        v-else
                        :action="$url+'/userfile/upload?accesstoken='+token"
                        ref="upload"
                        :disabled="!upDataFile"
                        :file-list="lists[item.title + '_' + item.type]"
                        :class="'img-file-class ' + classFun(item, lists[item.title + '_' + item.type])"
                        class="file-img-up"
                        :on-progress="handleProgress"
                        list-type="picture-card"
                        :on-preview="handlePreview"
                        :on-success="handleSuccess"
                        :on-error="handleError"
                        :on-remove="handleRemove"
                        :limit="Number(item.upNumber)"
                        :on-exceed="(file, fileList)=>{return handleExceed(file, fileList, item)}"
                        :before-upload="beforeImgUpload"
                        :multiple="true"
                      >
                        <template #trigger>
                          <div
                            class="el-upload__text"
                            style="background: none;border:none;"
                          >
                            <i
                              class="WSiconfont WSicon-fwbcharutupian"
                              style="color:#4284BA;font-size: 14px"
                            ></i>
                            {{item.placeholder == '' ? '选择上传图片' : item.placeholder}}
                          </div>
                        </template>
                      </el-upload>
                    </el-form-item>
                  </template>
                </div>
              </div>
            </template>
          </template>
        </div>
      </div>
      <div v-if="detailsWidgetData.statistics && detailsWidgetData.statistics.length > 0" class="table-link-block" style="padding-bottom:22px;">
        <div class='table-link-block-t' v-for="(list, ind) in getStatistics()" :key="ind + 'summ'">
          <div class="table-link-block-list link-list-tb">{{ind > 0 ? '' : '汇总'}}</div>
          <div v-for="(item, itemI) in list" :key="itemI + '222_' + ind" class="table-link-block-list link-list-tb">
            <template v-if="item && item.title">
              {{ item.name }}：{{summaryObj[item.title + '_' + item.type]}}
            </template>
            <template v-else>&nbsp;</template>
          </div>
        </div>
      </div>
    </template>
    <template v-else>
      <div class="header">
        <div
          class="details-table-row table-col-nowrap"
          :style="{ transform: 'translate3d(' + topDistance + 'px,0,0)', zIndex: 8}"
          v-if="isInput&&detailsWidgetData.per==1||!isInput&&!detailsWidgetData.detailsNum&&detailsWidgetData.per==1||modifyId"
        >
          <div class="details-table-header-row" style="width: 14px">
            <el-checkbox v-if="!detailsWidgetData.tableSAll" v-model="checkAll" @change="handleCheckAllChange"></el-checkbox>
          </div>
        </div>
        <div class="details-table-row table-col-nowrap"
            :style="{ transform: 'translate3d(' + topDistance + 'px,0,0)', zIndex: 8 }"
        >
          <div
            class="details-table-header-row text-center"
            style="width: 28px"
          >{{detailsWidgetData.per && Number(detailsWidgetData.per) !== 2 || !detailsWidgetData.per ? '操作' : '序号'}}</div>
        </div>
        <template v-for="(list, index) in detailsWidgetData.list">
          <template v-if="list.per !== 3 && getHide(list)">
            <table-header-col :style="freezeObj[list.title + '_' + list.type] ? ('transform:translate3d(' + topDistance + 'px,0,0);z-index:8;') : ''"
                              :key="list.title + '-' + index">
           <!-- <table-header-col :style="[freezeObj[list.title + '_' + list.type] ? {transform: 'translate3d(' + topDistance + 'px,0,0)', zIndex: 8} : '', getDetailsWidth(list, false, true)]"
                              :key="list.title + '-' + index"> -->
              <div class="details-table-header-row details-width widthA" :style="getDetailsWidth(list, false) + getBackk(list)">
              
                <i class="cor-red" v-if="list.required === 'required'">*</i>
                <div class="one-omit file-label" :title="list.name">
                  <el-tooltip v-if="list.annotationTop || list.annotationBottom" effect="light" placement="top">
                    <template #content>
                      <div>{{ list.annotationTop }}<br/>{{ list.annotationBottom }}</div>
                    </template>
                    <span style="cursor:pointer;">{{list.name}}</span>
                  </el-tooltip>
                  <template v-else>
                    {{list.name}}
                  </template>
                </div>
              </div>
              <!--  v-if="!detailsWidgetData.detailsTableType || detailsWidgetData.detailsTableType === 'scroll'" -->
              <span class="table-mouse"
                @mousedown="addMousedown($event, list.title + '_' + list.type)"
              ></span>
            </table-header-col>
            <template v-if="list.list && list.list.length > 0 && list.type !== 'relation-check' && (list.type !== 'new-rel-radio' || list.type === 'new-rel-radio' && (relShowObj[list.title + '_' + list.type] || !list.isRel) || detailsWidgetData.detailsTableType && detailsWidgetData.detailsTableType === 'flex')">
              <template v-for="(item, itemIndex) in list.list" :key="index + '-' +itemIndex">
                <table-header-col
                  v-if="item.per !== 3 && getHide(item)"
                  :style="freezeObj[item.title + '_' + item.type] ? ('transform:translate3d(' + topDistance + 'px,0,0);z-index:8;') : ''"
                >
                  <div
                    class="details-table-header-row details-width widthB"
                    :style="getDetailsWidth(item, false, true, list.title)"
                  >
                    <i class="cor-red" v-if="item.required === 'required'">*</i>
                    <div class="one-omit" :title="item.name">
                      <el-tooltip v-if="item.annotationTop || item.annotationBottom" effect="light" placement="top">
                        <template #content>
                          <div>{{ item.annotationTop }}<br/>{{ item.annotationBottom }}</div>
                        </template>
                        <span style="cursor:pointer;">{{item.name}}</span>
                      </el-tooltip>
                      <template v-else>
                        {{item.name}}
                      </template>
                    </div>
                  </div>
                  <span class="table-mouse"
                    @mousedown="addMousedown($event, item.title + '_' + item.type)"
                  ></span>
                </table-header-col>
              </template>
            </template>
          </template>
        </template>
      </div>
      <!-- <scrollBar style="padding-bottom: 20px;"
                :style="{width: tableWidth+'px'}"
                :scrollHStyle="'transform: translateX(-' + Math.abs(parseInt(tableWidth - tableCellWidth - topDistance)) + 'px)'"> -->
          <!-- <div
            class="details-table-no-text"
            :style="'width:' + tableWidth + 'px;'"
            v-if="detailsWidgetData.pagination && formdata.length <= 1 && nullFun(formdata)"
          >
            <div>暂无数据</div>
          </div> -->
    <el-scrollbar style="padding-bottom: 20px;"
          :style="{width: tableWidth+'px'}"
    >
            <template v-for="(lists, listsIndex) in formdata ? formdata : []">
              <div
                class="details-table-col fixed-value"
                :key="detailsWidgetData.title + listsIndex"
                v-if="getShowList(listsIndex, lists)"
              >              
                <div
                  class="details-table-row table-col-nowrap"
                  :style="{ transform: 'translate3d(' + topDistance + 'px,0,0)', zIndex: 8}"
                  v-if="isInput&&detailsWidgetData.per==1||!isInput&&!detailsWidgetData.detailsNum&&detailsWidgetData.per==1||modifyId"
                >
                  <div class="details-table-table-row" style="width: 14px;">
                    <el-checkbox v-if="dataModifyLen <= listsIndex" v-model="checkObj[listsIndex]" @change="checkFun(listsIndex)"></el-checkbox>
                  </div>
                </div>
                <div class="details-table-row table-col-nowrap"
                    :style="{ transform: 'translate3d(' + topDistance + 'px,0,0)', zIndex: 8}"
                >
                  <div class="details-table-table-row text-center" style="width: 28px">
                    <i
                      v-if="detailsWidgetData.ocrinfo && detailsWidgetData.ocrinfo.switch && isInput && showScan(lists)"
                      @click="scanOcr(listsIndex)"
                      class="iconfont icon-saoyisao-"
                    ></i>

                    <i
                      class="iconfont icon-a-shanchu2x"
                      v-if="dataModifyLen <= listsIndex && !detailsWidgetData.pagination && ((detailsWidgetData.per && Number(detailsWidgetData.per) !== 2) || modifyId || websiteIsOpen)"
                      @click="delWidget(listsIndex)"
                      style="cursor: pointer;color:#F56C6C;font-size:12px;"
                    ></i>
                    <template v-else>
                      {{ getOperateInd(listsIndex) }}
                    <!-- {{listsIndex + 1}}  -->
                    </template>
                  </div>
                </div>

                <template v-for="(list, index) in detailsWidgetData.list"  :key="listsIndex + '-' + index">
                    <!-- 欧总确认隐藏要存在结构中 -->
                    <table-col v-show="getHide(list) && list.per !== 3"
                              :style="(freezeObj[list.title + '_' + list.type] ? ('transform:translate3d(' + topDistance + 'px,0,0);z-index:8;') : '')">
                      <div class="details-table-table-row details-width widthA"
                        :style="'white-space: inherit;word-break: break-all;' + getDetailsWidth(list, false) + getBackk(list)">
                        <div class="on-show" v-if="list.onShow">
                          <div class="on-show-show"
                              v-show="!onShowObj[listsIndex + (list.title + '_' + list.type)]"
                              @click="setOnShow(listsIndex, list, onShowObj[listsIndex + (list.title + '_' + list.type)])">
                            <i class="iconfont icon-dakaiyanjing" />
                            {{list.placeholder}}
                          </div>
                          <i class="iconfont icon-guanbiyanjing on-show-close"
                            @click="setOnShow(listsIndex, list, onShowObj[listsIndex + (list.title + '_' + list.type)])" />
                        </div>

                        <template v-if="list.type === 'relation-radio'">此控件不在支持，请联系管理员处理</template>
                        <template v-if="list.type === 'text'">
                          <template
                            v-if="Number(list.per) === 2 || getUpcontroll(list) || websiteIsOpen || dataModifyLen > listsIndex"
                          >
                            <span v-if="list.format && list.format.value !== 'routine'" :class="list.isLink ? 'text-link' : ''" @click="list.isLink ? openLinkText(lists[list.title + '_' + list.type], list) : ''" :style="{
                                color: list.format.markedRed &&
                                (list.format.value === 'number'||list.format.value === 'currency') &&
                                lists[list.title + '_' + list.type] < 0 ? 'red': '',
                                justifyContent: list.format.value==='accounting'?'space-between':''
                              }">
                              <!-- 货币符号 -->
                              <template v-if="(list.format.value==='currency'||list.format.value==='accounting') && list.format.currency !== '万元'">
                                {{list.format.currency}}
                              </template>
                              {{ sliceEncrypt(numberFormat(lists[list.title + '_' + list.type],list.format), list.encrypt) }}
                              <!-- 百分比符号、自定义符号 -->
                              <template v-if="list.format.value==='percentage'">%</template>
                              <template v-else-if="list.format.value==='number'">{{list.format.customSymbols}}</template>
                              <template v-else-if="isWYFN(list)">{{list.format.currency}}</template>
                            </span>
                            <span v-else-if="list.isLink" class="text-link" @click="openLinkText(lists[list.title + '_' + list.type], list)">
                              {{sliceEncrypt(lists[list.title + '_' + list.type],list.encrypt)}}
                            </span>
                            <template v-else>
                              {{sliceEncrypt(lists[list.title + '_' + list.type],list.encrypt)}}
                            </template>
                          </template>
                          <template v-else>
                            <div v-if="list.queryOnly && list.dataconfig && list.dataconfig.setUpValue && list.dataconfig.setUpValue === 3" class="on-show" style="pointer-events:none;">
                              <div class="on-show-show on-show-left" style="pointer-events:none;">
                                <i class="iconfont icon-shujuchaxun" />
                                {{list.placeholder}}
                              </div>
                            </div>
                            <el-autocomplete
                              style="width: 100%;"
                              size="large"
                              popper-class="select-text"
                              :class="[
                                classFun(list, lists[list.title + '_' + list.type],lists),
                                'input-details',
                                list.queryOnly && list.dataconfig && list.dataconfig.setUpValue && list.dataconfig.setUpValue === 3 ? 'on-show-pointer' : ''
                              ]"
                              :maxlength="list.sizeLimit && list.sizeLimit > 0 && list.sizeLimit !== 'Infinity' ? list.sizeLimit : undefined"
                              v-model="lists[list.title + '_' + list.type]"
                              @focus="autocompleteTextFun(list, true, listsIndex); conditionLink(list); setAi(list, listsIndex)"
                              @input="autoinputFun($event, list, listsIndex)"
                              @blur="approvalProcess(list, listsIndex); conditionLinkObj = null; setAi(null)"
                              @select="approvalProcess(list, listsIndex)"
                              :fetch-suggestions="querySearchAsync"
                              :placeholder="list.placeholder"
                              :readonly="list.type === 'text' && Number(list.disSearch) === 1"
                            ></el-autocomplete>
                          </template>
                          <div
                            class="details-textarea-right"
                            v-if="list.sizeLimit && list.sizeLimit !== 'Infinity'"
                          >{{lists[list.title + '_' + list.type] ? lists[list.title + '_' + list.type].length : 0}}/{{list.sizeLimit}}</div>
                        </template>
                        <template v-if="list.type === 'textarea'">
                          <template v-if="Number(list.per) === 2 || getUpcontroll(list) || websiteIsOpen || dataModifyLen > listsIndex">
                            <span
                              v-html="lists[list.title + '_' + list.type]"
                              style="white-space: pre-wrap;"
                            ></span>
                          </template>
                          <template v-else>
                            <div v-if="list.queryOnly && list.dataconfig && list.dataconfig.setUpValue && list.dataconfig.setUpValue === 3" class="on-show" style="pointer-events:none;">
                              <div class="on-show-show on-show-left" style="pointer-events:none;">
                                <i class="iconfont icon-shujuchaxun" />
                                {{list.placeholder}}
                              </div>
                            </div>
                            <el-dropdown
                              trigger="click"
                              width="360"
                              style="width:100%;"
                              placement="bottom-start"
                              :class="list.queryOnly && list.dataconfig && list.dataconfig.setUpValue && list.dataconfig.setUpValue === 3 ? 'on-show-pointer' : ''"
                              @command="handleCommand"
                              v-if="list.sels || (list.dataconfig && Number(list.dataconfig.setUpValue) === 1 || Number(list.dataconfig.setUpValue === 3))"
                            >
                            <span>
                              <el-input
                                type="textarea"
                                :class="'input-details ' + classFun(list, lists[list.title + '_' + list.type])"
                                :autosize="{ minRows: 1, maxRows: 6}"
                                :maxlength="list.sizeLimit && list.sizeLimit > 0 && list.sizeLimit !== 'Infinity' ? list.sizeLimit : undefined"
                                @focus="selschange(true, list, listsIndex); conditionLink(list); setAi(list, listsIndex)"
                                @blur="setAi(null)"
                                @change="approvalProcess(list, listsIndex)"
                                v-model="lists[list.title + '_' + list.type]"
                                :placeholder="list.placeholder"
                              ></el-input>
                            </span>
                              <template #dropdown>
                                <el-dropdown-menu style="max-height:80%;overflow-y:auto;" v-if="list.sels!='[]'">
                                  <el-dropdown-item
                                    v-for="(popoverList, popIndex) in JSON.parse(list.sels||'[]')"
                                    :key="popIndex"
                                    v-show="new RegExp(escapeRegex(lists[list.title + '_' + list.type] ? lists[list.title + '_' + list.type] : '')).test(popoverList)"
                                    :command="{item2: list, popoverList: popoverList, scopeIndex: listsIndex}"
                                  >
                                    <div
                                      class="popover-list"
                                      style="max-width: 800px;line-height: 20px;padding-bottom: 10px;"
                                    >{{popoverList}}</div>
                                  </el-dropdown-item>
                                </el-dropdown-menu>
                              </template>
                            </el-dropdown>
                            <el-input
                              type="textarea"
                              v-else
                              class="textarea-table"
                              :class="'input-details ' + classFun(list, lists[list.title + '_' + list.type])"
                              :autosize="{ minRows: 1, maxRows: 6}"
                              :maxlength="list.sizeLimit && list.sizeLimit > 0 && list.sizeLimit !== 'Infinity' ? list.sizeLimit : undefined"
                              @focus="setAi(list, listsIndex)"
                              @blur="setAi(null)"
                              v-model="lists[list.title + '_' + list.type]"
                              :placeholder="list.placeholder"
                              @change="approvalProcess(list, listsIndex)"
                            ></el-input>
                           <!-- :style="{ width: (list.width === '100%' || !list.width ? '180px' : list.width), maxWidth: (list.width === '100%' || !list.width ? '180px' : list.width), minWidth: (list.width === '100%' || !list.width ? '180px' : list.width)}" -->

                            <div
                              class="details-textarea-right"
                              v-if="list.sizeLimit && list.sizeLimit !== 'Infinity'"
                            >{{lists[list.title + '_' + list.type] ? lists[list.title + '_' + list.type].length : 0}}/{{list.sizeLimit}}</div>
                          </template>
                        </template>
                        <template v-if="list.type === 'date'">
                          <template
                            v-if="Number(list.per) === 2 || getUpcontroll(list) || websiteIsOpen || dataModifyLen > listsIndex"
                          >
                            <template v-if="list.match && list.match == 'yyyy-MM'">
                              {{ getTimeYM(lists[list.title + '_' + list.type]) }}
                            </template>
                            <template v-else-if="list.match && list.match === 'yyyy-MM-dd HH:mm' && list.timeList && list.timeList.open">
                              {{getTimeYMD(lists[list.title + '_' + list.type])}}  
                            </template>
                            <template v-else-if="list.match && list.match === 'HH:mm' && list.timeList && list.timeList.open">
                              {{ getTimeHHmm(lists[list.title + '_' + list.type]) }}
                            </template>
                            <template v-else>
                              {{lists[list.title + '_' + list.type]}}
                            </template>
                            <template v-if="lists[list.title + '_' + list.type] && list.match === 'yyyy-MM-dd ww'">
                              &nbsp;&nbsp;
                              星期{{timeWeek(lists[list.title + '_' + list.type])}}
                            </template>
                            <template v-if="list.match && list.match == 'yyyy-MM-dd HH:mm' && list.timeList && list.timeList.open && list.timeList.options.length > 0">
                              &nbsp;&nbsp;
                              {{getTimeLabel(lists[list.title + '_' + list.type], list.timeList.options)}}
                            </template>
                          </template>
                          <div v-else class="time-block">
                            <el-date-picker
                              v-model="lists[list.title + '_' + list.type]"
                              :class="'input-details ' + classFun(list, lists[list.title + '_' + list.type])"
                              type="date"
                              placeholder="选择日期"
                              format="YYYY-MM-DD"
                              :picker-options="pickerOptionsLimit(list)"
                              :default-value="nextMonthFun(list.limit || '')"
                              value-format="YYYY-MM-DD"
                              style="width: 100%;"
                              size="large"
                              v-if="list.match === 'yyyy-MM-dd' || list.match === 'yyyy-MM-dd ww'"
                              @change="approvalProcess(list, listsIndex)"
                            ></el-date-picker>
                            <div v-else-if="list.match && list.match == 'yyyy-MM'" class="time-y-m">
                              <el-date-picker
                                v-model="lists[list.title + '_' + list.type]"
                                type="month"
                                format="YYYY-MM-DD"
                                class="input-details"
                                value-format="YYYY-MM-DD"
                                style="width: 100%;"
                                size="large"
                                :default-value="nextMonthFun(list.limit || '')"
                                @change="approvalProcess(list, listsIndex)"
                                :picker-options="pickerOptionsLimit(list)"
                                placeholder="选择月">
                              </el-date-picker>
                              <div class="time-y-m-text">
                                {{ getTimeYM(lists[list.title + '_' + list.type]) }}
                              </div>
                            </div>
                            <timePicker v-else-if="list.match && list.match == 'yyyy-MM-dd HH:mm' && list.timeList && list.timeList.open && list.timeList.options.length > 0" :config="list" :formdata="lists" @update:formdata="handleFormdataUpdata(list, $event)" :modifyId="modifyId" @change="approvalProcess(list, listsIndex)" />
                            <!--
                            <div v-else-if="list.match && list.match == 'yyyy-MM-dd HH:mm' && list.timeList && list.timeList.open && list.timeList.options.length > 0" class="time-y-m time-md-m">
                            
                              <el-date-picker
                                popper-class="time-zjy-widget-one-layer"
                                v-model="lists[list.title + '_' + list.type]"
                                :class="'input-details ' + classFun(list, lists[list.title + '_' + list.type])"
                                type="date"
                                placeholder="选择日期时间"
                                style="width: 100%;"
                                :picker-options="pickerOptionsLimit(list)"
                                :default-value="nextMonthFun(list.limit || '')"
                                format="YYYY-MM-DD HH:mm"
                                value-format="YYYY-MM-DD HH:mm"
                                @change="(val) => {setTimeDefault(val, list, lists);approvalProcess(list, listsIndex)}"
                              ></el-date-picker>
                              
                              <div class="time-y-m-text">
                                {{ getTimeYMD(lists[list.title + '_' + list.type]) }}
                              </div>
                              <div class="time-md">
                                <el-select v-model="timeWidthObj[list.title + '_' + list.type + '_' + listsIndex]" @change="(val) => getItt(lists, list, val, 1, listsIndex)" placeholder=" ">
                                  <el-option v-for="(itt, ittInd) in list.timeList.options" :key="ittInd + list.title" :value="itt.value" :label="itt.label" />
                                </el-select>
                                <div class="time-md-text">{{getTimeLabel(lists[list.title + '_' + list.type], list.timeList.options, list.timeList.defaultValue) || '请选择'}}</div>
                              </div>
                            </div>
                            -->
                            <div v-else-if="list.match && list.match === 'HH:mm'" class="time-y-m time-md-m time-text-color">
                              <el-time-picker
                                  @change="approvalProcess(list, listsIndex)"
                                  value-format="HH:mm"
                                  format="HH:mm"
                                  style="width: 100%;"
                                  v-model="lists[list.title + '_' + list.type]"
                                  :picker-options="{ format: 'HH:mm' }"
                                  :disabled="list.exhibiIs"
                                  placeholder="任意时间点">
                              </el-time-picker>
                              <div class="time-y-m-text">
                                {{ getTimeHHmm(lists[list.title + '_' + list.type]) }}
                              </div>
                            </div>
                            <el-date-picker
                              v-model="lists[list.title + '_' + list.type]"
                              :class="'input-details ' + classFun(list, lists[list.title + '_' + list.type])"
                              :picker-options="pickerOptionsLimit(list)"
                              type="datetime"
                              placeholder="选择日期时间"
                              style="width: 100%;"
                              size="large"
                              :default-value="nextMonthFun(list.limit || '')"
                              format="YYYY-MM-DD HH:mm:ss"
                              value-format="YYYY-MM-DD HH:mm:ss"
                              @change="approvalProcess(list, listsIndex)"
                              v-else-if="list.match && list.match == 'yyyy-MM-dd HH:mm:ss'"
                            ></el-date-picker>
                            <el-date-picker
                              v-model="lists[list.title + '_' + list.type]"
                              :class="'input-details ' + classFun(list, lists[list.title + '_' + list.type])"
                              :picker-options="pickerOptionsLimit(list)"
                              type="datetime"
                              placeholder="选择日期时间"
                              style="width: 100%;"
                              size="large"
                              :default-value="nextMonthFun(list.limit || '')"
                              format="YYYY-MM-DD HH:mm"
                              value-format="YYYY-MM-DD HH:mm"
                              @change="approvalProcess(list, listsIndex)"
                              v-else
                            ></el-date-picker>
                            <div v-if="lists[list.title + '_' + list.type] && list.match === 'yyyy-MM-dd ww'" class="time-week">星期{{timeWeek(lists[list.title + '_' + list.type])}}</div>
                          </div>
                        </template>
                        <template v-if="list.type === 'number'">
                          <template
                            v-if="Number(list.per) === 2 || getUpcontroll(list) || websiteIsOpen || dataModifyLen > listsIndex"
                          >
                            <!-- 用来数据联动、计算 -->
                            <el-input-number 
                              style="display: none;"
                              size="large"
                              @change="approvalProcess(list, listsIndex)"
                              @input="approvalProcess(list,listsIndex); arithmetic(list,listsIndex)"
                              v-model="lists[list.title + '_' + list.type]" 
                            ></el-input-number>
                            <div
                              class="right-block-number"
                              v-if="list.format && list.format.value !== 'routine'"
                              :style="{
                                color: list.format.markedRed &&
                                (list.format.value === 'number'||list.format.value === 'currency') &&
                                lists[list.title + '_' + list.type] < 0 ? 'red': '',
                                justifyContent: list.format.value==='accounting'?'space-between':''
                              }">
                              <span>
                                <!-- 货币符号 -->
                                <template v-if="(list.format.value==='currency'||list.format.value==='accounting') && list.format.currency !== '万元'">
                                  {{list.format.currency}}
                                </template>
                              </span>
                              <span>
                                {{numberFormat(lists[list.title + '_' + list.type],list.format)}}
                                <!-- 百分比符号、自定义符号 -->
                                <template v-if="list.format.value==='percentage'">%</template>
                                <template v-else-if="list.format.value==='number'">{{list.format.customSymbols}}</template>
                                <template v-else-if="isWYFN(list)">{{list.format.currency}}</template>
                              </span>
                            </div>
                            <div v-else>
                              {{lists[list.title + '_' + list.type]}}
                            </div>
                          </template>
                          <template v-else-if="isWYFN(list, true, listsIndex)">
                            <el-input-number
                              v-model="tempFormdata[listsIndex][list.title + '_' + list.type]"
                              :class="'input-details ' + classFun(list, lists[list.title + '_' + list.type])"
                              :controls="true"
                              controls-position="right"
                              :step="list.step"
                              label="描述文字"
                              style="width:80%"
                              size="large"
                              :placeholder="list.placeholder||'请输入'"
                              @keyup="numDecimal($event,list.format.value!=='routine'?list.format.decimal + 4:null)"
                              @change="approvalProcess(list, listsIndex);setOriginalData(list, listsIndex)"
                              @input="approvalProcess(list,listsIndex); arithmetic(list,listsIndex)"
                              @blur="arithmetic(list,listsIndex)"
                            ></el-input-number>
                            万元
                          </template>
                          <el-input-number
                            v-else
                            v-model="lists[list.title + '_' + list.type]"
                            :class="'input-details ' + classFun(list, lists[list.title + '_' + list.type])"
                            :controls="true"
                            controls-position="right"
                            :step="list.step"
                            label="描述文字"
                            style="width:100%"
                            size="large"
                            :placeholder="list.placeholder||'请输入'"
                            @keyup="numDecimal($event,list.format.value!=='routine'?list.format.decimal:null)"
                            @change="approvalProcess(list, listsIndex)"
                            @input="approvalProcess(list,listsIndex); arithmetic(list,listsIndex)"
                            @blur="arithmetic(list,listsIndex)"
                          ></el-input-number>
                        </template>
                        <template v-if="list.type === 'radio'">
                          <span v-if="Number(list.per) === 2 || getUpcontroll(list) || websiteIsOpen || dataModifyLen > listsIndex"
                            :class="['list-block', list.selsItemColor && list.selsItemColor[lists[list.title + '_' + list.type]] ? 'list-block-active' : '', list.types && Number(list.types) === 6 ? 'no-back' : '']"
                            :style="lists[list.title + '_' + list.type] && list.selsItemColor && list.selsItemColor[lists[list.title + '_' + list.type]] ?  {backgroundColor: lists[list.title + '_' + list.type] ? (list.selsItemColor ? list.selsItemColor[lists[list.title + '_' + list.type]]:'#4e86ff') : '',color:'#fff'} : ''"
                          >
                            <template v-if="list.types && Number(list.types) === 5">
                              {{ getRadioProvinces(lists[list.title + '_' + list.type], list) }}
                            </template>
                            <radioXing v-else-if="list.types && Number(list.types) === 6" :sels="objSels(list.sels ? list.sels : [], list)" :value="lists[list.title + '_' + list.type]" :edit="false" @upXing="val => upXing(val, list, listsIndex)" />
                            <template v-else>
                              {{lists[list.title + '_' + list.type] === 'others其他' && list.others ? othersObj[detailsWidgetData.title + '_' + detailsWidgetData.type][listsIndex][list.title + '_' + list.type] : getRadioLabel(lists[list.title + '_' + list.type], objSels(list.sels ? list.sels : [], list))}}  
                            </template>
                          </span>
                          <template v-else>
                            <div v-if="list.queryOnly && list.dataconfig && list.dataconfig.setUpValue && list.dataconfig.setUpValue === 1" class="on-show" style="pointer-events:none;">
                              <div class="on-show-show on-show-left" style="pointer-events:none;">
                                <i class="iconfont icon-shujuchaxun" />
                                {{list.placeholder}}
                              </div>
                            </div>
                            <el-radio-group v-model="lists[list.title + '_' + list.type]"
                                    @change="approvalProcess(list, listsIndex)"
                                    v-if="list.types && Number(list.types) === 1">
                              <template v-for="sels in objSels(list.sels ? list.sels : [], list)">
                                <el-radio v-if="!list.isHideObj || !list.isHideObj[sels.value || sels]" :label="sels.value || sels" :key="sels.value">
                                  <span
                                    class="radiovalue"
                                    v-if="list.selsItemColor"
                                    :style="{backgroundColor:list.selsItemColor[sels.value || sels],color:list.selsItemColor[sels.value || sels]?'#fff':''}"
                                  >{{sels.label || sels}}</span>
                                  <template v-else>
                                    {{ sels.label || sels }}
                                  </template>
                                </el-radio>
                              </template>
                              <el-radio label="others其他" v-if="list.others">其他</el-radio>
                            </el-radio-group>
                            <div v-else-if="list.types && Number(list.types) === 2" class="radio-list">
                              <template v-for="(its, indexIts) in objSels(list.sels ? list.sels : [], list)">
                                <div v-if="!list.isHideObj || !list.isHideObj[its.value || its]"
                                    :key="indexIts + (its.value || its)"
                                    class="radio-list-imgs"
                                    :style="getButtonBlock(its.value || its, list, '', listsIndex)"
                                    @click="setRadio({val: its.value || its, item: list, index: listsIndex})">
                                  <el-image v-if="list.selsItemImg && list.selsItemImg[its.value || its]"
                                            class="radio-list-img"
                                            :src="$imgurl + list.selsItemImg[its.value || its] + '?accesstoken=' + token"></el-image>
                                  <div v-else class="radio-list-img">
                                    <i class="el-icon-picture-outline no-icon"></i>
                                  </div>
                                  <div class="radio-list-text ellipsis" :style="getButtonStyle(its.value || its, list, '', listsIndex)">{{its.label || its}}</div>
                                </div>
                              </template>
                            </div>
                            <div v-else-if="list.types && Number(list.types) === 3" class="radio-list" style="margin-bottom:-10px;">
                              <template v-for="(its, indexIts) in objSels(list.sels ? list.sels : [], list)">
                                <div v-if="!list.isHideObj || !list.isHideObj[its.value || its]"
                                  :key="indexIts + (its.value || its)"
                                  @click="setCheck({val: its.value || its, item: list, index: listsIndex})"
                                  :style="getRadioStyle(its, list, listsIndex)"
                                  class="radio-list-button">
                                  {{its.label || its}}
                                </div>
                              </template>
                            </div>
                            <div class="radio-switch" v-else-if="list.types && Number(list.types) === 4">
                              <template v-if="list.switchStyle && list.switchStyle === 3">
                                <el-checkbox v-model="lists[list.title + '_' + list.type]"
                                            :true-label="getSwitchColor({ele: list, type: 'active',isGet: true})"
                                            :false-label="getSwitchColor({ele: list, type: 'inactive',isGet: true})"
                                            @change="approvalProcess(list, lists[list.title + '_' + list.type], formdata)" />
                              </template>
                              <el-switch v-else
                                :active-value="getSwitchColor({ele: list, type: 'active',isGet: true})"
                                :inactive-value="getSwitchColor({ele: list, type: 'inactive',isGet: true})"
                                :active-color="getSwitchColor({ele: list, type: 'active'})"
                                :inactive-color="getSwitchColor({ele: list, type: 'inactive'})"
                                :inactive-text="list.switchStyle === 1 ? '' : getSwitchColor({ele: list, type: 'inactive', isGet: true})"
                                :active-text="list.switchStyle === 1 ? '' : getSwitchColor({ele: list, type: 'active', isGet: true})"
                                v-model="lists[list.title + '_' + list.type]"
                                @change="approvalProcess(list, lists[list.title + '_' + list.type], formdata)"
                              />
                            </div>
                            <multilevel v-else-if="list.types && Number(list.types) === 5" :config="list.multilevelConfig" :formdata="lists[list.title + '_' + list.type]" @update:formdata="handleFormdataUpdata(list, $event)" @change="approvalProcess(list, listsIndex)" :placeholder="list.placeholder" />
                            <radioXing v-else-if="list.types && Number(list.types) === 6" :sels="objSels(list.sels ? list.sels : [], list)" :value="lists[list.title + '_' + list.type]" :edit="true" @upXing="val => upXing(val, list, listsIndex)" />
                            <el-select
                              v-else
                              v-model="lists[list.title + '_' + list.type]"
                              :class="[
                                'input-select select-details ',
                                classFun(list, lists[list.title + '_' + list.type]),
                                list.queryOnly && list.dataconfig && list.dataconfig.setUpValue && list.dataconfig.setUpValue === 1 ? 'on-show-pointer' : ''
                              ]"
                              :placeholder="list.placeholder"
                              style="width: 100%;"
                              size="large"
                              filterable
                              color="#f00"
                              @focus="conditionLink(list)"
                              @change="approvalProcess(list, listsIndex)"
                              @visible-change="radioBlurChange(list.title + '_' + list.type+'_'+listsIndex, $event, list, listsIndex)"
                            >
                              <template #prefix>
                                <div style="display:none;min-height:28px;margin-top:1px;background:#ffffff;height:calc(100% - 2px);" v-if="lists[list.title + '_' + list.type]!=='others其他'&&!radioBlur[list.title + '_' + list.type+'_'+listsIndex] && list.types !== 2 && lists[list.title + '_' + list.type]">
                                  <span class="ridiotagstyle ellipsis ellipsis3" :style="{'backgroundColor':list.selsItemColor&&list.selsItemColor[lists[list.title + '_' + list.type]],'color':list.selsItemColor&&list.selsItemColor[lists[list.title + '_' + list.type]]?'#fff':'#333'}">
                                    {{getRadioLabel(lists[list.title + '_' + list.type], objSels(list.sels ? list.sels : [], list))}}
                                  </span>
                                </div>
                              </template>
                              <template v-for="sels in objSels(list.sels ? list.sels : [], list)">
                                <el-option
                                  v-if="!list.isHideObj || !list.isHideObj[sels.value || sels]"
                                  :key="sels.value || sels"
                                  :label="sels.label || sels"
                                  :value="sels.value || sels"
                                >
                                  <div v-if="list.types === 2" class="radio-img">
                                    <el-image  v-if="list.selsItemImg && getImgRadio(list, sels.value || sels)"
                                              :src="getImgRadio(list, sels.value || sels)"
                                              :preview-src-list="[getImgRadio(list, sels.value || sels)]"
                                              fit="scale-down"
                                              @click.stop
                                              class="radio-imgs">
                                      <template #error>
                                        <div class="image-slot">
                                          <i class="el-icon-picture-outline"></i>
                                        </div>
                                      </template>
                                    </el-image>
                                    <span :style="getRadioTypes(list, sels.value || sels)">{{sels.label || sels}}</span>
                                  </div>
                                  <span
                                    v-else-if="list.selsItemColor"
                                    :style="getRadioTypes(list, sels.value || sels)"
                                  >{{sels.label || sels}}</span>
                                </el-option>  
                              </template>
                              <el-option key="其他" label="其他" value="others其他" v-if="list.others">
                                <span :style="{padding:'4px 8px',borderRadius:'10px'}">其他</span>
                              </el-option>
                            </el-select>
                            <template
                              v-if="list.others && lists[list.title + '_' + list.type] === 'others其他'"
                            >
                              <br />
                              <input
                                type="text"
                                v-model="othersObj[detailsWidgetData.title + '_' + detailsWidgetData.type][listsIndex][list.title + '_' + list.type]"
                                :class="'select-details ' + classFun(list, lists[list.title + '_' + list.type], othersObj[detailsWidgetData.title + '_' + detailsWidgetData.type][listsIndex][list.title + '_' + list.type])"
                                placeholder="请输入内容"
                                class="other-class"
                              />
                            </template>
                          </template>
                        </template>
                        <template v-if="list.type === 'checkbox'">
                          <template v-if="Number(list.per) === 2 || getUpcontroll(list) || websiteIsOpen || dataModifyLen > listsIndex">
                            <!-- color:list.selsItemColor&&list.selsItemColor[checkList]?'#fff':'#333' -->
                            <span
                              :class="['list-block', list.selsItemColor && list.selsItemColor[checkList] ? 'list-block-active' : '']"
                              v-for="checkList in lists[list.title + '_' + list.type]||[]"
                              :key="checkList"
                              :style="{backgroundColor:list.selsItemColor?list.selsItemColor[checkList]:'#4e86ff',color:'#fff'}"
                            >{{checkList}}</span>
                          </template>
                          <template v-else>
                            <el-checkbox-group v-model="lists[list.title + '_' + list.type]"
                              @change="approvalProcess(list, listsIndex)"
                              v-if="list.types && list.types === 1">
                              <template v-for="sels in objSels(list.sels ? list.sels : [], list)">
                                  <el-checkbox v-if="!list.isHideObj || !list.isHideObj[sels.value || sels]" :label="sels" :key="sels.value || sels">
                                    <span class="checkboxvalue"
                                      v-if="list.selsItemColor"
                                      :style="{backgroundColor:list.selsItemColor[sels],color:list.selsItemColor[sels]?'#fff':''}"
                                    >{{sels}}</span>
                                  </el-checkbox>
                              </template>
                            </el-checkbox-group>
                            <div v-else-if="list.types && list.types === 2" class="radio-list">
                              <template v-for="(its, indexIts) in objSels(list.sels ? list.sels : [], list)">
                                <div v-if="!list.isHideObj || !list.isHideObj[its.value || its]"
                                    :key="indexIts + (its.value || its)"
                                    class="radio-list-imgs"
                                    :style="getButtonBlock(its.value || its, list, true, listsIndex)"
                                    @click="setCheck({val: its.value || its, item: list, index: listsIndex})">
                                  <el-image v-if="list.selsItemImg && list.selsItemImg[its.value || its]"
                                            class="radio-list-img"
                                            :src="$imgurl + list.selsItemImg[its.value || its] + '?accesstoken=' + token"></el-image>
                                  <div v-else class="radio-list-img">
                                    <i class="el-icon-picture-outline no-icon"></i>
                                  </div>
                                  <div class="radio-list-text ellipsis" :style="getButtonStyle(its.value || its, list, true, listsIndex)">{{its.label || its}}</div>
                                </div>
                              </template>
                            </div>
                            <div v-else-if="list.types && list.types === 3" class="radio-list" style="margin-bottom:-10px;">
                              <template v-for="(its, indexIts) in objSels(list.sels ? list.sels : [], list)">
                                <div v-if="!list.isHideObj || !list.isHideObj[its.value || its]"
                                  :key="indexIts + (its.value || its)"
                                  @click="setCheck({val: its.value || its, item: list, index: listsIndex})"
                                  :style="getRadioStyle(its.value || its, list, listsIndex)"
                                  class="radio-list-button">
                                  {{its.label || its}}
                                </div>
                              </template>
                            </div>
                            <el-select
                              v-model="lists[list.title + '_' + list.type]"
                              v-else
                              filterable
                              :class="'select-details check-inp check-inpC ' + classFun(list, lists[list.title + '_' + list.type])"
                              @focus="conditionLink(list)"
                              @change="approvalProcess(list, listsIndex)"
                              multiple
                              :placeholder="list.placeholder"
                              style="width: 100%"
                              size="large"
                              @visible-change="selschange($event, list, listsIndex)"
                            >
                            <!-- :style="{ width: (list.width === '100%' || !list.width ? '180px' : list.width), maxWidth: (list.width === '100%' || !list.width ? '180px' : list.width), minWidth: (list.width === '100%' || !list.width ? '180px' : list.width)}" -->
                              <template #prefix>
                                <span style="line-height:normal;display:contents;">
                                  <template v-if="lists[list.title + '_' + list.type] && lists[list.title + '_' + list.type].length > 0">
                                    <template v-for="sels in lists[list.title + '_' + list.type]" :key="sels.label">
                                      <span class="demo-tag-details" :style="{'backgroundColor':list.selsItemColor ? list.selsItemColor[sels] : ''}">{{sels}}</span>
                                    </template>
                                  </template>
                                  <!-- 如果没有数据则显示 placeholder -->
                                  <template v-else>
                                    <span style="padding-left: 5px;">{{list.placeholder}}</span>
                                  </template>
                                </span>
                              </template>
                              <template v-for="sels in objSels(list.sels ? list.sels : [], list)">
                                <el-option
                                  v-if="!list.isHideObj || !list.isHideObj[sels.value || sels]"
                                  :key="list.title + sels"
                                  :label="sels"
                                  :value="sels"
                                >
                                  <span
                                    v-if="list.selsItemColor"
                                    :style="{backgroundColor:list.selsItemColor[sels],color:list.selsItemColor[sels]?'#fff':'',padding:'4px 8px',borderRadius:'10px'}"
                                  >{{sels}}</span>
                                </el-option>
                              </template>
                            </el-select>
                          </template>
                        </template>
                        <template v-if="list.type === 'image'">
                          <div
                            class="img-flex"
                            v-if="Number(list.per) === 2 || getUpcontroll(list) || websiteIsOpen || dataModifyLen > listsIndex"
                          >
                            <!--                    <el-scrollbar style="width: 100%;" class="el-menu-scrollbar__wrap">-->
                            <!-- <a target="_blank" @click="returnImage(lists[list.title + '_' + list.type], imgListIndex)"
                                v-for="(imgList, imgListIndex) in lists[list.title + '_' + list.type] || []"
                                class="table-img-list"
                                :key="imgList.url">
                                <img class="list-img" :src="imgList.url">
                            </a>-->

                            <div
                              v-for="imgList in lists[list.title + '_' + list.type] || []"
                              class="table-img-list"
                              :key="imgList.url"
                            >
                              <el-image
                                class="list-img"
                                :src="imgList.url || imgUrlHandle(imgList.response)"
                                :z-index="99999"
                                :append-to-body="true"
                                :preview-src-list="[imgUrlHandle(imgList.response)] || (lists[list.title + '_' + list.type] || []).map(val=>{return val.url})"
                              ></el-image>
                            </div>

                            <!--                    </el-scrollbar>-->
                          </div>

                          <el-form-item
                            @click="listCli(listsIndex, index)"
                            v-else
                            @mousemove="listCliRemo(listsIndex, index)"
                            style="margin-bottom: 0px;"
                          >
                            <div v-if="list.signature === true" class="signa-box">
                              <el-button class="signabtn"  @click="showSigna(list,listsIndex)">点击签名</el-button>
                              <div class="signaPic" v-for="list1 in lists[list.title + '_' + list.type]" :key="list1.url">
                                <el-image
                                  fit="cover"
                                  :src="list1.url || ($url + list1.response + '?accesstoken=' + token)"></el-image>
                                  <a class="btn-delete" title="删除签名" @click="deleteSign(list1,list,listsIndex)"></a>
                              </div>
                            </div>
                            <el-upload
                              v-else
                              :action="$url+'/userfile/upload?accesstoken='+token"
                              ref="upload"
                              :disabled="!upDataFile"
                              :file-list="lists[list.title + '_' + list.type]"
                              :class="'img-file-class ' + classFun(list, lists[list.title + '_' + list.type])"
                              class="file-img-up"
                              :on-progress="handleProgress"
                              list-type="picture-card"
                              :on-preview="handlePreview"
                              :on-success="handleSuccess"
                              :on-error="handleError"
                              :on-remove="handleRemove"
                              :limit="Number(list.upNumber)"
                              :on-exceed="(file, fileList)=>{return handleExceed(file, fileList, list)}"
                              :before-upload="beforeImgUpload"
                              :multiple="true"
                            >
                              <template #trigger>
                                <div
                                  class="el-upload__text"
                                  style="background: none;border:none;"
                                >
                                  <i
                                    class="WSiconfont WSicon-fwbcharutupian"
                                    style="color:#4284BA;font-size: 14px"
                                  ></i>
                                  {{list.placeholder == '' ? '选择上传图片' : list.placeholder}}
                                </div>
                              </template>
                            </el-upload>
                          </el-form-item>
                        </template>
                        <template v-if="list.type === 'file'">
                          <template v-if="Number(list.per) === 2 || getUpcontroll(list) || websiteIsOpen || dataModifyLen > listsIndex">
                            <div
                              class="a-list-download"
                              v-for="(fileList, fileListIndex) in lists[list.title + '_' + list.type] || []"
                              :key="fileListIndex"
                            >
                              <div class="ellipsis">
                                <a
                                  class="a-list"
                                  href="javascript:volid(0);"
                                  @click="file_pvw(fileList)"
                                  :title="fileList.realname ? fileList.realname : fileList.name"
                                >{{fileList.realname ? fileList.realname : fileList.name}}</a>
                              </div>
                              <div
                                :style="(fileList.url.indexOf('.pdf') > 0 || fileList.url.indexOf('.PDF') > 0) && list.signet ? 'min-width:80px' : 'min-width:30px'"
                                style="text-align:right"
                              >
                                <template
                                  v-if="(fileList.url.indexOf('.pdf') > 0 || fileList.url.indexOf('.PDF') > 0) && list.signet"
                                >
                                  <span
                                    v-if="fileList.signet&&fileList.signet.isArchived"
                                    @click="ondocfileconf({key: fileListIndex, item: list, details:{index: listsIndex, type: detailsWidgetData.type, title: detailsWidgetData.title}})"
                                  >已归档</span>
                                  <span v-else-if="fileList.signet&&fileList.signet.isRejectSign">已作废</span>
                                  <el-dropdown @command="handleSignet" v-else>
                                    <span class="el-dropdown-link">
                                      签章
                                      <i class="el-icon-arrow-down el-icon--right"></i>
                                    </span>
                                    <template #dropdown>
                                      <el-dropdown-menu>
                                        <el-dropdown-item
                                          :command="{key: fileListIndex, item: list, command:'a', details:{index: listsIndex, type: detailsWidgetData.type, title: detailsWidgetData.title}}"
                                        >签章</el-dropdown-item>
                                        <el-dropdown-item
                                          :command="{key: fileListIndex, item: list, command:'b', details:{index: listsIndex, type: detailsWidgetData.type, title: detailsWidgetData.title}}"
                                          v-if="fileList.signet"
                                        >作废</el-dropdown-item>
                                      </el-dropdown-menu>
                                    </template>
                                  </el-dropdown>
                                </template>
                                <a class="a-list-download-span" @click="handleFileDown(fileList)">下载</a>
                                <a class="a-list-download-span" v-if="list.isFileEdit" @click="handleFileDown(fileList, true)">编辑</a>
                                <i v-if="list.fileDocument && (list.fileDocument === 'music' || list.fileDocument === 'video')"
                                 @click="playFun(fileList, list.fileDocument)"
                                  :style="{color: themeConfig.headColor}" class="iconfont icon-bofang play" />
                              </div>
                            </div>
                            <div
                              style="text-align:center"
                              v-if="list.signet&&lists[list.title + '_' + list.type].length>0"
                            >
                              <el-dropdown @command="handleListSignet">
                                <el-button size="small" type="primary" style="width:170px">
                                  批量操作
                                  <i class="el-icon-caret-bottom el-icon--right"></i>
                                </el-button>
                                <template #dropdown>
                                  <el-dropdown-menu>
                                    <el-dropdown-item
                                      :command="{item: list, command:'a', details:{index: listsIndex, type: detailsWidgetData.type, title: detailsWidgetData.title}}"
                                      v-if="list.signet && list.signetWay"
                                    >签章</el-dropdown-item>
                                    <el-dropdown-item
                                      :command="{item: list, command:'b', details:{index: listsIndex, type: detailsWidgetData.type, title: detailsWidgetData.title}}"
                                    >文档签署完毕，归档</el-dropdown-item>
                                  </el-dropdown-menu>
                                </template>
                              </el-dropdown>
                            </div>
                            <span v-if="(lists[list.title + '_' + list.type] || []).length > 1" class="file-label-down" @click.stop="fileDown(list, listsIndex)">
                              <i class="iconfont icon-xiazai" />
                              打包下载
                            </span>
                          </template>
                          <el-form-item
                            @click="listCli(listsIndex, index, list, lists[list.title + '_' + list.type])"
                            v-else
                            @mousemove="listCliRemo(listsIndex, index)"
                            style="margin-bottom: 0px;"
                          >
                            <el-upload
                              :action="$url+'/userfile/upload?accesstoken='+token"
                              ref="upload"
                              style="width: 100%"
                              :disabled="!upDataFile"
                              :file-list="lists[list.title + '_' + list.type]"
                              :class="'img-file-class file-class ' + classFun(list, lists[list.title + '_' + list.type])"
                              :on-progress="handleProgress"
                              list-type="text"
                              :limit="list.upNumber"
                              :on-preview="handlePreview"
                              :on-success="handleSuccess"
                              :on-error="handleError"
                              :on-remove="handleRemove"
                              :before-upload="(val) => beforeFileUpload(val, list)"
                              :multiple="true">
                              <!-- v-if="!list.upNumber || list.upNumber > (lists[list.title + '_' + list.type] || []).length" -->
                              <div class="el-upload__text">
                                <el-icon><Link /></el-icon>
                                {{list.placeholder == '' ? '选择添加附件' : list.placeholder}}
                              </div>
                            </el-upload>
                            <!-- 列表展示 -->
  <!-- 这个和 element 上传组件重复了，不知道干嘛用的
                          <ul class="show_imglist">
                            <li
                              v-for="(item1,index1) in lists[list.title + '_' + list.type]"
                              :key="item1.uid"
                            >
                                <i class="el-icon-document" style="color:#999;"></i>
                                <a :title="item1.name" @click="file_pvw({ url: item1.response })">{{item1.name}}</a>
                                <span class="icon_to">
                                  <i
                                    class="el-icon-upload-success el-icon-circle-check"
                                    style="color:#4e86ff;"
                                  ></i>
                                  <i
                                    class="el-icon-close"
                                    @click="deleteImg(lists[list.title + '_' + list.type],index1)"
                                  ></i>
                                </span>
                            </li>
                          </ul>
  -->
                          </el-form-item>
                        </template>
                        <template v-if="list.type === 'relation-user'">
                          <template v-if="Number(list.per) === 2 || getUpcontroll(list) || websiteIsOpen || dataModifyLen > listsIndex">
                            <span
                              class="relationUserStyle"
                              v-for="relU in lists[list.title + '_' + list.type] || []"
                              :key="relU.organizationId"
                            >
                              <relationUserInfo v-if="list.isMoreInfo" :moreInfo="list.moreInfoArr" :checkedInfo="list.checkKey" :info="relU" :isNewInfo="list.isNewData" />
                              <template v-else>{{ relU.realname }}</template>
                            </span>
                          </template>
                          <!-- 快速录入 -->
                          <div v-else-if="list.isEnterChoice" style="position: relative">
                            <user-drop-down
                              :data="list"
                              :formdata="lists[list.title + '_' + list.type]"
                              :placeholder="list.placeholder==''?'输入添加联系人':list.placeholder"
                              :isDetaild="true"
                              :itemInfo="list"
                              @userCheck="param=>{userCheckCallback(list,listsIndex,lists[list.title + '_' + list.type],param)}"
                              @closeFlow="(index)=>{handleCloseFlow(list,index,listsIndex)}"
                            >
                            </user-drop-down>
                          </div>
                          <div :class="list.dataShow ? 'relation-user-wrap relation-default bbb' : 'relation-user-wrap'" :ref="'relationUserRef_' + list.title" v-else>
                            <p
                              style="cursor: pointer;"
                              class="relation-user"                            
                              :class="classFun(list, lists[list.title + '_' + list.type]) + ' el-upload__text'"
                              @click="relationUserChoice(list, listsIndex, lists[list.title + '_' + list.type])"
                            >
                              <!-- <template
                                v-if="!lists[list.title + '_' + list.type] || lists[list.title + '_' + list.type] && lists[list.title + '_' + list.type].length === 0"
                              >{{list.placeholder == '' ? '选择添加联系人' : list.placeholder}}</template> -->
                              <template v-for="(relU,index2) in lists[list.title + '_' + list.type]">
                                <el-tag
                                  type="info"
                                  closable
                                  :key="relU.organizationId"
                                  :disable-transitions="false"
                                  @click="editUser(relU, list, $event)"
                                  @close="handleCloseFlow(list, index2, listsIndex)"
                                  v-if="(lists[list.title + '_' + list.type] && index2==0) || isExpand(listsIndex)"
                                >{{relU.realname}}</el-tag>
                              </template>
                              <span
                                class="relationUserStyle"
                                v-if="lists[list.title + '_' + list.type] && lists[list.title + '_' + list.type].length > 1 && !isExpand(listsIndex)"
                              >等{{lists[list.title + '_' + list.type].length}}人</span>
                              <span 
                                v-if="(lists[list.title + '_' + list.type] && lists[list.title + '_' + list.type].length > 1) && !isExpand(listsIndex)" 
                                style="color: #4E86FF; font-size: 12px;"
                                @click.stop="expandUser(listsIndex, true)">展开 <i class="iconfont icon-shuangjiantouyou" style="font-size: 12px;" /></span>
                              <span 
                                v-if="(lists[list.title + '_' + list.type] && lists[list.title + '_' + list.type].length > 1) && isExpand(listsIndex)" 
                                style="color: #4E86FF; font-size: 12px;"
                                @click.stop="expandUser(listsIndex, false)">收起 <i class="iconfont icon-shuangjiantouzuo" style="font-size: 12px;" /></span>
                                <el-input
                                  v-if="lists[list.title + '_' + list.type] && lists[list.title + '_' + list.type].length < 2"
                                  style="width: 100px;"
                                  :autofocus="false"
                                  ref="input"
                                  v-model="linkedWd[list.title + '_' + list.type + '_' + listsIndex]"
                                  readonly
                                >
                                </el-input>
                            </p>
                            <div class="fast-btn">
                              <a href="javascript:;" title="组织查找" @click="relationUserChoice(list, listsIndex, lists[list.title + '_' + list.type],'orgBtn')"><i class="iconfont icon-zuzhijigou"></i></a>
                              <a v-if="list.singleIsUser !== 0" href="javascript:;" title="批量查找" @click="showBatchSearch(list, listsIndex)"><i class="iconfont icon-kuaisuchazhao"></i></a>
                            </div>   
                            <!-- 下拉框 -->
                              <linked-drop-down
                                v-if="list.dataShow"
                                :ref="'linkedDropDownRef_' + list.title"
                                :formdata="lists[list.title + '_' + list.type]"
                                :isDetaild="true"
                                :itemInfo="list"
                                @userCheck="param=>{userCheckCallback(list,listsIndex,lists[list.title + '_' + list.type],param)}"
                                @closeFlow="(index)=>{handleCloseFlow(list,index,listsIndex)}"
                              >
                              </linked-drop-down>
                          </div>
                        </template>
                        <template v-if="list.type === 'relation-check'">
                          <div v-if="lists[list.title + '_' + list.type] && typeof lists[list.title + '_' + list.type] === 'object' && lists[list.title + '_' + list.type].data.length > 0" :ref="list.title + '_' + listsIndex" style="display:flex;align-items:center;min-width:30px;">
                            <div v-if="relevancyShowObj[list.title + '_' + list.type + '_' + listsIndex]"
                              class="rel-dialog">
                              <div class="rel-all-dialog"></div>
                              <div class="rel-all-up" :style="{transform: 'translate('+ relevancyAddress.x + 'px,' + relevancyAddress.y +'px)', width: (relevancyAddress.w || '') + 'px'}">
                                  <p class="relation-user"
                                    :class="'relation-radio-class el-upload__text ' + classFun(list, lists[list.title + '_' + list.type])"
                                    @click="relationRadio(list, 2, listsIndex)"
                                    style="cursor: pointer;border:1px solid #DCDCDC;"
                                  >
                                    <span style="color:#4284BA">
                                      <i
                                        class="WSiconfont WSicon-fwbbiaoge"
                                        style="margin-right: 3px;font-size: 14px"
                                      ></i>
                                      {{list.placeholder == '' ? '选择添加关联表单' : list.placeholder}}
                                    </span>
                                  </p>
                                  <span class="rel-all-close" @click="openRelUp(list, listsIndex)">确定</span>
                              </div>
                            </div>

                            <tableRead :config="list" :formdata="lists[list.title + '_' + list.type]" />
                            <div v-if="!(Number(list.per) === 2 || getUpcontroll(list) || websiteIsOpen || dataModifyLen > listsIndex)"
                                @click="openRelUp(list, listsIndex)"
                                class="rel-button-up" style="margin-left:2px;min-width:30px;">修改</div>
                          </div>
                          <template v-else>
                            <template
                              v-if="Number(list.per) === 2 || getUpcontroll(list) || websiteIsOpen || dataModifyLen > listsIndex"
                            >{{lists[list.title + '_' + list.type]}}</template>
                            <p v-else
                              class="relation-user"
                              :class="'relation-radio-class el-upload__text ' + classFun(list, lists[list.title + '_' + list.type])"
                              @click="relationRadio(list, 2, listsIndex)"
                              style="cursor: pointer;border:1px solid #DCDCDC;"
                            >
                              <span v-if="!lists[list.title + '_' + list.type] || lists[list.title + '_' + list.type] && lists[list.title + '_' + list.type].data && lists[list.title + '_' + list.type].data.length === 0" style="color:#4284BA">
                                <i
                                  class="WSiconfont WSicon-fwbbiaoge"
                                  style="margin-right: 3px;font-size: 14px"
                                ></i>
                                {{list.placeholder == '' ? '选择添加关联表单' : list.placeholder}}
                              </span>
                              <template v-else>{{lists[list.title + '_' + list.type]}}</template>
                            </p>
                          </template>
                        </template>
                        <template v-if="list.type === 'new-rel-radio'">
                          <template
                            v-if="Number(list.per) === 2 || getUpcontroll(list) || websiteIsOpen || dataModifyLen > listsIndex"
                          >{{lists[list.title + '_' + list.type]}}</template>
                          <span
                            v-else
                            :class="'button-rel ' + classFun(list, lists[list.title + '_' + list.type])"
                            :ref="list.title + '_' + listsIndex"
                          >
                          <div v-if="relevancyShowObj[list.title + '_' + list.type + '_' + listsIndex]"
                              class="rel-dialog">
                            <div class="rel-all-dialog"></div>
                              <div class="rel-all-up" :style="{transform: 'translate('+ relevancyAddress.x + 'px,' + relevancyAddress.y +'px)'}">
                                <div class="rel-all-up-ate">
                                  <new-rel-radio
                                    :relRadio="list"
                                    :newIndex="detailsIndex"
                                    :isMom="false"
                                    :bindVal="lists"
                                    :detailsType="detailsWidgetData.title + '_' + detailsWidgetData.type"
                                    :scopeIndex="listsIndex"
                                    :userHide="userHide"
                                    :formdata="formdatas"
                                    :approvalId="approvalId"
                                    :AuditList="AuditList"
                                    @onRelCondition="onRelCondition"
                                    @onLinkageNewRel="onLinkageNewRel"
                                  ></new-rel-radio>
                                  <i
                                    class="WSiconfont WSicon-fwbbiaoge icon-rel"
                                    @click="relationRadio(list, 1, {x: listsIndex,y: index})"
                                  ></i>
                                </div>
                                <span class="rel-all-close" @click="openRelUp(list, listsIndex)">确定</span>
                              </div>
                            </div>
                            <span v-if="lists[list.title + '_' + list.type] || lists[list.title + '_' + list.type]"
                              class="rel-button-up"
                              @click="openRelUp(list, listsIndex)">
                              {{ list.placeholder }}
                            </span>
                            <template v-else>
                              <el-popover
                                placement="bottom-start"
                                width="296"
                                @show="openRel(list.title + 'rel')"
                                trigger="click">
                                <div style="height:230px;background-color:#ffffff;">
                                  <new-rel-radio
                                    :id="list.title + 'rel'"
                                    :ref="list.title + 'rel'"
                                    :relRadio="list"
                                    :newIndex="detailsIndex"
                                    :isMom="false"
                                    :bindVal="lists"
                                    :detailsType="detailsWidgetData.title + '_' + detailsWidgetData.type"
                                    :scopeIndex="listsIndex"
                                    :userHide="userHide"
                                    :formdata="formdatas"
                                    :approvalId="approvalId"
                                    :isFocus="true"
                                    :AuditList="AuditList"
                                    @onRelCondition="onRelCondition"
                                    @onLinkageNewRel="onLinkageNewRel"
                                  ></new-rel-radio>
                                  <i
                                    style="top:32px;right:13px;"
                                    class="WSiconfont WSicon-fwbbiaoge icon-rel"
                                    @click="relationRadio(list, 1, {x: listsIndex,y: index})"
                                  ></i>
                                </div>
                                <template #reference>
                                  <div class="rel-select rel-selectB">选择</div>
                                </template>
                              </el-popover>
                              
                              
                            </template>
                          </span>
                        </template>
                      </div>
                    </table-col>
                    <!-- 明细里面只有关联单选会有 list 参数 -->
                    <template v-if="list.list && list.list.length > 0 && list.per !== 3 && getHide(list) && list.type !== 'relation-check' && (list.type !== 'new-rel-radio' || list.type === 'new-rel-radio' && (relShowObj[list.title + '_' + list.type] || !list.isRel) || detailsWidgetData.detailsTableType && detailsWidgetData.detailsTableType === 'flex')">
                      <template v-for="(item, itemIndex) in list.list" :key="listsIndex + '-' + index + '-' + itemIndex">
                        <table-col                          
                          v-if="item.per !== 3 && getHide(item)"
                          :style="freezeObj[item.title + '_' + item.type] ? ('transform:translate3d(' + topDistance + 'px,0,0);z-index:8;') : ''"
                        >
                          <div class="details-table-table-row details-width widthB"
                          :style="getDetailsWidth(item, false, false, list.title)">
                          <!--  :style="'width:' + (!widthObj[item.title + '_' + item.type] ? !item.width ? '180px' : item.width : widthObj[item.title + '_' + item.type])" -->
                            <div class="on-show" v-if="item.onShow">
                              <div class="on-show-show"
                                  v-show="!onShowObj[listsIndex + (item.title + '_' + item.type)]"
                                  @click="setOnShow(listsIndex, item, onShowObj[listsIndex + (item.title + '_' + item.type)])">
                                <i class="iconfont icon-dakaiyanjing" />
                                {{list.placeholder}}
                              </div>
                              <i class="iconfont icon-guanbiyanjing on-show-close"
                                @click="setOnShow(listsIndex, item, onShowObj[listsIndex + (item.title + '_' + item.type)])" />
                            </div>
                            <template v-if="item.type === 'text'">
                              <template
                                v-if="item.per === 2 || getUpcontroll(item)"
                              >
                                <span v-if="item.format && item.format.value !== 'routine'" :class="item.isLink ? 'text-link' : ''" @click="item.isLink ? openLinkText(lists[item.title + '_' + item.type], item) : ''" :style="{
                                    color: item.format.markedRed &&
                                    (item.format.value === 'number'||item.format.value === 'currency') &&
                                    lists[item.title + '_' + item.type] < 0 ? 'red': '',
                                    justifyContent: item.format.value==='accounting'?'space-between':''
                                  }">
                                  <!-- 货币符号 -->
                                  <template v-if="(item.format.value==='currency'||item.format.value==='accounting') && item.format.currency !== '万元'">
                                    {{item.format.currency}}
                                  </template>
                                  {{ sliceEncrypt(numberFormat(lists[item.title + '_' + item.type],item.format), item.encrypt) }}
                                  <!-- 百分比符号、自定义符号 -->
                                  <template v-if="item.format.value==='percentage'">%</template>
                                  <template v-else-if="item.format.value==='number'">{{item.format.customSymbols}}</template>
                                  <template v-else-if="isWYFN(item)">{{item.format.currency}}</template>
                                </span>
                                <span v-else-if="item.isLink" class="text-link" @click="openLinkText(lists[item.title + '_' + item.type], item)">
                                  {{sliceEncrypt(lists[item.title + '_' + item.type],item.encrypt)}}
                                </span>
                                <template v-else>
                                  {{sliceEncrypt(lists[item.title + '_' + item.type],item.encrypt)}}
                                </template>
                              </template>
                              <template v-else>
                                <div v-if="item.queryOnly && item.dataconfig && item.dataconfig.setUpValue && item.dataconfig.setUpValue === 3" class="on-show" style="pointer-events:none;">
                                  <div class="on-show-show on-show-left" style="pointer-events:none;">
                                    <i class="iconfont icon-shujuchaxun" />
                                    {{item.placeholder}}
                                  </div>
                                </div>
                                <el-autocomplete
                                  style="width: 100%;"
                                  size="large"
                                  popper-class="select-text"
                                  :class="[
                                    classFun(item, lists[item.title + '_' + item.type]),
                                    'input-details',
                                    item.queryOnly && item.dataconfig && item.dataconfig.setUpValue && item.dataconfig.setUpValue === 3 ? 'on-show-pointer' : ''
                                  ]"
                                  v-model="lists[item.title + '_' + item.type]"
                                  @focus="autocompleteFun(item); conditionLink(item); setAi(item, listsIndex)"
                                  @input="autoinputFun($event, item, listsIndex)"
                                  @blur="approvalProcess(item, listsIndex,index); conditionLinkObj = null; setAi(null)"
                                  @select="approvalProcess(item, listsIndex,index)"
                                  :fetch-suggestions="querySearchAsync"
                                  :placeholder="item.placeholder"
                                  :readonly="item.type === 'text' && Number(item.disSearch) === 1"
                                ></el-autocomplete>
                              </template>
                            </template>
                            <template v-if="item.type === 'textarea'">
                              <template v-if="item.per === 2 || getUpcontroll(item)">
                                <span
                                  v-html="lists[item.title + '_' + item.type]"
                                  style="white-space: pre-wrap;"
                                ></span>
                              </template>
                              <template v-else>
                                <div v-if="item.queryOnly && item.dataconfig && item.dataconfig.setUpValue && item.dataconfig.setUpValue === 3" class="on-show" style="pointer-events:none;">
                                  <div class="on-show-show on-show-left" style="pointer-events:none;">
                                    <i class="iconfont icon-shujuchaxun" />
                                    {{item.placeholder}}
                                  </div>
                                </div>
                                <el-dropdown
                                  trigger="click"
                                  v-if="item.sels || item.dataconfig && item.dataconfig.linked && item.dataconfig.linked.conditional.length === 0 && item.dataconfig.linked.resultdata.length > 0"
                                  placement="bottom-start"
                                  :class="item.queryOnly && item.dataconfig && item.dataconfig.setUpValue && item.dataconfig.setUpValue === 3 ? 'on-show-pointer' : ''"
                                  @command="handleCommand"
                                  width="360"
                                >
                                  <span>
                                    <el-input
                                      type="textarea"
                                      :class="classFun(item, lists[item.title + '_' + item.type])"
                                      :autosize="{ minRows: 1}"
                                      :maxlength="item.sizeLimit && item.sizeLimit > 0 ? item.sizeLimit : undefined"
                                      @focus="conditionLink(item); setAi(item, listsIndex)"
                                      @blur="setAi(null)"
                                      @change="approvalProcess(item, listsIndex,index)"
                                      v-model="lists[item.title + '_' + item.type]"
                                      :placeholder="item.placeholder"
                                    ></el-input>
                                  </span>
                                  <template #dropdown>
                                    <el-dropdown-menu style="max-height: 80%;overflow-y:auto;">
                                      <el-dropdown-item
                                        v-for="(popoverList, popIndex) in item.sels ? JSON.parse(item.sels) : []"
                                        :key="popIndex"
                                        v-show="new RegExp(escapeRegex(lists[item.title + '_' + item.type] ? lists[item.title + '_' + item.type] : '')).test(popoverList)"
                                        :command="{item2: item, popoverList: popoverList, scopeIndex: listsIndex}"
                                      >
                                        <div
                                          class="popover-list"
                                          style="max-width: 800px;line-height: 20px;padding-bottom: 10px;"
                                        >{{popoverList}}</div>
                                      </el-dropdown-item>
                                    </el-dropdown-menu>
                                  </template>
                                </el-dropdown>
                                <el-input
                                  type="textarea"
                                  v-else
                                  :maxlength="item.sizeLimit && item.sizeLimit > 0 ? item.sizeLimit : undefined"
                                  :class="[
                                    classFun(item, lists[item.title + '_' + item.type]),
                                    item.queryOnly && item.dataconfig && item.dataconfig.setUpValue && item.dataconfig.setUpValue === 3 ? 'on-show-pointer' : ''
                                ]"
                                  @focus="conditionLink(item); setAi(item, listsIndex)"
                                  @blur="setAi(null)"
                                  :autosize="{ minRows:1, maxRows: 100}"
                                  @change="approvalProcess(item, listsIndex,index)"
                                  v-model="lists[item.title + '_' + item.type]"
                                  :placeholder="item.placeholder"
                                ></el-input>
                                <div
                                  class="details-textarea-right"
                                  v-if="item.sizeLimit && item.sizeLimit !== 'Infinity'"
                                >{{lists[item.title + '_' + item.type] ? lists[item.title + '_' + item.type].length : 0}}/{{item.sizeLimit}}</div>
                              </template>
                            </template>
                            <template v-if="item.type === 'date'">
                              <template
                                v-if="item.per === 2 || getUpcontroll(item)"
                              >
                                <template v-if="item.match && item.match == 'yyyy-MM'">
                                  {{ getTimeYM(lists[item.title + '_' + item.type]) }}
                                </template>
                                <template v-else-if="item.match && item.match === 'yyyy-MM-dd HH:mm' && item.timeList && item.timeList.open">
                                  {{getTimeYMD(lists[item.title + '_' + item.type])}}  
                                </template>
                                <template v-else-if="item.match && item.match === 'HH:mm' && item.timeList && item.timeList.open">
                                  {{getTimeHHmm(lists[item.title + '_' + item.type])}}
                                </template>
                                <template v-else>
                                  {{lists[item.title + '_' + item.type]}}
                                </template>
                                <template v-if="lists[item.title + '_' + item.type] && item.match === 'yyyy-MM-dd ww'">
                                  &nbsp;&nbsp;
                                  星期{{timeWeek(lists[item.title + '_' + item.type])}}
                                </template>
                                <template v-if="item.match && item.match == 'yyyy-MM-dd HH:mm' && item.timeList && item.timeList.open && item.timeList.options.length > 0">
                                  &nbsp;&nbsp;
                                  {{getTimeLabel(lists[item.title + '_' + item.type], item.timeList.options)}}
                                </template>
                              </template>
                              <div v-else class="time-block">
                                <el-date-picker
                                  v-model="lists[item.title + '_' + item.type]"
                                  type="date"
                                  placeholder="选择日期"
                                  format="YYYY-MM-DD"
                                  value-format="YYYY-MM-DD"
                                  style="width: 100%;"
                                  size="large"
                                  :class="classFun(item, lists[item.title + '_' + item.type])"
                                  v-if="item.match === 'yyyy-MM-dd' || item.match === 'yyyy-MM-dd ww'"
                                  :default-value="nextMonthFun(item.limit || '')"
                                  :picker-options="pickerOptionsLimit(item)"
                                  @change="approvalProcess(item, listsIndex,index)"
                                ></el-date-picker>
                                <div v-else-if="item.match && item.match == 'yyyy-MM'" class="time-y-m">
                                  <el-date-picker
                                    v-model="lists[item.title + '_' + item.type]"
                                    type="month"
                                    format="YYYY-MM-DD"
                                    class="input-details"
                                    value-format="YYYY-MM-DD"
                                    style="width: 100%;"
                                    size="large"
                                    :default-value="nextMonthFun(item.limit || '')"
                                    @change="approvalProcess(item, listsIndex,index)"
                                    :picker-options="pickerOptionsLimit(item)"
                                    placeholder="选择月">
                                  </el-date-picker>
                                  <div class="time-y-m-text">
                                    {{ getTimeYM(lists[item.title + '_' + item.type]) }}
                                  </div>
                                </div>
                                <timePicker v-else-if="item.match && item.match == 'yyyy-MM-dd HH:mm' && item.timeList && item.timeList.open && item.timeList.options.length > 0" :config="list" :formdata="lists" @update:formdata="handleFormdataUpdata(item, $event)" :modifyId="modifyId" @change="approvalProcess(item, listsIndex,index)" />
                                <!--
                                <div v-else-if="item.match && item.match == 'yyyy-MM-dd HH:mm' && item.timeList && item.timeList.open && item.timeList.options.length > 0" class="time-y-m time-md-m">
                                
                                  <el-date-picker
                                    popper-class="time-zjy-widget-one-layer"
                                    v-model="lists[item.title + '_' + item.type]"
                                    :class="classFun(item, lists[item.title + '_' + item.type])"
                                    type="date"
                                    placeholder="选择日期时间"
                                    style="width: 100%;"
                                    :default-value="nextMonthFun(item.limit || '')"
                                    :picker-options="pickerOptionsLimit(item)"
                                    @change="(val) => {setTimeDefault(val, item, lists);approvalProcess(item, listsIndex,index)}"
                                    format="YYYY-MM-DD HH:mm"
                                    value-format="YYYY-MM-DD HH:mm"
                                  ></el-date-picker>
                                  
                                  <div class="time-y-m-text">
                                    {{ getTimeYMD(lists[item.title + '_' + item.type]) }}
                                  </div>
                                  <div class="time-md">
                                    <el-select v-model="timeWidthObj[item.title + '_' + item.type + '_1_' + listsIndex]" @change="(val) => getItt(lists, item, val, 2, listsIndex, index)" placeholder=" ">
                                      <el-option v-for="(itt, ittInd) in item.timeList.options" :key="ittInd + list.title" :value="itt.value" :label="itt.label" />
                                    </el-select>
                                    <div class="time-md-text">{{getTimeLabel(lists[item.title + '_' + item.type], item.timeList.options, item.timeList.defaultValue) || '请选择'}}</div>
                                  </div>
                                </div>
                                -->
                                <div v-else-if="item.match && item.match === 'HH:mm'" class="time-y-m time-md-m">
                                  <el-time-picker
                                      @change="approvalProcess(item, listsIndex,index)"
                                      value-format="HH:mm"
                                      style="width: 100%;"
                                      v-model="lists[item.title + '_' + item.type]"
                                      :picker-options="{ format: 'HH:mm' }"
                                      :disabled="item.exhibiIs"
                                      placeholder="任意时间点">
                                  </el-time-picker>
                                  <div class="time-y-m-text">
                                    {{ getTimeHHmm(lists[item.title + '_' + item.type]) }}
                                  </div>
                                </div>
                                <el-date-picker
                                  v-model="lists[item.title + '_' + item.type]"
                                  type="datetime"
                                  placeholder="选择日期时间"
                                  style="width: 100%;"
                                  size="large"
                                  :class="classFun(item, lists[item.title + '_' + item.type])"
                                  format="YYYY-MM-DD HH:mm:ss"
                                  value-format="YYYY-MM-DD HH:mm:ss"
                                  :default-value="nextMonthFun(item.limit || '')"
                                  :picker-options="pickerOptionsLimit(item)"
                                  @change="approvalProcess(item, listsIndex,index)"
                                  v-else-if="item.match && item.match == 'yyyy-MM-dd HH:mm:ss'"
                                ></el-date-picker>
                                <el-date-picker
                                  v-model="lists[item.title + '_' + item.type]"
                                  type="datetime"
                                  placeholder="选择日期时间"
                                  style="width: 100%;"
                                  size="large"
                                  :class="classFun(item, lists[item.title + '_' + item.type])"
                                  format="YYYY-MM-DD HH:mm"
                                  value-format="YYYY-MM-DD HH:mm"
                                  :default-value="nextMonthFun(item.limit || '')"
                                  :picker-options="pickerOptionsLimit(item)"
                                  @change="approvalProcess(item, listsIndex,index)"
                                  v-else
                                ></el-date-picker>
                                <div v-if="lists[item.title + '_' + item.type] && item.match === 'yyyy-MM-dd ww'" class="time-week">星期{{timeWeek(lists[item.title + '_' + item.type])}}</div>
                              </div>
                            </template>
                            <template v-if="item.type === 'number'">
                              <template
                                v-if="item.per === 2 || getUpcontroll(item)"
                              >{{lists[item.title + '_' + item.type]}}</template>
                              <el-input-number
                                v-model="lists[item.title + '_' + item.type]"
                                v-else
                                :class="classFun(item, lists[item.title + '_' + item.type])"
                                label="描述文字"
                                style="width:100%"
                                size="large"
                                :controls="true"
                                controls-position="right"
                                :step="item.step"
                                :placeholder="list.placeholder||'请输入'"
                                @change="approvalProcess(item, listsIndex,index)"
                                @input="arithmetic(item, listsIndex)"
                              ></el-input-number>
                            </template>
                            <template v-if="item.type === 'radio'">
                              <template v-if="item.per === 2 || getUpcontroll(item)">
                                <span
                                  :class="['list-block', item.selsItemColor && item.selsItemColor[lists[item.title + '_' + item.type]] ? 'list-block-active' : '', list.types && Number(list.types) === 6 ? 'no-back' : '']"
                                  :style="item.selsItemColor && item.selsItemColor[lists[item.title + '_' + item.type]] ? {backgroundColor:item.selsItemColor? item.selsItemColor[lists[item.title + '_' + item.type]] : '#fff',color:item.selsItemColor&&item.selsItemColor[lists[item.title + '_' + item.type]] ? '#fff' : '#333'} : ''"
                                >
                                  <template v-if="item.types && Number(item.types) === 5">
                                    {{ getRadioProvinces(lists[item.title + '_' + item.type], item) }}
                                  </template>
                                  <radioXing v-else-if="item.types && Number(item.types) === 6" :sels="objSels(item.sels, item)" :value="lists[item.title + '_' + item.type]" :edit="false" @upXing="val => upXing(val, item, listsIndex)" />
                                  <template v-else>
                                    {{lists[item.title + '_' + item.type] === 'others其他' && item.others ? othersObj[detailsWidgetData.title + '_' + detailsWidgetData.type][listsIndex][item.title + '_' + item.type] : getRadioLabel(lists[item.title + '_' + item.type], objSels(item.sels, item))}}
                                  </template>
                                </span>
                              </template>
                              <template v-else>
                                <div v-if="item.queryOnly && item.dataconfig && item.dataconfig.setUpValue && item.dataconfig.setUpValue === 1" class="on-show" style="pointer-events:none;">
                                  <div class="on-show-show on-show-left" style="pointer-events:none;">
                                    <i class="iconfont icon-shujuchaxun" />
                                    {{item.placeholder}}
                                  </div>
                                </div>
                                <el-radio-group v-model="lists[item.title + '_' + item.type]"
                                    @change="approvalProcess(item, listsIndex,index)"
                                    v-if="item.types && Number(item.types) === 1">
                                  <template v-for="sels in objSels(item.sels, item)">
                                    <el-radio v-if="!item.isHideObj || !item.isHideObj[sels.value || sels]" :label="sels.value || sels" :key="sels.value">
                                      <span
                                        class="radiovalue"
                                        v-if="item.selsItemColor"
                                        :style="{backgroundColor:item.selsItemColor[sels.value || sels],color:item.selsItemColor[sels.value || sels]?'#fff':''}"
                                      >{{sels.label || sels}}</span>
                                      <template v-else>
                                        {{ sels.label || sels }}
                                      </template>
                                    </el-radio>
                                  </template>
                                  <el-radio label="others其他" v-if="item.others">其他</el-radio>
                                </el-radio-group>
                                <div v-else-if="item.types && Number(item.types) === 2" class="radio-list">
                                  <template v-for="(its, indexIts) in objSels(item.sels, item)">
                                    <div v-if="!item.isHideObj || !item.isHideObj[its.value || its]"
                                        :key="indexIts + (its.value || its)"
                                        class="radio-list-imgs"
                                        :style="getButtonBlock(its.value || its, item, '', listsIndex)"
                                        @click="setRadio({val: its.value || its, item: item, index: listsIndex})">
                                      <el-image v-if="item.selsItemImg && item.selsItemImg[its.value || its]"
                                                class="radio-list-img"
                                                :src="$imgurl + item.selsItemImg[its.value || its] + '?accesstoken=' + token"></el-image>
                                      <div v-else class="radio-list-img">
                                        <i class="el-icon-picture-outline no-icon"></i>
                                      </div>
                                      <div class="radio-list-text ellipsis" :style="getButtonStyle(its.value || its, item, '', listsIndex)">{{its.label || its}}</div>
                                    </div>
                                  </template>
                                </div>
                                <div v-else-if="item.types && Number(item.types) === 3" class="radio-list" style="margin-bottom:-10px;">
                                  <template v-for="(its, indexIts) in objSels(item.sels, item)">
                                    <div v-if="!item.isHideObj || !item.isHideObj[its.value || its]"
                                      :key="indexIts + (its.value || its)"
                                      @click="setCheck({val: its.value || its, item: item, index: listsIndex})"
                                      :style="getRadioStyle(its, item, listsIndex)"
                                      class="radio-list-button">
                                      {{its.label || its}}
                                    </div>
                                  </template>
                                </div>
                                <div class="radio-switch" v-else-if="item.types && Number(item.types) === 4">
                                  <template v-if="item.switchStyle && item.switchStyle === 3">
                                    <el-checkbox v-model="lists[item.title + '_' + item.type]"
                                                :true-label="getSwitchColor({ele: item, type: 'active',isGet: true})"
                                                :false-label="getSwitchColor({ele: item, type: 'inactive',isGet: true})"
                                                @change="approvalProcess(item, lists[item.title + '_' + item.type], formdata)" />
                                  </template>
                                  <el-switch v-else 
                                    :active-value="getSwitchColor({ele: item, type: 'active',isGet: true})"
                                    :inactive-value="getSwitchColor({ele: item, type: 'inactive',isGet: true})"
                                    :active-color="getSwitchColor({ele: item, type: 'active'})"
                                    :inactive-color="getSwitchColor({ele: item, type: 'inactive'})"
                                    :inactive-text="item.switchStyle === 1 ? '' : getSwitchColor({ele: item, type: 'inactive', isGet: true})"
                                    :active-text="item.switchStyle === 1 ? '' : getSwitchColor({ele: item, type: 'active', isGet: true})"
                                    v-model="lists[item.title + '_' + item.type]"
                                    @change="approvalProcess(item, lists[item.title + '_' + item.type], formdata)"
                                  />
                                </div>
                                <multilevel v-else-if="item.types && Number(item.types) === 5" :config="item.multilevelConfig" :formdata="lists[item.title + '_' + item.type]" 
                                @update:formdata="handleFormdataUpdata(item, $event)" @change="approvalProcess(item, listsIndex,index)" :placeholder="item.placeholder" />
                                <radioXing v-else-if="item.types && Number(item.types) === 6" :sels="objSels(item.sels, item)" :value="lists[item.title + '_' + item.type]" :edit="true" @upXing="val => upXing(val, item, listsIndex, index)" />
                                <el-select
                                  v-else
                                  filterable
                                  v-model="lists[item.title + '_' + item.type]"
                                  :class="[
                                    'input-select input-details select-details ',
                                    classFun(item, lists[item.title + '_' + item.type]),
                                    item.queryOnly && item.dataconfig && item.dataconfig.setUpValue && item.dataconfig.setUpValue === 1 ? 'on-show-pointer' : ''
                                  ]"
                                  :placeholder="item.placeholder"
                                  style="width: 100%;"
                                  size="large"
                                  @focus="conditionLink(item)"
                                  @change="approvalProcess(item, listsIndex,index)"
                                  @visible-change="radioBlurChange(list.title+'_'+list.type+'_'+listsIndex, $event)"
                                >
                                  <template #prefix>
                                    <div style="display:none;min-height:28px;margin-top:1px;background:#ffffff;height:calc(100% - 2px);" v-if="lists[item.title + '_' + item.type] && lists[item.title + '_' + item.type]!=='others其他'&&!radioBlur[list.title+'_'+list.type+'_'+listsIndex] && (!item.types || item.types !== 2)">
                                      <span class="ridiotagstyle ellipsis ellipsis4" :style="{'backgroundColor':item.selsItemColor&&item.selsItemColor[lists[item.title + '_' + item.type]],'color':item.selsItemColor&&item.selsItemColor[lists[item.title + '_' + item.type]]?'#fff':'#333'}">
                                        {{getRadioLabel(lists[item.title + '_' + item.type], objSels(item.sels, item))}}
                                      </span>
                                    </div>
                                  </template>
                                  <template v-for="sels in objSels(item.sels, item)">
                                    <el-option
                                      v-if="!item.isHideObj || !item.isHideObj[sels.value || sels]"
                                      :key="sels.id"
                                      :label="sels.label || sels"
                                      :value="sels.value || sels"
                                    >
                                      <div v-if="item.types && item.types === 2" class="radio-img">
                                        <el-image  v-if="item.selsItemImg && getImgRadio(item, sels.value || sels)"
                                                  :src="getImgRadio(item, sels.value || sels)"
                                                  :preview-src-list="[getImgRadio(item, sels.value || sels)]"
                                                  fit="scale-down"
                                                  @click.stop
                                                  class="radio-imgs">
                                          <template #error>
                                            <div class="image-slot">
                                              <i class="el-icon-picture-outline"></i>
                                            </div>
                                          </template>
                                        </el-image>
                                        <span :style="getRadioTypes(item, sels.value || sels)">{{sels.label || sels}}</span>
                                      </div>
                                      <span
                                        v-else-if="item.selsItemColor"
                                        :style="getRadioTypes(item, sels.value || sels)"
                                      >{{sels}}</span>
                                    </el-option>  
                                  </template>
                                  <el-option key="其他" label="其他" value="others其他" v-if="item.others">
                                    <span :style="{padding:'4px 8px',borderRadius:'10px'}">其他</span>
                                  </el-option>
                                </el-select>
                                <template
                                  v-if="item.others && lists[item.title + '_' + item.type] === 'others其他'"
                                >
                                  <br />
                                  <input
                                    type="text"
                                    v-model="othersObj[detailsWidgetData.title + '_' + detailsWidgetData.type][listsIndex][item.title + '_' + item.type]"
                                    :class="classFun(item, lists[item.title + '_' + item.type], othersObj[detailsWidgetData.title + '_' + detailsWidgetData.type][listsIndex][item.title + '_' + item.type])"
                                    placeholder="请输入内容"
                                    class="other-class"
                                  />
                                </template>
                              </template>
                            </template>
                            <template v-if="item.type === 'checkbox'">
                              <template v-if="item.per === 2 || getUpcontroll(item)">
                                <span
                                  :class="['list-block', item.selsItemColor && item.selsItemColor[list] ? 'list-block-active' : '']"
                                  v-for="list in lists[item.title + '_' + item.type] || []"
                                  :key="list.id"
                                  :style="{backgroundColor:item.selsItemColor? item.selsItemColor[list] : '#fff',color:item.selsItemColor&&item.selsItemColor[list] ? '#fff' : '#333'}"
                                >{{list}}</span>
                              </template>
                              <template v-else>
                                <el-checkbox-group v-model="lists[item.title + '_' + item.type]"
                                  @change="approvalProcess(item, listsIndex,index)"
                                  v-if="item.types && item.types === 1">
                                  <template v-for="sels in objSels(item.sels, item)">
                                      <el-checkbox v-if="!item.isHideObj || !item.isHideObj[sels.value || sels]" :label="sels" :key="sels.value || sels">
                                        <span class="checkboxvalue"
                                          v-if="item.selsItemColor"
                                          :style="{backgroundColor:item.selsItemColor[sels],color:item.selsItemColor[sels]?'#fff':''}"
                                        >{{sels}}</span>
                                      </el-checkbox>
                                  </template>
                                </el-checkbox-group>
                                <div v-else-if="item.types && item.types === 2" class="radio-list">
                                  <template v-for="(its, indexIts) in objSels(item.sels, item)">
                                    <div v-if="!item.isHideObj || !item.isHideObj[its.value || its]"
                                        :key="indexIts + (its.value || its)"
                                        class="radio-list-imgs"
                                        :style="getButtonBlock(its.value || its, item, true, listsIndex)"
                                        @click="setCheck({val: its.value || its, item: item, index: listsIndex})">
                                      <el-image v-if="item.selsItemImg && item.selsItemImg[its.value || its]"
                                                class="radio-list-img"
                                                :src="$imgurl + item.selsItemImg[its.value || its] + '?accesstoken=' + token"></el-image>
                                      <div v-else class="radio-list-img">
                                        <i class="el-icon-picture-outline no-icon"></i>
                                      </div>
                                      <div class="radio-list-text ellipsis" :style="getButtonStyle(its.value || its, item, true, listsIndex)">{{its.label || its}}</div>
                                    </div>
                                  </template>
                                </div>
                                <div v-else-if="item.types && item.types === 3" class="radio-list" style="margin-bottom:-10px;">
                                  <template v-for="(its, indexIts) in objSels(item.sels, item)">
                                    <div v-if="!item.isHideObj || !item.isHideObj[its.value || its]"
                                      :key="indexIts + (its.value || its)"
                                      @click="setCheck({val: its.value || its, item: item, index: listsIndex})"
                                      :style="getRadioStyle(its.value || its, item, listsIndex)"
                                      class="radio-list-button">
                                      {{its.label || its}}
                                    </div>
                                  </template>
                                </div>
                                <el-select
                                  v-else
                                  filterable
                                  v-model="lists[item.title + '_' + item.type]"
                                  :class="'select-details check-inp check-inpD ' + classFun(item, lists[item.title + '_' + item.type])"
                                  @focus="conditionLink(item)"
                                  @change="approvalProcess(item, listsIndex,index)"
                                  multiple
                                  placeholder="请选择"
                                  style="width: 100%"
                                  size="large"
                                >
                                  <template #prefix>
                                    <span style="line-height:normal;display:contents;">
                                      <template v-if="lists[item.title + '_' + item.type] && lists[item.title + '_' + item.type].length > 0">
                                        <template v-for="sels in lists[item.title + '_' + item.type]" :key="sels.label">
                                          <span class="demo-tag-details" :style="{'backgroundColor':item.selsItemColor ? item.selsItemColor[sels] : '','marginTop':'5px'}">{{sels}}</span>
                                        </template>
                                      </template>
                                      <!-- 如果没有数据则显示 placeholder -->
                                      <template v-else>
                                        <span style="padding-left: 5px;">{{item.placeholder}}</span>
                                      </template>
                                    </span>
                                  </template>
                                  <template v-for="sels in objSels(item.sels, item)">
                                    <el-option
                                      v-if="!item.isHideObj || !item.isHideObj[sels.value || sels]"
                                      :key="sels"
                                      :label="sels"
                                      :value="sels"
                                    >
                                      <span
                                        v-if="item.selsItemColor"
                                        :style="{backgroundColor:item.selsItemColor[sels],color:item.selsItemColor[sels]?'#fff':'',padding:'4px 8px',borderRadius:'10px'}"
                                      >{{sels}}</span>
                                    </el-option>
                                  </template>
                                </el-select>
                              </template>
                            </template>
                            <template v-if="item.type === 'relation-user'">
                              <template v-if="item.per === 2 || getUpcontroll(item)">
                                <span
                                  :key="relU.organizationId"
                                  v-for="relU in lists[item.title + '_' + item.type] || []"
                                >{{relU.realname}}</span>
                              </template>
                              <template v-else>
                                <template
                                  v-if="lists[item.title + '_' + item.type] && lists[item.title + '_' + item.type].length !== 0"
                                >
                                  <div
                                    class="relation-user"
                                    @click="relationUserChoice(item, listsIndex, lists[item.title + '_' + item.type])"
                                    style="cursor: pointer;"
                                  >
                                    <template
                                      v-for="(relU,index3) in lists[item.title + '_' + item.type]"
                                    >
                                      <el-tag
                                        type="info"
                                        :key="relU.organizationId"
                                        closable
                                        :disable-transitions="false"
                                        @close="handleCloseFlow(item, index3, listsIndex)"
                                        v-if="index3==0"
                                      >{{relU.realname}}</el-tag>
                                    </template>
                                    <span
                                      v-if="lists[item.title + '_' + item.type].length > 1"
                                    >等{{lists[item.title + '_' + item.type].length}}人</span>
                                  </div>
                                </template>
                                <div
                                  v-else
                                  :class="classFun(item, lists[item.title + '_' + item.type])"
                                >
                                  <div
                                    class="relation-user"
                                    @click="relationUserChoice(item, listsIndex, lists[item.title + '_' + item.type])"
                                  >
                                    <span>
                                      <i
                                        class="iconfont icon-lianxirenkongjianxuanzerenyuan"
                                        style="margin-right: 5px"
                                      ></i>
                                      {{item.placeholder == '' ? '选择添加联系人' : item.placeholder}}
                                    </span>
                                  </div>
                                </div>
                              </template>
                            </template>
                            <template v-if="item.type === 'image'">
                              <div
                                class="img-flex"
                                v-if="Number(item.per) === 2 || getUpcontroll(item) || websiteIsOpen"
                              >
                                <div
                                  v-for="imgList in lists[item.title + '_' + item.type] || []"
                                  class="table-img-list"
                                  :key="imgList.url"
                                >
                                  <el-image
                                    class="list-img"
                                    :src="imgList.url || imgUrlHandle(imgList.response)"
                                    :z-index="99999"
                                    :append-to-body="true"
                                    :preview-src-list="[imgUrlHandle(imgList.response)] || (lists[item.title + '_' + item.type] || []).map(val=>{return val.url})"
                                  ></el-image>
                                </div>
                              </div>

                              <el-form-item
                                @click="listCli(listsIndex, index)"
                                v-else
                                @mousemove="listCliRemo(listsIndex, index)"
                                style="margin-bottom: 0px;"
                              >
                                <div v-if="item.signature === true" class="signa-box">
                                  <el-button class="signabtn"  @click="showSigna(item,listsIndex)">点击签名</el-button>
                                  <div v-for="(list1, index) in lists[item.title + '_' + item.type]" :key="index">
                                    <el-image
                                      fit="cover"
                                      :src="list1.url || ($url + list1.response + '?accesstoken=' + token)" class="signaPic" ></el-image>
                                  </div>
                                </div>
                                <el-upload
                                  v-else
                                  :action="$url+'/userfile/upload?accesstoken='+token"
                                  ref="upload"
                                  :disabled="!upDataFile"
                                  :file-list="lists[item.title + '_' + item.type]"
                                  :class="'img-file-class ' + classFun(item, lists[item.title + '_' + item.type])"
                                  class="file-img-up"
                                  :on-progress="handleProgress"
                                  list-type="picture-card"
                                  :on-preview="handlePreview"
                                  :on-success="handleSuccess"
                                  :on-error="handleError"
                                  :on-remove="handleRemove"
                                  :limit="Number(item.upNumber)"
                                  :on-exceed="(file, fileList)=>{return handleExceed(file, fileList, item)}"
                                  :before-upload="beforeImgUpload"
                                  :multiple="true"
                                >
                                  <template #trigger>
                                    <div
                                      class="el-upload__text"
                                      style="background: none;border:none;"
                                    >
                                      <i
                                        class="WSiconfont WSicon-fwbcharutupian"
                                        style="color:#4284BA;font-size: 14px"
                                      ></i>
                                      {{item.placeholder == '' ? '选择上传图片' : item.placeholder}}
                                    </div>
                                  </template>
                                </el-upload>
                              </el-form-item>
                            </template>
                          </div>
                        </table-col>
                    </template>
                  </template>
                </template>
              </div>
            </template>
            <!-- 这行是汇总的 -->
            <div
              class="details-table-col fixed-value"
              v-if="detailsWidgetData.statistics && detailsWidgetData.statistics.length > 0"
            >
              <div
                class="details-table-row table-col-nowrap text-r pad-5"
                v-if="isInput && detailsWidgetData.per == 1
                      || !isInput && !detailsWidgetData.detailsNum && detailsWidgetData.per == 1
                      || modifyId"
                :style="{transform: 'translate3d(' + topDistance + 'px,0,0)', zIndex: 8}"
              >汇</div>
              <div
                class="details-table-row table-col-nowrap pad-5"
                :class="isInput && detailsWidgetData.per == 1
                        || !isInput && !detailsWidgetData.detailsNum && detailsWidgetData.per == 1
                        || modifyId ? '' : 'text-c'"
                :style="{transform: 'translate3d(' + topDistance + 'px,0,0)', zIndex: 8}"
              >
                {{isInput && detailsWidgetData.per == 1
                || !isInput && !detailsWidgetData.detailsNum && detailsWidgetData.per == 1
                || modifyId ? '总' : '汇总'}}
              </div>
              <template v-for="list in detailsWidgetData.list">
                <div class="details-table-row table-col-nowrap"
                    v-if="list.per !== 3 && getHide(list)"
                    :key="list.title"
                    :style="freezeObj[list.title + '_' + list.type] ? ('transform:translate3d(' + topDistance + 'px,0,0);z-index:8;') : ''">
                  <div
                    class="details-table-table-row details-width"
                    v-if="list.type === 'number'"
                  >{{summaryObj[(list.title + '_' + list.type)]}}</div>
                </div>
                <template v-if="list.list && list.list.length > 0 && list.per !== 3 && getHide(list) && (list.type !== 'new-rel-radio' || list.type === 'new-rel-radio' && (relShowObj[list.title + '_' + list.type] || !list.isRel))">
                  <template v-for="item in list.list">
                    <div class="details-table-row table-col-nowrap"
                        v-if="item.per !== 3 && getHide(item)"
                        :key="item.title"
                        :style="freezeObj[item.title + '_' + item.type] ? ('transform:translate3d(' + topDistance + 'px,0,0);z-index:8;') : ''">
                      <div
                        class="details-table-table-row details-width"
                        v-if="item.type === 'number'"
                      >{{summaryObj[(item.title + '_' + item.type)]}}</div>
                    </div>
                  </template>
                </template>
              </template>
            </div>
        </el-scrollbar>
      <!-- </scrollBar> -->
    </template>
    <el-dialog
      title="签名板"
      v-model="signaVisible"
      width="900px"
      class="signa"
      append-to-body
      >
      <div class="sign">
        <div class="pc">
          <h6>电脑端签名</h6>
          <div class="box">
            <vue-esign ref="esign" class="canvas" :width="582" :height="350" :isCrop="isCrop" :lineWidth="lineWidth" :lineColor="lineColor" :bgColor="bgColor" />
            <el-button class="clear" type="primary" @click="handleReset">重签</el-button>
          </div>
        </div>
        <div class="phone">
          <p class="tip1">使用微信扫码签名</p>
          <div class="code">
            <vue-qrcode 
              :value="vueqrval" 
              :options="{
                width: 188,
                margin: 5
              }"
            />
          </div>
          <p class="tip2">扫描后可在手机端签名</p>
          <div v-if="uploadSignStatus">
            <div class="upload-sign">
              <i class="el-icon-plus"></i>
              <span>上传签名图片</span>
              <input type="file" id="upload-file" @change="uploadSign()" />
            </div>
            <p class="tip2">上传签名图片格式.png</p>
          </div>
        </div>
      </div>
      <span class="dialog-footer">
        <el-button @click="signaVisible = false">取 消</el-button>
        <el-button type="primary" @click="upSigna">提 交</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
/* eslint-disable vue/no-mutating-props */
import { defineAsyncComponent } from 'vue'
import tableCol from "./table-col.vue";
import tableHeaderCol from "./table-header-col.vue";
import newRelRadio from "../newRelRadio.vue";
// import scrollBar from "./scrollBar"
import tableRead from './tableRead.vue'
import * as widgetJs from "@/api/widgetOneLayer/";
import { momVal, limitDate, thisNoTime, copyObj, accAdd, formatWY, isWY } from "@/api/utils";
import { retClassName, getWeek } from "@/api/styleUtils";
import webSocketClass from "@/api/ws";
import {
  formatDate,
  linkedSetEvent,
  fileFormatted,
  linkedFormatConversion,
  sliceEncrypt,
  fileListForeach,
  getSwitchColor
} from "@/api/global";
import { getlinkeddatalist } from "@/port/clientSide/oaExamineAudit";
import Axios from 'axios';
import vueEsign from 'vue-esign'
import VueQrcode from '@chenfengyuan/vue-qrcode'
import {filesConfig} from "../../../../api/global";
import multilevel from '../../common/multilevel' // 单选多级选择
import timePicker from '../../common/timePicker'
import radioXing from '../widgetCommon/radioXing'
import { getapiuserlist } from "@/port/clientSide/multipleChoice";

export default {
  name: "detailsTable",
  // formdata 结果数据 detailsWidgetData 模板数据 modifyId 是否修改 isOne 点击了提交状态变成true detailsIndex 当前模板的下标  userHide 提交隐藏值另存 othersObj 单选（其他选项）approvalId 应用id  pageSize 每页条数 current 第几页 upView 视图更新(防止父级display:none)放大缩小同时使用他 cutkey 开启了明细切页的当前显示页key
  // 注意：formdatas 是所有数据，只能用来获取值，不能修改任何值
  props: [
    "formdata",
    "detailsWidgetData",
    "modifyId",
    "isOne",
    "formdatas",
    "detailsIndex",
    "userHide",
    "othersObj",
    "isInput",
    "approvalId",
    "pageSize",
    "current",
    "upView",
    "websiteIsOpen", // 用于判断是否是官网
    "themeConfig", // 主题色配置
    "layout",
    "cutkey",
    "AuditList",
    "pageId",
    "modify"
  ],
  components: {
    tableCol,
    tableHeaderCol,
    newRelRadio,
    // scrollBar,
    vueEsign,
    VueQrcode,
    tableRead,
    multilevel,
    timePicker,
    radioXing,
    userDropDown: defineAsyncComponent(() => import('../userDropDown')),
    linkedDropDown: defineAsyncComponent(() => import('../linkedDropDown')),
    relationUserInfo: defineAsyncComponent(() => import('@/components/clientSide/common/relationUserInfo'))    
  },
  data() {
    return {
      heightArr: [],
      // isWidth: false, // 自动触发宽度比对的开关
      // isFloat: false, // 是否出现浮层（出现滚动条的情况下才需要）
      tableCompute: 0, // 表格初始化触发阈值
      tableTime: null, // 存延时
      watchTime: null, // 触发值变动比对高度（节流）
      watchTimeAuto: null, // 这个是手动触发的
      checkAll: false, // 是否全选
      checkList: [], // 多选
      checkObj: [], // 多选
      isCheckObj: false,
      isDelLayout: false, // 删除时使用（有图片控件时用来二次高度校队）
      radioBlur:{},//单选有颜色时候，点击下拉需要把项隐藏
      restaurants: [], // 暂存输入框数据
      inputChange: false, // 由于当行输入框无法获取数据改变方法事件，所以联动需要使用，就通过这个来写
      autocompleteText: null, // 暂用存储单选输入框点击时的数据

      upDataFile: true, // 图片
      fileListLength: 0,
      indexNumber: null,
      colIndex: null,
      removeIndN: null,
      removeColI: null,
      detailsWidgetEmitData: null,
      signaVisible: false,// 签名板的显示
      uploadSignStatus: false, //是否显示上传签名图片按钮
      indexString: null, // 记录签名板的位置
      signa_index: null , // 记录签名板在明细表中的位置
      // 签名板手机端二维码
      vueqrval: '',
      lineWidth: 6,
      lineColor: '#000000',
      bgColor: '',
      resultImg: '',
      isCrop: false,
      signaPic:false, // 签名后的图片

      widthObj: {}, // 宽度列表
      tableWidth: 0,
      tableCellWidth: 0,

      topDistance: 0, // 顶部距离
      lessHeight: 0,

      summaryObj: {}, // 显示汇总的
      linkedWd: {}, //联系人控件搜索
      freezeObj: {},  // 冻结列

      myObserver: null,  // 监听大小变化
      onShowObj: {}, // 点击显示

      conditionLinkObj: null,
      // 关联单选值隐藏显示
      relShowObj: {},
      relevancyShowObj: {},
      relevancyAddress: {
        x: 0,
        y: 0
      },
      timeWidthObj: {},
      getWidthObj: {},
      cutObj: [],
      detailsFlex: {},
      dataModifyLen: null, //表单操作权限如果设置原数据不可改,读取到的原数据长度
      tempFormdata: [],
      isExpandList: {},
      trIndex: 0, // 当前行
      token: localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')).accesstoken : '',
    };
  },
  watch: {
    formdata: {
      immediate: true,
      deep: true,
      handler(val) {
        console.log("valaaa==",val);
        
        this.upSummary();
        // checkObj 列表只需要第一次构建一次就可以
        if (!this.isCheckObj) {
          this.isCheckObj = true;
          this.selectAllCheck(false);
        }
        // 数量不对等就是添加
        if (val !== undefined && this.checkObj.length !== val.length) {
          this.checkObj.push(false);
        }
        this.getRelShow()
        // 如果开启了明细切页，根据配置给一个条数的匹配
        if (this.detailsWidgetData && this.detailsWidgetData.isCutDataConfig) {
          const count = {}
          const countArr = []
          for (let i = 0; i < val.length; i++) {
            const tip = val[i].tip
            if (tip) {
              count[tip] = (count[tip] || 0) + 1
              countArr.push({i: tip, ind: count[tip]})
            }
          }
          // this.$set(this, 'cutObj', countArr)
          this.cutObj = countArr
        }
      }
    },
    upView: {
      immediate: true,
      handler (val) {
        if (val) this.getSys()
      }
    },
    // 会报错，先注释
    // 'signaVisible': {
    //   immediate: true,
    //   handler (val) {
    //     if(val){
    //       this.$refs.esign.reset()
    //     }
    //   }
    // },
    'detailsWidgetData.freeze': {
      immediate: true,
      handler (val) {
        if (val && JSON.stringify(this.freezeObj) === '{}') this.getFreezeCol(val)
      }
    },
    'detailsWidgetData.list': {
      immediate: true,
      deep: true,
      handler (arr = []) {        
        if (this.detailsWidgetData && this.detailsWidgetData.detailsTableType && this.detailsWidgetData.detailsTableType === 'flex') {
          let count = 0
          let jCount = 0
          const o = {}

          // getHide(list) && list.per !== 3

          for (const i of arr) {
            console.log('隐藏判断', this.getHide(i), i.per)
            if (!this.getHide(i) || i.per == 3) continue
            jCount += 1
            const v = (i.widthFlex || '100%').split('%')
            o[i.title] = v[0]
            count += Number(v[0])
            if (i.list && i.list.length > 0) {
              for (const a of i.list) {
                if (!this.getHide(a) || a.per == 3) continue
                jCount += 1
                const v1 = (a.widthFlex || '100%').split('%')
                o[i.title + '.' + a.title] = v1[0]
                count += Number(v1[0])
              }
            }
          }
          console.log('宽度计算大小', count, jCount, o)
          // 0.2 误差
          if (99.8 > count) {
            const kk = (100 - count) / jCount
            console.log('多宽度分配', kk, jCount)
            for (const o1 in o) {
              o[o1] = (Number(o[o1]) + Number(kk))
            }
          } else if (count > 100) {
            for (const o1 in o) {
              o[o1] = (100 / jCount)
            }
          }
          // this.$set(this, 'detailsFlex', o)
          this.detailsFlex = o
        }
        // 明细控件-表单操作权限如果设置原数据不可改并且是可写状态
        console.log("asdasd==",this.formdata)
        console.log("this.detailsWidgetData==",this.detailsWidgetData)
        if(this.detailsWidgetData.per === 1 && this.detailsWidgetData.dataModify === 0){
          let validDataCount = 0;
          this.formdata.forEach(item => {
            let hasValidField = false; // 用于标记是否找到有效字段
            for (let key in item) {
              if (Object.prototype.hasOwnProperty.call(item, 'key')){
                const value = item[key];
                // 如果值不是null、undefined或空数组，认为这是一个有效字段
                if (value !== null && value !== undefined && (!Array.isArray(value) || value.length > 0)) {
                  hasValidField = true; // 标记找到有效字段
                  break; // 找到有效字段后，跳出循环
                }
              }
            }
            if (hasValidField) {
                validDataCount++; // 如果找到至少一个有效字段，则增加计数
            }
          });
          if(validDataCount > 0){
            this.dataModifyLen = validDataCount //原数据不可改的长度
            console.log("this.formdata==",this.formdata, validDataCount)
          }
        }
        // 默认值联动
        const defaultVal = this.getNonEmptyFieldPrefixes(this.detailsWidgetData.list)
        if (
          this.detailsWidgetData &&
          this.detailsWidgetData.list &&
          this.detailsWidgetData.list.length > 0 && 
          defaultVal.length > 0 &&
          this.isInput &&
          !this.modifyId
        ) {
          const detailsWidgetDataList = this.detailsWidgetData.list;
          const detailsType =
            this.detailsWidgetData.title + "_" + this.detailsWidgetData.type;
          console.log("qqqqq===",defaultVal);
          // 遍历 defaultVal 中的每个 prefixes 数组
          defaultVal.forEach((row) => {
            // 遍历当前行的 prefixes
            row.prefixes.forEach((itemTitle) => {
              // 在 detailsWidgetDataList 中查找匹配的 title
              for (let [i, el] of detailsWidgetDataList.entries()) {
                if (el.title === itemTitle) {
                  console.log("vvvvvv=", i, itemTitle);
                  // detailsWidgetDataList遍历如果title字段和itemTitle，则获取对应的数组内容
                  detailsWidgetDataList.forEach((item) => {
                    if (item.title === itemTitle) {
                      this.$emit(
                        "linkageMethEachEmit",
                        detailsWidgetDataList,
                        item,  // 使用 itemTitle 而不是 item
                        i,
                        { key: detailsType, index: row.index }
                      );
                    }
                  })
                }
              }
            });
          });
        }
      }
    },
    tableCellWidth: {
      immediate: true,
      handler (val) {
        console.log('当前值呗更新了', val)
      }
    }
  },
  mounted() {
    this.getSys()
    const id = this.detailsWidgetData.title + "_" + "2";
    const dom = this.$refs[id];

    this.myObserver = new ResizeObserver(entries => {
      entries.forEach(entry => {
        const width = entry.contentRect.width
        if (!this.tableCellWidth || (this.tableCellWidth - 5) < width < (this.tableCellWidth + 5)) {
          // this.getHeaderWidth()
          const domHeader = entry.target.getElementsByClassName('header')
          const tableCellWidth = dom.offsetWidth;
          if (domHeader && domHeader[0]) {
            const tableWidth = domHeader[0].scrollWidth || domHeader[0].cellWidth;
            this.tableWidth = tableWidth
            this.tableCellWidth = tableCellWidth
          }
        }
      })
    })
    this.myObserver.observe(dom)
  },
  beforeUnmount() {
    const id = this.detailsWidgetData.title + "_" + "2";
    const dom = document.getElementById(id);
    if (dom) {
      const self = this;
      dom.removeEventListener("scroll", self.distanceFun);
    }
    if (this.myObserver) this.myObserver = null
  },
  methods: {
    getRadioStyle (val, item, index) {
      if (val && typeof val === 'object') val = val.value || val
      const obj = {}
      let color = item.selsItemColor && item.selsItemColor[val] ? item.selsItemColor[val] : '#C0C4CC'
      const e = this.formdata[index][item.title + '_' + item.type]
      const isColor = item.type === 'checkbox' && e && e.includes(val) || item.type !== 'checkbox' && e && val === e

      if (isColor) {
        color = item.selsItemColor && item.selsItemColor[val] ? item.selsItemColor[val] : '#057EFF'
      }
      obj.backgroundColor = isColor ? color : ''
      obj.borderColor = color
      obj.color = isColor ? '#ffffff' : color
      return obj
    },
    setCheck ({ val, item, index }) {
      let value = JSON.parse(JSON.stringify(this.formdata[index][item.title + '_' + item.type]))
      if (item && item.type === 'radio') {
        value = val
      } else {
        if (!value || !Array.isArray(value)) value = []
        const ind = value.findIndex(its => its === val)
        if (ind !== -1) {
          value.splice(ind, 1)
        } else {
          value.push(val)
        }
      }
      
      // this.$set(this.formdata[index], item.title + '_' + item.type, value)
      this.formdata[index][item.title + '_' + item.type] = value
      this.$forceUpdate()
      this.approvalProcess(item, index)
    },
    getButtonStyle (val, item, key, index) {
      const color = item.selsItemColor && item.selsItemColor[val] ? item.selsItemColor[val] : '#057EFF'
      let e = this.formdata[index] && this.formdata[index][item.title + '_' + item.type] || ''
      if (key && typeof e === 'string') {
        try {
          e = JSON.parse(e)
        } catch (s) {
          console.log("ss",s);          
        }
      } 
      return {
        color: e && (!key && val === e || key && e.includes(val)) ? color : ''
      }
    },
    setRadio ({ val, item, index }) {
      // this.$set(this.formdata[index], item.title + '_' + item.type, val)
      this.formdata[index][item.title + '_' + item.type] = val
      this.approvalProcess(item, val, this.formdata)
    },
    getButtonBlock (val, item, key, index) {
      const obj = {}
      let e = this.formdata[index] && this.formdata[index][item.title + '_' + item.type]
      if (key && typeof e === 'string') {
        try {
          e = JSON.parse(e)
        } catch (s) {
          console.log("ss",s);
        }
      }
      if (e && ((!key && val === e) || key && e.includes(val))) {
        const color = item.selsItemColor && item.selsItemColor[val] ? item.selsItemColor[val] : '#057EFF'
        obj.borderColor = color
      }
      return obj
    },
    upXing (val, item, ind, indC) {
      const type = item.title + '_' + item.type
      // this.$set(this.formdata[ind], type, val)
      this.formdata[ind][type] = val
      if(indC){
        this.approvalProcess(item, ind, indC)
      }
    },
    getNonEmptyFieldPrefixes(list) {
      return list
        .filter(item => {
          // 检查 bindinf 是否存在有效值
          const value = item.bindinf;
          return value !== null && 
                value !== undefined && 
                value !== '' && 
                !(Array.isArray(value) && value.length === 0);
        })
        .map(item => ({
          index: list.indexOf(item), // 保留原始索引
          prefixes: [item.title.split('_')[0]] // 获取 title 下划线前的部分
        }));
    },
    openLinkText (val, config = {}) {
      if (config.per === 2 && config.type === 'text' && config.isLink) {
        window.open(val)
      }
    },
    getShowList (index, lists) {
      
      if (!this.detailsWidgetData.isCutDataConfig || this.detailsWidgetData.isCutDataConfig.length === 0) {
        
        return this.detailsWidgetData.pagination && ((this.current - 1) * this.pageSize) <= index && index < (this.current * this.pageSize) || !this.detailsWidgetData.pagination
        // return this.detailsWidgetData.pagination && ((this.current - 1) * this.pageSize) <= this.listsIndex && index < (this.current * this.pageSize) || !this.detailsWidgetData.pagination
      } else {
        if (lists.tip === this.cutkey) {
          if (this.detailsWidgetData.pagination) {
            const ind = this.cutObj[index].ind - 1
            return ((this.current - 1) * this.pageSize) <= ind && ind < (this.current * this.pageSize)
          } else {
            return true
          }
        }
        return false
      }
    },
    // 此方法需要从所有数据里面查询到当前属于第几条
    getOperateInd (ind, key) {
      return this.detailsWidgetData.isCutDataConfig && this.cutkey ? (this.cutObj[ind].ind || ind + 1) : (key ? ind : ind + 1)
    },
    getTimeHHmm (val = '') {
      if (!val) return val
      const vv = val.split(':').slice(0, 2).join(':')
      return vv
    },
    getItt (formdata, item, value, key, ind, k1) {
      console.log('getItt')
      const type = item.title + '_' + item.type
      const e = formatDate(new Date(formdata[type]), "yyyy-MM-dd")
      const str = e + ' ' + value
      // this.$set(formdata, type, str)
      formdata.type = str
      switch (key) {
        case 1:
          this.approvalProcess(item, ind)
          break
        case 2:
          this.approvalProcess(item, ind, k1)
          break
      }
    },
    getTimeLabel (val, sels, defaultValue) {
      if (!val && defaultValue) {
        for (const i of sels) {
          if (i.value === defaultValue) return i.label
        }
      }
      if (!val || !sels || sels.length === 0) return val
      const v = val.split(' ')[1]
      for (const i of sels) {
        if (i.value === v) return i.label
      }
      return v ? v : val
    },
    getTimeYMD (val = '') {
      if (!val) return ''
      return formatDate(new Date(val), "yyyy-MM-dd")
    },
    getTimeYM (val = '') {
      if (!val) return ''
      const date = new Date(val)
      const y = date.getFullYear()
      let m = date.getMonth() + 1
      if (m < 10) m = '0' + m
      return y + '-' + m
    },
    // 查询当前显示控件总个数
    getShowControl (arr) {
      let co = 0
      for (const i of arr) {
        if (i.list && i.list > 0) {
          const type = i.title + '_' + i.type
          for (const a of this.formdata) {
            if (a[type] || a[type] === 0) co += i.list.length
          }
        }
        co += 1
      }
      return co
    },
    getDetailsWidth ({ title, type, width, widthFlex }, kk, fName) {
      // console.log('查询宽度', this.detailsWidgetData && this.detailsWidgetData.detailsTableType && this.detailsWidgetData.detailsTableType === 'flex')
      if (this.detailsWidgetData && this.detailsWidgetData.detailsTableType && this.detailsWidgetData.detailsTableType === 'flex') {
        if (this.widthObj[title + '_' + type]) {
          const vvv = kk ? { width: this.widthObj[title + '_' + type] } : 'width:' + this.widthObj[title + '_' + type] + ';'
          return vvv
        }
        const hc = (this.isInput && this.detailsWidgetData && this.detailsWidgetData.per==1 || !this.isInput && !this.detailsWidgetData.detailsNum && this.detailsWidgetData.per == 1 || this.modifyId) ? 35 : 0
        const wa = this.tableCellWidth - 50 - hc - 6

        const nTitle = (fName ? fName + '.' : '') + title
        if (this.detailsFlex && this.detailsFlex[nTitle]) {
          // const s1 = (wa * this.detailsFlex[nTitle] / 100)
          const s1 = (wa * this.detailsFlex[nTitle] / 100) - 21
          const sw1 = s1 + 'px'
          // console.log("s1==",s1,sw1)
          return kk ? { width: sw1, minWidth: sw1, maxWidth: sw1 } : 'width:' + sw1 + ';'
        }


        const count = this.getShowControl(this.detailsWidgetData.list)

        if (!widthFlex || widthFlex === '100%' && this.detailsWidgetData.list.length > 1) {
          const s1 = (wa / count) - 20
          // const s1 = (wa / count) - (kk ? 20 : 0)
          const sw = s1 + 'px'
          // console.log('宽度返回', sw)
          const kkk2 = kk ? { width: sw, minWidth: sw, maxWidth: sw } : 'width:' + sw + ';'
          return kkk2
          // return 'width:' + sw + ';'
          // return {
          //   width: sw,
          //   minWidth: sw,
          //   maxWidth: sw
          // }
        }
        const w = ((widthFlex.slice(0, widthFlex.length - 1)) / 100 * wa) - 20
        // const w = ((widthFlex.slice(0, widthFlex.length - 1)) / 100 * wa) - (kk ? 20 : 0)
        const ww = w + 'px'
        // console.log('减完的', name, ww, title, type, width, widthFlex, isHeader)
        const kkk1 = kk ? { width: ww, minWidth: ww, maxWidth: ww } : 'width:' + ww + ';'
        return kkk1
        // return { width: ww, minWidth: ww, maxWidth: ww }
      } else {
        let w = !this.widthObj[title + '_' + type] ? !width ? '180px;' : width : this.widthObj[title + '_' + type]
        if (!kk) {
          try {
            w = (Number(w.split('px')[0]) - 20) + 'px'
          } catch (err) { console.log(err) }
        }
        const vvv = kk ? { width: w } : 'width:' + w + ';'
        return vvv
        // return { width: kk ? '' : !this.widthObj[title + '_' + type] ? !width ? '180px;' : width : this.widthObj[title + '_' + type] }
      }
    },
    // 单选-多级选项值
    getRadioProvinces (key, config) {
      if (!key || !config || !config.multilevelConfig || !config.multilevelConfig.levelConfig) return key
      return this.getShowVal(key, config.multilevelConfig)
    },
    getShowVal (val, config) {
      if (!config.levelConfig || config.levelConfig.length === 0 || !val) return val
      const s = val.split(',')
      const e = []
      let levelConfig = JSON.parse(JSON.stringify(config.levelConfig))
      if (config.dataType === 'provinces') {
          for (const i of s) {
              if (levelConfig[i]) {
                  e.push(levelConfig[i].label)
                  levelConfig = levelConfig[i].children
              } else {
                  e.push(i)
              }
          }
          return e.join(',')
      } else {
          for (const i of s) {
              const a = levelConfig.findIndex(it => it.value === i)
              if (a !== -1) {
                  e.push(levelConfig[a].label)
                  levelConfig = levelConfig[a].children
              } else {
                  e.push(i)
              }
          }
          return e.join(',')
      }
    },
    fileDown (item, index) {
      this.$emit('down-file', { ...item, fatherField: this.detailsWidgetData.title + '_' + this.detailsWidgetData.type, faIndex: index  })
    },
    getStatistics () {
      // if (this.detailsWidgetData)
      const art = this.detailsWidgetData.list.filter(its => this.detailsWidgetData.statistics.includes(its.title + '_' + its.type) && !its.viewHide && its.per !== 3)
      const cont = Math.ceil(art.length / 3)
      const arr = []
      for (let i = 0; i < cont; i++) {
        let ar = art.slice(i * 3, (i + 1) * 3)
        if (ar.length < 3) ar = ar.concat(Array.from({length: 3 - ar.length}))
        arr.push(ar)
      }
      return arr
    },  
    getSwitchColor (opt = {}) {
      return getSwitchColor(opt)
    },
    // 明细-行使用方法
    getLinkContainerList () {
      const arr = []
      for (const i of this.detailsWidgetData.containerList) {
        if (i && i.length > 0) {
          const are = []
          for (const a of i) {
            const ind = this.detailsWidgetData.list.findIndex(it => it.title === a)
            if (ind !== -1) {
              this.detailsWidgetData.list[ind].containerListIndex = ind
              this.detailsWidgetData.list[ind].containerListWidth = this.detailsWidgetData.styleRatio[a]
              if (this.detailsWidgetData.list[ind].type === 'new-rel-radio' && this.detailsWidgetData.list[ind].styleRatio && this.detailsWidgetData.list[ind].list) {
                for (let s = 0; s < this.detailsWidgetData.list[ind].list.length; s++) {
                  const type = this.detailsWidgetData.list[ind].list[s].title
                  this.detailsWidgetData.list[ind].list[s].containerListWidth = this.detailsWidgetData.list[ind].styleRatio[type]
                }
              }
              are.push(this.detailsWidgetData.list[ind])
            }
          }
          if (are.length > 0) arr.push(are)
        }
      }
      return arr
    },
    getLinkContainerWidth (list) {
      const w = 'calc(' + list.containerListWidth + '% - 15px)'
      const obj = list.containerListWidth ? {
        width: w,
        minWidth: w,
        maxWidth: w
      } : {}
      if (list.type === 'relation-check') obj.overflowX = 'auto'
      return obj
    },
    // 明细-行使用方法 end
    getBackk (config) {
      let obs = ''
      const obj = widgetJs.getLabelBackk(config)
      for (const i in obj) {
        obs += (i + ':' + obj[i] + ';')
      }
      return obs
    },
    // 播放音乐
    async playFun (val, fileDocument) {
      const url = this.$url + val.response
      if (fileDocument === 'music') {
        this.$musicPlayer().paly(url)
      } else if(fileDocument === 'video') {
        this.$videoPlayer().paly(url)
      }
    },
    // 单选显示值匹配
    getRadioLabel (val, item) {
      if (!item || item.length === 0) return val
      for (const i of item) {
        if (i.value === val) return i.label
      }
      return val
    },
    // 手动触发关联单选的选择
    openRel (key) {
      try {
        const dom = this.$refs[key]
        if (dom) {
          (dom[0] || dom).openS()
        }
      } catch(e) { console.log(e) }
    },
    // ps：这个更新方式需要更换
    async openRelUp (item, index) {
      console.log('关联', item, index)
      const res = item.title + '_' + index
      const dom = this.$refs[res]
      let doms = null
      try {
        doms = dom[0].getBoundingClientRect()
        console.log('查看demo信息', doms)
        // this.$set(this.relevancyAddress, 'y', !this.relevancyShowObj[type] ? (doms.top - 20) : 0)
        // this.$set(this.relevancyAddress, 'w', !this.relevancyShowObj[type] ? (doms.width) : 0)
        this.relevancyAddress['y'] = !this.relevancyShowObj[type] ? (doms.top - 20) : 0
        this.relevancyAddress['w'] = !this.relevancyShowObj[type] ? (doms.width) : 0
      } catch(e) {console.log(e)}
      const type = item.title + '_' + item.type + '_' + index
      // this.$set(this.relevancyShowObj, type, !this.relevancyShowObj[type])
      this.relevancyShowObj.type = !this.relevancyShowObj[type]
      try {
        await this.$nextTick()
        setTimeout(() => {
          // this.$set(this.relevancyAddress, 'x', this.relevancyShowObj[type] ? (doms.left - 20) : 0)
          this.relevancyAddress['x'] = this.relevancyShowObj[type] ? (doms.left - 20) : 0
        }, 10)
      } catch (e) { console.log(e) }
    },
    getHeaderWidth () {
      const id = this.detailsWidgetData.title + "_" + "2";
      const dom = this.$refs[id];
      const domHeader = document.getElementsByClassName('header')
      const tableCellWidth = dom.offsetWidth;
      if (domHeader && domHeader[0]) {
        const tableWidth = domHeader[0].scrollWidth || domHeader[0].cellWidth;
        this.tableWidth = tableWidth
        console.log('值变更', tableCellWidth)
        this.tableCellWidth = tableCellWidth
      }
    },
    // 查询是否有关联单选值变更等
    async getRelShow () {
      const rel = (this.detailsWidgetData.list || []).filter(its => its.type === 'new-rel-radio')
      const relObj = {}
      for (const i of this.formdata || []) {
        for (const a of rel) {
          const type = a.title + '_' + a.type
          if (i[type]) relObj[type] = true
        }
      }
      // this.$set(this, 'relShowObj', relObj)
      this.relShowObj = relObj
      await this.$nextTick()
      if (JSON.stringify(relObj) !== '{}') this.getHeaderWidth()
    },
    setAi (val, index) {
      let obj = null
      if (val) {
        obj = {
          fType: this.detailsWidgetData.title + '_' + this.detailsWidgetData.type,
          index: index,
          type: 'details',
          title: val.title + '_' + val.type
        }
      }
      this.$emit('setAi', obj)
    },
    getHide (item) {
      return !item.viewHide
    },
    getImgRadio (item, val) {
      return item.selsItemImg && item.selsItemImg[val] ? this.$imgurl + item.selsItemImg[val] + '?accesstoken=' + filesConfig() : ''
    },
    // 单选样式判断
    getRadioTypes (list, sels) {
      const obj = {}
      if (list.types && list.types === 2) {
        obj.color = list.selsItemColor && list.selsItemColor[sels] ? list.selsItemColor[sels] : '#c0c4cc'
      } else if (list.types && list.types === 3) {
        const color = list.selsItemColor && list.selsItemColor[sels] ? list.selsItemColor[sels] : '#c0c4cc'
        obj.color = color
        obj.border = '1px solid ' + color
        obj.padding = '4px 8px'
        obj.borderRadius = '4px'
      } else {
        const color = list.selsItemColor && list.selsItemColor[sels] ? list.selsItemColor[sels] : ''
        obj.backgroundColor = color
        obj.color = list.selsItemColor && list.selsItemColor[sels]?'#fff':''
        obj.padding = '4px 8px'
        obj.borderRadius = '10px'
      }
      return obj
    },
    //联系人控件快速录入的回调
    userCheckCallback(data, indexs, value, param) {
      const obj = {
        data: { ...data },
        indexs: indexs,
        finx: this.detailsIndex,
        finxType:
          this.detailsWidgetData.title + "_" + this.detailsWidgetData.type,
        type: 1,
        checkedUserArr: param.user
      };
      obj.data.bindinf = value; // 值给过去暂用
      this.linkedWd = {}
      this.$emit("detailsFastRelUers", obj);
    },
    numDecimal(e,num){
      let value = e.target.value
      let valueArr = value.split('.')
      if(num === null||!valueArr[1]||valueArr[1].length<=0) return false
      value = e.target.value.replace(/[^\d.-]/g, '') // 清除“数字”和“.”以外的字符
        .replace(/\.{2,}/g, '.') // 只保留第一个. 清除多余的
        .replace(/\.{2,}/g, '-') // 只保留第一个-清除多余的
        .replace('.', '$#$')
        .replace(/\./g, '')
        .replace('$#$', '.')
      if(value.split('.')[1].length>num){
        value = Number(value).toFixed(num)
      }
      e.target.value = value
    },
    isWYFN (item, isSet, listsIndex) {
      if (isWY(item) && isSet) {
        const decimal = 4 + (item.format.decimal || 0)
        const field = `${item.title}_${item.type}`
        // this.$set(this.tempFormdata, field, (this.formdata[field] / 10000).toFixed(decimal))
        this.tempFormdata.field = (this.formdata[field] / 10000).toFixed(decimal)
        if (this.tempFormdata[listsIndex] !== undefined) {
          // this.$set(this.tempFormdata[listsIndex], `${item.title}_${item.type}`, (this.formdata[listsIndex][`${item.title}_${item.type}`] / 10000).toFixed(decimal))
          this.tempFormdata[listsIndex][`${item.title}_${item.type}`] = (this.formdata[listsIndex][`${item.title}_${item.type}`] / 10000).toFixed(decimal)
        } else {
          this.tempFormdata.push({
            [`${item.title}_${item.type}`]: (this.formdata[listsIndex][`${item.title}_${item.type}`] / 10000).toFixed(decimal)
          })
        }
      }
      return isWY(item)
    },
    setOriginalData (item, listsIndex) {
      const field = `${item.title}_${item.type}`
      if (this.tempFormdata[listsIndex][field] * 10000 !== this.formdata[listsIndex][field]) {
        // this.$set(this.formdata[listsIndex], field, this.tempFormdata[listsIndex][field] * 10000)
        this.formdata[listsIndex][field] = this.tempFormdata[listsIndex][field] * 10000
      }
    },
    // 千分符和保留小数点cc
		numberFormat (value,format) {
      const decimal = format.decimal //小数点
      let str = Number(value).toFixed(decimal)
      if (format.value === 'currency' && format.currency === '万元') {
        str =  formatWY(value, decimal)
      }
      // 千分符
      if((format.value==='number' || format.value==='currency') && format.separator){
        let num = str.split('.')
        var reg=/\d{1,3}(?=(\d{3})+$)/g
        num[0] = (num[0] + '').replace(reg, '$&,')
        str = num.join('.')
      } else if(format.value==='percentage'){ // 百分比
        str = (value * 100).toFixed(decimal)
      }
      return isNaN(str) ? format.value==='number' || format.value==='currency' && format.separator ? str : 0 : str
		},
    escapeRegex(string) {
      return string.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&');
    },
    // 这个方法只给一级控件的 单多行、单多选 控件 使用
    async conditionLink (item) {

      if (item.dataconfig && item.dataconfig.linked && item.dataconfig.linked.conditional.length === 0 && item.dataconfig.linked.resultdata.length > 0) {
      // if (item.dataconfig && item.dataconfig.setUpValue && item.dataconfig.setUpValue === 3 && item.dataconfig.linked && item.dataconfig.linked.conditional.length === 0 && item.dataconfig.linked.resultdata.length > 0) {
        if (item.type === 'text') {
          this.conditionLinkObj = {
            type: false,
            dataconfig: item.dataconfig
          }
        } else {
          // 去无条件联动
          console.log(222222222)

          const res = await getlinkeddatalist({type: false, dataconfig: item.dataconfig}).catch(err => { console.log(err) })
          if (res.code === 0) {
            // this.$set(item, 'sels', JSON.stringify(res.data) || '[]')
            item['sels'] = JSON.stringify(res.data) || '[]'
          }
        }
      }
    },

    //删除图片列表数据
    deleteImg(target,index){
      target.splice(index,1)

    },
    // 点击显示
    setOnShow (index, item, val) {
      const type = item.title + '_' + item.type;
      // this.$set(this.onShowObj, (index + type), !val)
      this.onShowObj[index + type] = !val
    },
    // 获取dom基础信息
    async getSys () {
      await this.$nextTick()
      const id = this.detailsWidgetData.title + "_" + "2";
      const dom = this.$refs[id];
      if (dom) {
        const domHeader = dom.getElementsByClassName('header')
        if (domHeader && domHeader[0]) {
          const tableWidth = domHeader[0].scrollWidth || domHeader[0].cellWidth;
          const tableCellWidth = dom.offsetWidth;
          if (tableCellWidth < tableWidth) {
            dom.removeEventListener("scroll", this.distanceFun);
            dom.addEventListener("scroll", this.distanceFun, 1000);
          }
          this.tableWidth = tableWidth
          console.log('值变更1', tableCellWidth)
          this.tableCellWidth = tableCellWidth
        }
      }
    },
    // 放开
    mouseOpen (e) {
      this.distanceFun(e)
      this.isMouseup = false
      document.removeEventListener('mouseup', this.mouseOpen)
    },
    // 转冻结列
    getFreezeCol (val) {
      if (val && this.detailsWidgetData.list && this.detailsWidgetData.list.length > 0) {
        let count = 0
        const obj = {}
        for (const item of this.detailsWidgetData.list) {
          count += 1
          obj[item.title + '_' + item.type] = true
          if (item.list && item.list.length > 0) {
            for (const items of item.list) {
              count += 1
              obj[items.title + '_' + items.type] = true
              if (count === val) {
                break
              }
            }
          }
          if (count === val) {
            break
          }
        }
        this.freezeObj = obj
      }
    },
    // 时间格式转化
    timeWeek (time) {
      return getWeek(time)
    },
    // 暂无数据
    nullFun(val) {
      let isNull = true;
      if (val.length === 0) {
        return true;
      } else if (val.length === 1) {
        for (const item in val[0]) {
          if (val[0][item] && JSON.stringify(val[0][item]) !== "[]") {
            isNull = false;
            break;
          }
        }
      }
      return isNull;
    },
    // 更新汇总
    upSummary() {
      const val = copyObj(this.formdata);
      console.log("aaaa==",val,this.detailsWidgetData);
      
      const obj = this.detailsWidgetData.statistics || "";
      if (val && val.length > 0 && obj) {
        const summaryObj = {};
        for (const i of val) {
          for (const item of obj) {
            const itemVal = i[item] || 0;
            summaryObj[item] = accAdd(summaryObj[item] || 0, itemVal);
          }
        }
        this.summaryObj = summaryObj;
      }
    },
    // 横向滚动触发
    distanceFun(e) {
      if (e.target.className === 'details-table-all') {
        // 监听鼠标放开事件做一次兼容
        if (!this.isMouseup) {
          document.addEventListener("mouseup", this.mouseOpen)
          this.isMouseup = true
        }
        this.topDistance = e.target.scrollLeft;
      }
    },
    // 返回下月
    nextMonthFun(val) {
      return thisNoTime(val);
    },
    // 时间限制
    pickerOptionsLimit(val) {
      if (this.modifyId) return "";
      return limitDate(val.limit || "", val.dayWeek || "");
    },
    sliceEncrypt(str, encrypt) {
      return sliceEncrypt(str, encrypt);
    },
    classFun(e, val, othersVal) {
      return retClassName(e, this.isOne, null, val, othersVal);
    },
    objSels(data, item) {
      let date = data ? JSON.parse(JSON.stringify(data)) : []
      if (item && item.dataconfig && item.dataconfig.setUpValue && (item.dataconfig.setUpValue === 2 || item.dataconfig.setUpValue === 1 && item.dataconfig.downType && item.dataconfig.downType === 'dictionary')) {
        if (typeof date === 'string') {
          try {
            date = JSON.parse(date)
          } catch (err) { console.log(err) }
        }
        if (item.type === 'checkbox') {
          date = date.concat((item.dictionary || []).map(it => it.value))
        } else {
          date = date.concat(item.dictionary)
        }
      }
      //选择框格式转换
      // return widgetJs.objSels(data);
      return widgetJs.objSels(date).filter(it => it || it === 0);
    },
    selectAllCheck(val) {
      const checkObj = [];
      if(this.formdata === undefined) return
      this.formdata.map(vals => {
        console.log("vals==",vals);
        checkObj.push(val);
      });
      this.checkObj = checkObj;
    },
    handleCheckAllChange(val) {
      if (val) {
        this.checkList = [...Array(this.formdata.length).keys()];
        this.selectAllCheck(true);
      } else {
        this.checkList = [];
        this.selectAllCheck(false);
      }
      // this.checkList = val ? [...Array(this.formdata.length).keys()] : [];
    },
    checkFun(val) {
      // 查找是否存在，存在的话删掉，不存在就添加
      const index = this.checkList.indexOf(val);
      if (index === -1) {
        this.checkList.push(val);
      } else {
        this.checkList.splice(index, 1);
      }
      if (this.checkList.length === this.formdata.length) {
        this.checkAll = true;
      } else {
        this.checkAll = false;
      }
    },
    async querySearchAsync(queryString, cb) {
      // 如果开启了数据选项
      if (this.conditionLinkObj) {
        const res = await getlinkeddatalist(this.conditionLinkObj).catch(err => { console.log(err) })
        if (res.code === 0) {
          const val = (res.data || []).map(its => { return {value: its} })
          const results = queryString
                ? val.filter(this.createFilter(queryString))
                : val;
              cb(results);
          // cb(val)
        } else {
          cb([])
        }
        return;
      }

      if (this.autocompleteText) {
        const item = this.autocompleteText.val;
        const index = this.autocompleteText.index;
        const detailKey = {
          key: this.detailsWidgetData.title + "_" + this.detailsWidgetData.type,
          index: index
        };
        if (
          item &&
          this.autocompleteText.changesels &&
          item.dataconfig &&
          item.dataconfig.setUpValue != 2 &&
          item.dataconfig.linked &&
          item.dataconfig.linked.conditional.length > 0
        ) {
          const param = linkedSetEvent(
            item.dataconfig,
            this.formdatas,
            detailKey
          );
          if (param) {
            getlinkeddatalist(param).then(res => {
              const sels = linkedFormatConversion(
                { type: "checkbox" },
                res.data
              );
              item.sels = res.data ? JSON.stringify(sels) : "[]";
              const ars = sels.map(vals => {
                return {
                  value: vals
                };
              });
              const results = queryString
                ? ars.filter(this.createFilter(queryString))
                : ars;
              cb(results);
            });
          } else {
            const results = this.querySearchAsyncCb(queryString);
            cb(results);
          }
        } else {
          const results = this.querySearchAsyncCb(queryString);
          cb(results);
        }
      } else {
        const results = this.querySearchAsyncCb(queryString);
        cb(results);
      }
    },
    querySearchAsyncCb(queryString) {
      const restaurants = this.restaurants;
      const results = queryString
        ? restaurants.filter(this.createFilter(queryString))
        : restaurants;
      return results;
    },
    createFilter(queryString) {
      return restaurant => {
        return new RegExp(queryString.toLowerCase()).test(
          restaurant.value.toLowerCase()
        );
      };
    },
    autocompleteFun(val, changesels, index) {
      this.inputChange = false;
      /**
       * selschange这个是联动，获取sels的值，替换当前的sels
       */
      this.selschange(changesels, val, index);
      /**
       * 再去改变sels的格式，给下拉框使用
       */
      if (val.sels && val.sels.length > 0) {
        this.restaurants = JSON.parse(val.sels).map(val => {
          return { value: val };
        });
      } else {
        this.restaurants = [];
      }
    },
    handleSignet(command) {
      this.$emit("signetdetail", command, 0);
    },
    handleListSignet(command) {
      this.$emit("signetdetail", command, 1); // true为批量
    },
    ondocfileconf(command) {
      this.$emit("signetdetail", command, 2); // 存证
    },
    handleFileDown(command, isEdit = false) {
      //附件下载
      this.$emit("signetdetail", command, 3, isEdit); // 附件下载
    },
    handleCommand(e) {
      //点击下拉内容回调数据给输入框
      const type = e.item2.title + "_" + e.item2.type;
      this.formdata[e.scopeIndex][type] = e.popoverList;
      this.approvalProcess(e.item2, e.scopeIndex);
    },
    returnImage(data, index) {
      const param = {
        dataImg: data,
        indexImg: index
      };
      this.$emit("previewPictureImg", param);
    },
    radioBlurChange(key, show, item, index){
      // this.$set(this.radioBlur, key, show ? true : false)
      this.radioBlur[key] = show ? true : false
      if(item) {
        this.selschange(show, item, index)
      }
    },
    selschange(show, item, index) {
      //审批和修改的时候点击选项使用的，show为下拉框显示，item为当前项目，detailKey是给子明细使用
      const detailsType =
        this.detailsWidgetData.title + "_" + this.detailsWidgetData.type;
      const detailKey = { key: detailsType, index: index };
      if (
        show &&
        item.dataconfig &&
        item.dataconfig.setUpValue != 2 &&
        item.dataconfig.linked &&
        item.dataconfig.linked.conditional.length > 0
      ) {
        const param = linkedSetEvent(
          item.dataconfig,
          this.formdatas,
          detailKey
        );
        if (param) {
          getlinkeddatalist(param).then(res => {
            // this.$set(
            //   item,
            //   "sels",
            //   JSON.stringify(
            //     linkedFormatConversion({ type: "checkbox" }, res.data)
            //   )
            // );
            item['sels'] = JSON.stringify(
              linkedFormatConversion({ type: "checkbox" }, res.data)
            )
          });
        } else {
          // this.$set(item, "sels", "[]");
          item['sels'] = '[]'
        }
      }
    },
    autocompleteTextFun(val, changesels, index) {
      this.inputChange = false;
      // 如果是联动相关直接清空
      if (
        val.dataconfig &&
        val.dataconfig.setUpValue !== 2 &&
        val.dataconfig.linked
      ) {
        val.sels = "[]";
        this.restaurants = [];
      } else {
        if (val.sels && val.sels.length > 0) {
          this.restaurants = JSON.parse(val.sels).map(val => {
            return { value: val };
          });
        } else {
          this.restaurants = [];
        }
      }
      this.autocompleteText = {
        val: val,
        changesels: changesels,
        index: index
      };
    },
    autoinputFun(val, item, index) {
      this.inputChange = true;
      if(item && item.type === 'text' && Number(item.disSearch) === 2){
        // 只允许数字、负号、小数点
        const valid = /^-?\d*(\.\d*)?$/.test(val);
        if (!valid && val !== ''){
          console.log("233123")
          const type = item.title + "_" + item.type;
          this.$message.error('输入错误，只能输入数字.-');
          this.formdata[index][type] = null
          // this.$set(this.formdata[index], type, null);
          return;
        }
      }
    },
    // vue3 更新formdata
    handleFormdataUpdata(item, value) {
      console.log("item, value==",item, value);
      const key = item.title + '_' + item.type
      // 更新特定的字段
      this.formdata[key] = value
    },    
    approvalProcess(item, index, newrel) {
      // 仅查看 这个功能需要重置值
      if (item.queryOnly && item.dataconfig && item.dataconfig.setUpValue && ((item.type !== 'radio' && item.dataconfig.setUpValue === 3) || (item.type === 'radio' && item.dataconfig.setUpValue === 1))) {
        const type = item.title + "_" + item.type;
        this.formdata[index][type] = null
        return ;
      }
      //返回回去配置明细联动inputChange 有值，来源于单行输入框的下来选择
      // 如果有其他需要进行一次判断
      if (item.others) {
        const type = item.title + "_" + item.type;
        const fType =
          this.detailsWidgetData.title + "_" + this.detailsWidgetData.type;
        const val = this.formdata[index][type];
        let chang = true;
        try {
          if ((typeof item.sels === 'string' ? JSON.parse(item.sels) : item.sels).findIndex(ite => (ite.value || ite) === val) === -1) chang = false;
          // if (JSON.parse(item.sels).indexOf(val) === -1) chang = false;
        } catch (e) {
          console.log(e);
        }
        if (!chang) {
          if (!this.othersObj[fType]) this.othersObj[fType] = [];
          if (!this.othersObj[fType][index]) this.othersObj[fType][index] = {};
          this.othersObj[fType][index][type] = "";
        } else {
          if (
            this.othersObj[fType] &&
            this.othersObj[fType][index] &&
            (this.othersObj[fType][index][type] ||
              this.othersObj[fType][index][type] === "")
          )
            delete this.othersObj[fType][index][type];
        }
      }
      if (!this.inputChange && item.type === "text") {
        return false;
      }
      if (
        this.detailsWidgetData &&
        this.detailsWidgetData.list &&
        this.detailsWidgetData.list.length > 0
      ) {
        const detailsWidgetDataList = this.detailsWidgetData.list;
        const detailsType =
          this.detailsWidgetData.title + "_" + this.detailsWidgetData.type;
        if (newrel || newrel == 0) {
          //如果有值就是联系人
          this.$emit(
            "linkageMethEachEmit",
            detailsWidgetDataList,
            item,
            newrel,
            { key: detailsType, index: index }
          );
        } else {
          for (let [i, el] of detailsWidgetDataList.entries()) {
            if (el.title === item.title) {
              this.$emit(
                "linkageMethEachEmit",
                detailsWidgetDataList,
                item,
                i,
                { key: detailsType, index: index }
              );
            }
          }
        }
      }
    },
    // 删除
    delWidget(index) {
      // 先删除列表的
      this.checkObj.splice(index, 1);
      this.formdata.splice(index, 1);
      if (this.formdata.length === 0) {
        this.formdata.push(momVal(this.detailsWidgetData.list, "no"));
      }
      // 如果关联单选对应有值就删掉
      if (
        this.userHide[this.detailsWidgetData.title] &&
        this.userHide[this.detailsWidgetData.title][index]
      ) {
        this.userHide[this.detailsWidgetData.title].splice(index, 1);
      }
      this.$emit("linkageMethEachEmit", undefined, undefined, undefined, {
        key: this.detailsWidgetData.title + "_" + this.detailsWidgetData.type
      });
      this.upToAllFormdata();
    },
    upToAllFormdata() {
      // 当前是发起页面的话走

      // 删除的需要再走一次同步流程 (明细走一次模板赋值就行了,会统一起来)
      const date =
        this.detailsWidgetData && this.detailsWidgetData.list
          ? this.detailsWidgetData.list
          : [];
      // 第一条数据
      const formdataOne = this.formdata[0] || {};
      for (let i = 0; i < date.length; i++) {
        if (date[i].type === "relation-user") {
          // 是联系人的话走
          const res = JSON.parse(JSON.stringify(date[i]));
          const type = res.title + "_" + res.type;
          res.finx = this.detailsIndex;
          res.checkedUserArr = formdataOne[type];
          // this.$parent.orgChoiceMethod(res);
          this.$emit("retOrgChoiceMethod", res);
        }
      }
    },
    //联系人控件--删除操作 index是多选联系人，删除哪个联系人，indexs第几行
    handleCloseFlow(data, index, indexs) {
      console.log(data, index, indexs);
      // return
      const param = {
        data: data,
        index: index,
        indexs: indexs,
        finx: this.detailsIndex,
        finxType:
          this.detailsWidgetData.title + "_" + this.detailsWidgetData.type,
        type: 2
      };
      this.$emit("detailsWidgetRelUers", param);
    },
    getUpcontroll (item) {
      return item.upcontroll && this.modify
    },
    async editUser (user, item, event) {
      // 修改页面才可以修改用户信息
      // pageId 5 关于我的 7 全部数据 1 个人数据
      const pageObj = {
        1: 'person',
        5: 'about',
        7: 'all',
      }
      if (this.modify && item.isMoreInfo && item.isUserEidt && item.userEidtInfo) {
        const { userInfo, page } = item.userEidtInfo
        if (page && page[pageObj[this.pageId]]) {
          event.stopPropagation();
          if (Object.keys(userInfo).length === 0) {
            return this.$message.warning('未选择可编辑字段')
          } else {
            const { data } = await getapiuserlist({userids: user.userId, curpage: 0, pagesize: 1})
            if (data && data[0]) {
              const param = {
                editUserInfoKey: userInfo,
                editUserInfo: data[0]
              }
              this.$emit("detailsEditUers", param);
            } else {
              this.$message.warning('用户不存在')
            }
          }
        }
      }
    },
    expandUser (index, flag) {
      // this.$set(this.isExpandList, index, flag)
      this.isExpandList[index] = flag
    },
    isExpand (index) {
      let flag = false
      if (this.isExpandList[index]) {
        flag = true
      }
      return flag
    },
    //联系人控件--选择组织index是多选联系人，删除哪个联系人，indexs第几行
    relationUserChoice(data, indexs, value, fromBtn = 'default') {
      const param = {
        data: { ...data },
        indexs: indexs,
        finx: this.detailsIndex,
        finxType:
          this.detailsWidgetData.title + "_" + this.detailsWidgetData.type,
        type: 1,
        fromBtn: fromBtn
      };
      if(fromBtn == 'defaultSearch') {        
        param.searchKey = this.linkedWd[data.title + '_' + data.type + '_' + indexs]
        console.log("asdasd==",param.searchKey)
      }
      console.log("param===1",param)
      param.data.bindinf = value; // 值给过去暂用
      this.trIndex = indexs
      this.$emit("detailsWidgetRelUers", param);
    },
    // 联系人控件-数据显示
    showUserList(data, list, params, searchKey) {
      let relationUserRef = "relationUserRef_" + data.title;
      let linkedDropDownRef = "linkedDropDownRef_" + data.title;
      if(searchKey){
        this.$refs[linkedDropDownRef][this.trIndex].getList(data, list, params, this.$refs[relationUserRef][this.trIndex].getBoundingClientRect(), searchKey);        
      }
      else{
        this.$refs[linkedDropDownRef][this.trIndex].getList(data, list, params, this.$refs[relationUserRef][this.trIndex].getBoundingClientRect());
      }
    },
    // 联系人控件-查找优化
    showNewUserList(data, params, searchKey){
      let relationUserRef = "relationUserRef_" + data.title;
      let linkedDropDownRef = "linkedDropDownRef_" + data.title;
      if(searchKey){
        this.$refs[linkedDropDownRef][this.trIndex].getNewList(data, params, this.$refs[relationUserRef][this.trIndex].getBoundingClientRect(), searchKey);
      }
      else{
        this.$refs[linkedDropDownRef][this.trIndex].getNewList(data, params, this.$refs[relationUserRef][this.trIndex].getBoundingClientRect());
      }
    },
    showBatchSearch(data, indexs){
      const param = {
        data: data,
        indexs: indexs,
        finx: this.detailsIndex
      };
      this.$emit("detailsShowBatchSearch", param);
    },
    //单选关联控件
    relationRadio(res, typeOr, index) {
      //typeOr==2关联多选
      const param = {
        type: 3,
        data: res
      };
      if (typeOr == 1) {
        this.detailsWidgetEmitData = res;
        if (this.detailsIndex || this.detailsIndex === 0)
          param.index = this.detailsIndex;
        if (index) param.listIndex = index;
        if (
          this.detailsWidgetData.detailsNum &&
          Number(this.detailsWidgetData.detailsNum) > 0
        )
          param.detailsNum = this.detailsWidgetData.detailsNum;
      } else {
        param.indexs = index;
        param.finx = this.detailsIndex;
        param.finxType =
          this.detailsWidgetData.title + "_" + this.detailsWidgetData.type;
        param.typeOr = 2;
      }
      this.$emit("detailsWidgetRelUers", param);
      // res.bindinf = '测试';
      //this.$refs.oaExamineAssFormRef.oaExamineAssChildMethod(data);
    },
    onRelCondition(param) {
      this.$emit("detailsWidgetRelUers", { type: 5, param: param });
    },
    // 返回联动e联动里面的模板，a为关联单选在明细里面第几个，ind为明细里面的行数
    onLinkageNewRel(e, a, ind) {
      for (let i = 0; i < e.length; i++) {
        this.$emit(
          "linkageMethEachEmit",
          this.detailsWidgetData.list || [],
          e[i],
          0,
          {
            key:
              this.detailsWidgetData.title + "_" + this.detailsWidgetData.type,
            index: ind
          }
        );
      }
    },
    // { key: detailsType, index: index}
    // 父组件调用的批量删除方法 val(防止title不对)
    batchDel(val) {
      if (val === this.detailsWidgetData.title && this.checkList.length > 0) {
        const checkObj = JSON.parse(JSON.stringify(this.checkObj));
        let checkList = JSON.parse(JSON.stringify(this.checkList));
        // 排序在删除
        checkList = checkList.sort((a, b) => {
          return b - a;
        });
        // 原数据不可改，批量删除得跳过原数据
        if(this.checkList.length == this.formdata.length && this.dataModifyLen > 0) {
          checkList.length = checkList.length - this.dataModifyLen;
        }
        for (let i = 0; i < checkList.length; i++) {
          checkObj.splice(checkList[i], 1);
        }
        this.checkObj = checkObj;
        this.checkList = [];
        this.checkAll = false;
        return checkList;
      }
      return [];
    },

    /* 图片、附件 start */
    //附件预览
    file_pvw(item) {
      this.$emit("signetdetail", item, 4);
    },
    //点击获取当前下表
    listCli(colIndex, index, config, val) {
      if (this.upDataFile) {
        if (config && config.upNumber <= val.length) {
          this.$message.error('最多只能上传'+ config.upNumber + '个文件！')
          return
        }
        this.indexNumber = index;
        this.colIndex = colIndex;
      } else {
        this.$message({
          message: "上传中，请稍等...",
          type: "warning"
        });
        return false;
      }
    },
    //鼠标经过获取下标值。删除用
    listCliRemo(colIndex, index) {
      this.removeColI = colIndex;
      this.removeIndN = index;
    },
    //图片上传
    handleProgress(file) {
      if (file.name) {
        file.name = file.name.replace(/^#+|#|#+$/g, "");
      }
      this.upDataFile = false;
    },
    //图片，附件上传打开本地文件夹
    handlePreview(file) {
      this.file_pvw({url:file.response})
    },
    //图片，附件上传。上传成功
    handleSuccess(response, file, fileList) {
      const type =
        this.detailsWidgetData.list[this.indexNumber].title +
        "_" +
        this.detailsWidgetData.list[this.indexNumber].type;
      this.formdata[this.colIndex][type] = fileListForeach(fileList);
      this.fileListLength = this.fileListLength - 1;

      if (this.fileListLength == 0) {
        this.upDataFile = true;
      }
    },
    handleError() {
      this.fileListLength = this.fileListLength - 1;
      this.upDataFile = true;
    },
    // 官网的图片处理
    imgUrlHandle(val){
      const imgName = this.$url + '/confiles/' + val.split('/')[2]
      return imgName
    },
    //图片,附件删除
    handleRemove(file, fileList) {
      const type =
        this.detailsWidgetData.list[this.removeIndN].title +
        "_" +
        this.detailsWidgetData.list[this.removeIndN].type;
      this.formdata[this.removeColI][type] = fileList;
    },
    // 清空签名板
    handleReset () {
      this.$refs.esign.reset()
    },
    showSigna(val,index){
      // 新增：图片上传数量限制
      const type = val.title + '_' + val.type;
      const curList = this.formdata[index][type] || [];
      if (curList.length >= Number(val.upNumber)) {
        this.$message.error('最多只能上传' + val.upNumber + '张图片！');
        return false;
      }
      this.signaVisible = true
      this.indexString = val
      this.signa_index = index
      this.uploadSignStatus = val.uploadSign
      // 调用webSocket
      webSocketClass.constructor("wss://user.topeti.com/webmessage", this.websocketMessageHandler.bind(this));
      webSocketClass.connect('立即与服务器通信');
    },
    websocketMessageHandler(e) {
      if(e.action === "connected"){
        let userAgent
        if (navigator && navigator.userAgent) {
          userAgent = navigator.userAgent;
        }
        this.vueqrval = this.$url + "/cust/sign/index.html?code="+e.msg.token+'&accesstoken='+this.token+'&userAgent='+encodeURIComponent(userAgent)
        console.log("this.vueqrval==",this.vueqrval);
      }
      else if(e.action === "upload"){
        let type = this.indexString.title + "_" + this.indexString.type
        let signList = this.formdata[this.signa_index][type]
        signList.push({response: e.msg.url})
        this.formdata[this.signa_index][type] = fileListForeach(signList)
        this.signaVisible = false
      }
    },
    // 删除签名
    deleteSign(val,item,index){
      console.log(val,item);
      this.signa_index = index
      let type = item.title + "_" + item.type
      let signList = this.formdata[this.signa_index][type]
      signList = signList.filter(value => {
        return value.response != val.response
      });
      this.formdata[this.signa_index][type] = signList;
    },
    base64ImgtoFile(dataurl, filename = 'file') {
      const arr = dataurl.split(',')
      const mime = arr[0].match(/:(.*?);/)[1]
      const suffix = mime.split('/')[1]
      const bstr = atob(arr[1])
      let n = bstr.length
      const u8arr = new Uint8Array(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      return new File([u8arr], `${filename}.${suffix}`, {
        type: mime
      })
    },
    // 上传签名
    uploadSign() {
      const fileInput = document.getElementById('upload-file');
      const file = fileInput.files[0];
      const fileExtension = file.name.slice(file.name.lastIndexOf('.') + 1);
      if (fileExtension === 'png') {
        const formData = new FormData()
        const token = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')).accesstoken : ''
        formData.append("file", file)
        let url = '/userfile/upload?accesstoken='+token
        let config = {
          headers:{
            'Content-Type':'multipart/form-data',
          },
        };
        let type = this.indexString.title + "_" + this.indexString.type
        Axios.post(url, formData, config)
          .then(res => {
            if(res.data){
              let signList = this.formdata[this.signa_index][type]
              signList.push({response: res.data})
              this.formdata[this.signa_index][type] = fileListForeach(signList)
              this.signaVisible = false
            }
          }).catch(err => {
            console.log('图片上传错误', err)
        })
      } else {
        // 提示用户选择正确格式的文件
        this.$message.error('上传签名图片必须为.png格式')
        return 
      }
    },
    // 签名生成图片
    async upSigna() {        
      this.$refs.esign.generate().then(res => {
        const loading = this.$loading({
          lock: true,
          text: '签名上传中',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.1)'
        });
        const blob = this.base64ImgtoFile(res,'name')
        const name = 'name.png'
        const file = new File([blob], name, {
          type: 'image/png'
        })
        const formData = new FormData()
        const token = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')).accesstoken : ''
        formData.append("file", file)
        let url = '/userfile/upload?accesstoken='+token
        let config = {
          headers:{
            'Content-Type':'multipart/form-data',
          },
        };
        let type = this.indexString.title + "_" + this.indexString.type

        Axios.post(url, formData, config)
          .then(res => {
            this.token = JSON.parse(localStorage.getItem('user')).accesstoken
            let signList = this.formdata[this.signa_index][type]
            signList.push({response: res.data})
            this.formdata[this.signa_index][type] = fileListForeach(signList)
            this.signaPic = true
            this.signaVisible = false
            loading.close()
            this.$refs.esign.reset()
          }).catch(err => {
            console.log('图片上传错误', err)
        })
      }).catch(err => {
        // 画布没有签字时提示
        this.$message.error('您还没有签名', err)
      })
    },
    // 限制图片上传数量
    handleExceed(file, fileList, item){
      console.log("fileListfileList==",fileList)
      if (fileList.length >= Number(item.upNumber)) {
        this.$message.error('最多只能上传' + item.upNumber + '张图片！');
        return false;
      }
    },
    //图片上传
    beforeImgUpload(file) {
      this.fileListLength += 1;
      this.upDataFile = false;
      const isJPG = file.type === "image/jpeg";
      const isPNG = file.type === "image/png";
      const isGIF = file.type === "image/gif";
      const isLt2M = file.size / 1024 / 1024 < 5;

      if (!isJPG && !isPNG && !isGIF) {
        this.fileListLength -= 1;
        this.upDataFile = true;
        this.$message.error("上传图片只能是 jpeg/png/gif 格式!");
      }
      if (!isLt2M) {
        this.fileListLength -= 1;
        this.upDataFile = true;
        this.$message.error("上传图片大小不能超过 5MB!");
      }
      return (isJPG && isLt2M) || (isPNG && isLt2M) || (isGIF && isLt2M);
    },
    //附件上传
    beforeFileUpload(file, config) {
      if (!fileFormatted(file.name, config.fileDocument)) {
        this.$message.error("上传文件格式不对");
        return false;
      }
      const count = file.size / 1024 / 1024
      const upSize = config.maxSize || 200
      if (count > upSize) {
        this.$message.error("上传附件大小不能超过" + upSize + "MB!");
        return false
      }

      // const isGt50M = file.size / 1024 / 1024 < 200;
      // if (!isGt50M) {
      //   this.$message.error("上传附件大小不能超过200MB!");
      //   return false;
      // }
      this.fileListLength += 1;
      this.upDataFile = false;
    },
    /* 图片、附件 end */

    /* 表格方法 start */
    addMousedown(event, type) {
      const self = this;
      const target = event.target || event.srcElement;
      const parentDom = target.parentNode;
      const width = parentDom.clientWidth;

      document.onmousemove = function(move) {
        // 拖拽对象的坐标 = 鼠标的坐标(event.client) - 拖拽对象的大小(dis)
        const widthNumber = move.clientX - event.clientX;
        const widthVal = Number(width) + Number(widthNumber);

        if (widthVal > 89 && widthVal < 721) {
          const str = "width:" + widthVal + "px;";
          // const str = "min-width:" + widthVal + "px;width:" + widthVal + "px;";
          (
            target.previousElementSibling || target.previousSibling
          ).style.cssText = str;
          // self.$set(self.widthObj, type, widthVal + "px");
          self.widthObj[type] = widthVal + "px"
        }
      };
      // 当鼠标放开时执行的js
      document.onmouseup = function() {
        document.onmousemove = null;
        document.onmouseup = null;
      };
      // 右键点击检测
      document.onmousedown = function(e) {
        if (e.which == 3) {
          document.onmousemove = null;
          document.onmouseup = null;
        }
      };
    },
    /* 表格方法 end */

    //明细里面的四则运算
    arithmetic(item){
      // setTimeout(function(){

          // !(item.dataconfig.setUpValue === 4)&&item.type === 'number' 原判断
          if(item.dataconfig && item.type === 'number'){
            let detailName = this.detailsWidgetData.title + '_' + this.detailsWidgetData.type
            let tmName = item.title + '_' + item.type
            let ruleRes = this.detailsWidgetData.list.filter(item1 => item1.dataconfig.formula && (item1.dataconfig.formula.allcontrols === detailName +'.' + tmName || item1.dataconfig.formula.filterControls === detailName +'.' + tmName))
            // 遍历所有数据项进行计算
            this.formdata.forEach((data, dataIndex) => {
              for(let i = 0; i < ruleRes.length; i++) {
                let formula = ruleRes[i].dataconfig.formula;
                let oneValue = formula.allcontrols.split('.')[1];
                let twoValue = formula.filterControls.split('.')[1];
                // 获取计算所需的值
                const val1 = Number(data[oneValue] || 0);
                const val2 = Number(data[twoValue] || 0);
                let result = 0;
                switch(formula.operation) {
                  case 0: result = val1 + val2; break;
                  case 1: result = val1 - val2; break;
                  case 2: result = val1 * val2; break;
                  case 3: result = val2 !== 0 ? val1 / val2 : 0; break;
                }
                const targetKey = ruleRes[i].title + '_' + ruleRes[i].type;
                const newValue = Number(result.toFixed(4));
                console.log(`准备更新 - index: ${dataIndex}, key: ${targetKey}, oldValue: ${data[targetKey]}, newValue: ${newValue}`);
                // this.$set(this.formdata[dataIndex], targetKey, newValue);
                this.formdata[dataIndex][targetKey] = newValue
                console.log(`更新后的值 - index: ${dataIndex}, key: ${targetKey}, currentValue: ${this.formdata[dataIndex][targetKey]}`);
              }
            });
            // 打印最终状态
            console.log('计算完成后的formdata:', JSON.stringify(this.formdata));
            // 确保视图更新
            this.$nextTick(() => {
              // 再次确认数据
              console.log('nextTick后的formdata:', JSON.stringify(this.formdata));
              this.$emit('updateFormdata', this.detailsWidgetData)
              this.$forceUpdate();
            });
          }
        // },100)


    },
    // 是否显示OCR扫码图标(开启ocr，并且值为空或者null不显示)
    showScan(obj) {
      // console.log("obj==",obj);
      return !Object.values(obj).every(value => value === '' || value === null || value === undefined || (Array.isArray(value) && value.length === 0))
    },
    // ocr扫码
    scanOcr(index){
      console.log("detailsWidgetData==",this.detailsWidgetData);
      this.$emit("scanOcr",{detailsInfo: this.detailsWidgetData, idx: index})
    }
  }
};
</script>

<style scoped lang="scss">
.radio-list {
  display: flex !important;
  align-items: center;
  flex-wrap: wrap;
  .radio-list-button {
    padding: 5px 16px;
    border-radius: 4px;
    line-height: 20px;
    color: #C0C4CC;
    border: 1px solid #C0C4CC;
    margin-right: 10px;
    cursor: pointer;
    margin-bottom: 10px;
    &:last-child {
      margin-right: 0;
    }
  }
  .radio-list-imgs {
    width: 102px;
    height: 132px;
    margin-right: 10px;
    line-height: 0;
    background-color: #ffffff;
    border-radius: 4px;
    border: 1px solid transparent;
    margin-bottom: 10px;
    cursor: pointer;
    .radio-list-img {
      width: calc(100% - 2px);
      height: 100px;
      position: relative;
      padding-left: 1px;
    }
    .radio-list-text {
      width: 100%;
      text-align: center;
      line-height: 32px;
      color: #333333;
    }
    .no-icon {
      position: absolute;
      left: calc(50% - 15px);
      top: calc(50% - 15px);
      font-size: 30px;
      color: #E6E8EB;
    }
  }
}
.no-back {
  background-color: transparent !important;
  padding: 0 !important;
}
.text-link {
  text-decoration: underline;
  color: #4e86ff;
  cursor: pointer;
}
.time-md-m {
  display: flex;
  align-items: center;
  .time-md {
    width: 30%;
    max-width: 160px;
    min-width: 90px;
    position: relative;
    margin-left: 10px;
    .time-md-text {
      position: absolute;
      top: 12px;
      left: 10px;
      pointer-events: none;
    }
  }
}
.time-y-m {
  position: relative;
  width: 100%;
  :deep(.el-input__inner) {
    color: #ffffff;
  }
  .time-y-m-text {
    position: absolute;
    top: 11px;
    left: 30px;
  }
}
.time-text-color {
  :deep(.el-input__inner) {
    color: #606266;
  }
  .time-y-m-text {
    display: none;
  }
}
.file-label-down {
  color: #4e86ff;
  cursor: pointer;
  font-size: 14px;
  font-weight: normal;
}
.details-table-col {
  .file-label-down {
    float: right;
    padding-bottom: 5px;
  }
}
.like-list-name {
  .file-label-down {
    float: right;
  }
}
:deep(.check-inp) {
  .el-input {
    line-height: normal;
    .el-input__prefix {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      .demo-tag-details {
        margin-top: 0px;
      }
    }
  }
}
.details-table-link {
  :deep(.el-form-item) {
    margin-top: 0;
  }
  .table-link-block {
    border-radius: 4px;
    background-color: #F9F9F9;
    padding-top: 10px;
    padding-bottom: 10px;
    margin-bottom: 15px;
    position: relative;
    .table-link-block-label {
      border-radius: 1.5px;
      background-color: #4E86FF;
      height: 21px;
      line-height: 21px;
      color: #fff;
      padding-left: 5px;
      display: inline-block;
      position: relative;
      &::before {
        content: ' ';
        position: absolute;
        right: -10px;
        top: 0;
        width: 0;
        height: 0;
        border-left: 11px solid #4E86FF;
        border-top: 10px solid transparent;
        border-bottom: 11px solid transparent;
      }
    }
    .link-delete {
      color: #D44D4D;
      font-size: 16px;
      position: absolute;
      right: 16px;
      top: 12px;
      cursor: pointer;
      label,
      i {
        margin:0 6px;
      }
    }
    .table-link-block-t {
      display: flex;
      align-items: flex-start;
      padding-top: 12px;
      padding-right: 15px;
      .table-link-block-list {
        display: inline-block;
        padding-left: 15px;
        .like-list-name {
          color: #333333;
          font-weight: 500;
          font-size: 14px;
          .required {
            color: #D44D4D;
          }
        }
        .like-list-input {
          flex: 1;
        }
      }
      .link-list-tb {
        flex: 1;
        .like-list-name {
          padding-bottom: 8px;
        }
      }
      .link-list-lr {
        display: flex;
        align-items: flex-start;
        flex: 1;
        .like-list-name {
          padding-top: 10px;
          padding-right: 12px;
        }
      }
    }
  }
  .file-img-up {
    flex-direction: column-reverse;
    :deep(.el-upload-list) {
      max-height: auto;
      margin-top: 12px;
      .el-upload-list__item {
        width: 60px;
        height: 60px;
      }
    }
  }
  .rel-select {
    margin-left: 0;
    display: block;
  }
  .rel-button-up {
    line-height: 38px;
  }
  .like-list-input-b {
    border-radius: 4px;
    background-color: #F2F2F2;
    padding: 10px 16px;
    min-height: 16px;
  }
}
.play {
  cursor: pointer;
  margin-left: 6px;
}
.rel-select {
  border-radius: 4px;
  border: 1px solid #E5E5E5;
  padding: 7px 18px;
  color: #999999;
  font-size: 14px;
  display: inline-block;
  cursor: pointer;
  position: relative;
  margin-left: calc(50% - 33px);
  margin-top: 5px;
  margin-bottom: 5px;
}
.rel-dialog {
  position: relative;
  .rel-all-dialog {
    position: fixed;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    background-color: rgba(0, 0, 0, 0.36);
    z-index: 9;
  }
  .rel-all-up {
    position: fixed;
    z-index: 10;
    top: 0;
    left: 0;
    display: flex;
    align-items: center;
    background-color: #ffffff;
    padding: 10px;
    transition: 0.3s;
    .rel-all-up-ate {
      position: relative;
    }
    .rel-all-close {
      font-size: 14px;
      color: #4e86ff;
      padding-left: 16px;
      cursor: pointer;
      min-width: 30px;
    }
  }
}
.rel-button-up {
  color: #4e86ff;
  cursor: pointer;
  margin-left: calc(50% - 16px);
}
.radio-img {
  display: flex;
  align-items: center;
  .radio-imgs {
    width: 14px;
    height: 14px;
    margin-right: 12px;
  }
  ::v-deep .image-slot {
    width: 14px;
    height: 14px;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #f5f7fa;
    color: #909399;
  }
}
/*
.file-img-up .el-upload-list, .img-file-class >>> .el-upload-list{
  display: none !important;
}
*/
  // 签名板
  .signa{
    :deep(.el-dialog) {
      border-radius: 8px;
      overflow: hidden;
    }
    :deep(.el-dialog__header){
      padding: 0 12px 0 31px;
      height: 52px;    
      background: #f5f5f5;
      .el-dialog__title{
        line-height: 52px;
        font-size: 16px;
        color:#333;
      }
    }
    :deep(.el-dialog__body){
      padding: 31px 0 31px 31px;
      .sign {
        clear: both;
        overflow: hidden;
        .pc {
          float: left;
          width: 582px;
          position: relative;
          h6 {
            height: 30px;
            line-height: 30px;
            font-weight: normal;
            font-size: 16px;
            color: #333;
            margin-bottom: 16px;
          }
          .box{
            border-radius: 8px;
            background-color: #F6F7F8;
          }
          .clear{
            position: absolute;
            right: 20px;
            bottom: 17px;
          }
        }
        .phone {
          float: right;
          width: 286px;
          text-align: center;
          padding-top: 45px;
          .tip1 {
            font-size: 16px;
            color: #333;
            line-height: 24px;
            padding-bottom: 10px;
          }
          .code {
            width: 198px;
            height: 198px;
            margin:0 auto;
            padding:4px;
            border: 1px solid #e4e4e4;
            border-radius: 8px;
            box-sizing: border-box;
          }
          .upload-sign {
            position: relative;
            width: 198px;
            height: 42px;
            line-height: 42px;
            font-size: 14px;
            color: #4e86ff;
            text-align: center;
            margin: 0 auto;
            border-radius: 4px;
            border: 1px solid #4e86ff;
            cursor: pointer;
            input {
              position: absolute;
              left: 0;
              top: 0;
              width: 100%;
              height: 100%;
              z-index:3;
              opacity: 0;
              cursor: pointer;
            }
          }
          .tip2 {
            font-size: 12px;
            color: #666;
            line-height: 18px;
            padding: 14px 0;
          }
        }
      }
    }
  }
  .signaPic{
    float: left;
    position: relative;
    width: 88px;
    height: 88px;
    border: 1px solid #EDEDED;
    border-radius: 3px;
    margin: 24px 24px 0 0;
    display: flex;
    align-items: center;
    text-align: center;
    img {
      display: block;
      max-width: 100%;
      margin:0 auto;
    }
    .btn-delete {
      position: absolute;
      right: -6px;
      top: -4px;
      width: 16px;
      height: 16px;
      background: url("https://bigdata.topeti.com/PCRepository/mainPlatform/icon-delete.png") no-repeat;
      cursor: pointer;
    }
  }
  .signabtn{
    float: left;
    display: block;
    width: 88px;
    height: 88px;
    font-size: 12px;
    color: #333;
    line-height: 20px;
    padding-top: 51px;
    box-sizing: border-box;
    text-align: center;
    background: #f7f7fa url("https://bigdata.topeti.com/PCRepository/mainPlatform/icon-sign.png") no-repeat 50% 19px;
    border: 1px dashed #EDEDED;
    border-radius: 3px;
    cursor: pointer;
    transition: all .5s;
    &:hover{
      color: rgb(87, 168, 251);
    }
  }
  .show_imglist {
    width: 100%;
    overflow: hidden;

    li {
      display: flex;
      align-items: center;
      padding: 0 5px 0 4px;
      overflow: hidden;
      height: 26px;
      line-height: 26px;
      &:hover {
        background-color: #f5f7fa;
        transition: color 0.3;
      }
      &:hover i:nth-child(2) {
        display: block !important;
      }
      &:hover span i:nth-child(1) {
        display: none !important;
      }

      &:hover a {
        color: #4e86ff;
      }
      a {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        text-decoration: none;
        color: #666;
        padding-left: 3px;
        width: 80%;
      }
      .icon_to {
        position: absolute;
        right: 5px;
        i:nth-child(2) {
          display: none;
        }
      }
    }
  }
  .on-show-left {
    background-color: #ffffff !important;
    border-color: #ffffff !important;;
    justify-content: left !important;;
  }
  .details-table-table-row:hover .on-show-left {
    color: #317CDF !important;
  }
  .on-show-pointer {
    :deep(.el-input__inner),
    :deep(.el-textarea__inner),
    :deep(.el-input__prefix) {
      cursor: pointer;
    }
  }
.on-show {
  text-align: center;
  color: #4e86ff;
  .on-show-show {
    position:absolute;
    margin: 5px 10px;
    width:calc(100% - 22px);
    top:0;
    left:0;
    z-index:7;
    cursor: pointer;
    background-color:#F1F8FF;
    border: 1px solid #4e86ff;
    border-radius: 4px;
    height: calc(100% - 12px);
    display: flex;
    align-items: center;
    justify-content: center;
    i {
      margin-right: 6px;
    }
  }
  .on-show-close {
    cursor: pointer;
    position: absolute;
    right: 0;
    z-index: 5;
    margin-right: 15px;
    top: 50%;
    transform: translateY(-50%);
  }
  .on-select {
    right: 15px;
  }
}

:deep(.el-scrollbar) {
  padding-bottom: 5px !important;
.el-scrollbar__wrap {
  max-height: 500px; // 最大高度
  overflow-x: hidden; // 隐藏横向滚动栏
}
}
:deep(.el-scrollbar__bar) {
  opacity: 1;
}
:deep(.el-scrollbar__bar.is-vertical:hover) {
  width: 12px;
}
.time-block {
  display: flex;
  align-items: center;
  .time-week {
    min-width: 64px;
    text-align: center;
    line-height: 38px;
    background: #F2F2F2;
    border-radius: 2px;
    border-width: 1px;
    border-style: solid;
    border-color: #D8D8D8;
    margin-left: 4px;
    font-size: 14px;
    color: #999999;
  }
}
.details-table-row {
  .time-y-m-text {
    top: 7px;
  }
  .time-md-text {
    top: 6px;
  }
}
.details-table-all {
  position: relative;
  border: 1px solid #e5e5e5;
  border-radius: 10px;
  overflow-y: hidden;
  overflow-x: auto;
  -webkit-overflow-scrolling:touch;
}
.img-flex {
  display: flex;
  flex-wrap: wrap;
}
/* UI start */
.other-class:focus {
  outline: none;
}
.other-class {
  width: calc(100% - 42px);
  height: 40px;
  -webkit-border-radius: 4px;
  -moz-border-radius: 4px;
  border-radius: 4px;
  border: 1px solid #d2d2d2;
  padding-left: 20px;
  padding-right: 20px;
  margin-top: 5px;
}
.list-block {
  //padding: 4px 8px;
  border-radius: 4px;
  //margin: 4px;
  display: inline-block;
  font-weight: normal;
  padding: 8px;
  margin-right: 4px;
}
.list-block-active {
  padding: 4px 8px;
  margin: 4px;
}

.select-details .demo-tag-details{
  padding: 0px 21px 0px 12px;
  margin-top: 5px;
  margin-right: 7px;
  margin-bottom: 0px;
  display: inline-block;
  background: #4e86ff;
  color: #fff;//transparent
  line-height: 22px;
  border-radius: 10px;
}
.input-select .el-input__prefix{
  right: 30px;
  overflow: hidden;
  text-align: left !important;
}
.ridiotagstyle{
  max-width: calc(100% - 16px);
  padding: 0 8px;
  color:#333;
  display: inline-block;
  min-height: 30px;
  line-height: 30px;
  border-radius: 10px;
  background: #fff;
  margin-top: 5px;
}
.ridiotagstyle:nth-child(1){
  // margin-left: 10px;
}
/* UI end */

/*.table-all {*/
/*  width: 100%;*/
/*  overflow: auto;*/
/*  max-height: 500px; // 暂时的*/
/*  padding-bottom: 17px;*/
/*}*/
/*.details-table {*/
/*  display: table;*/
/*  table-layout: fixed;*/
/*  position: relative;*/
/*  z-index: 1;*/
/*  padding-top: 39px;*/
/*}*/
.details-table-col {
  display: table-row;
  border-bottom: 1px solid #e5e5e5;
  position: relative;
}
.details-table-no-text {
  padding-top: 28px;
  color: #999999;
  position: relative;
  height: 20px;
  padding-bottom: 10px;
}
.details-table-no-text div {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
}
.table-col-nowrap {
  white-space: nowrap;
}
/*.table-col-header {*/
/*  background: #f7f7f7;*/
/*  color: #333333;*/
/*  font-weight: bold;*/
/*  position: absolute;*/
/*  top: 0;*/
/*  z-index: 2;*/
/*}*/
.header .details-table-row {
  background-color: #f7f7f7;
  color: #333333;
  font-weight: bold;
}
.details-table-row {
  display: table-cell;
  table-layout: fixed;
  /*text-align: left;*/
  /*padding: 0 20px;*/
  /*padding: 10px 20px;*/
  border-right: 1px solid #e5e5e5;
  border-bottom: 1px solid #e5e5e5;
  font-size: 14px;
  color: rgba(51, 51, 51, 1);
  flex: 1;
  vertical-align: middle;
  background-color: #ffffff;
  position: relative;
}
.details-table-header-row {
  padding: 10px;
  display: flex;
}
.right-block-number{
  display: flex;
}
.one-omit {
  width: 100%;
  flex-wrap: wrap;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.details-table-table-row {
  padding: 5px 10px;
  white-space: inherit;
  word-break: break-all;
  line-height: 26px;
}
.table-mouse {
  position: absolute;
  right: 0;
  top: 0;
  height: 100%;
  border-right: 2px solid transparent;
  cursor: col-resize;
}
.text-center {
  text-align: center;
}
.cor-red {
  color: red;
  margin-right: 2px;
}
.icon-rel:before {
  position: relative;
  top: 10px;
  left: 20px;
}
.icon-rel:hover {
  color: #965500;
  background-color: #fffdf6;
  border-color: #f6e8d0;
}
.icon-rel {
  position: absolute;
  right: 1px;
  top: 50%;
  transform: translateY(-50%);
  /*padding: 0 10px;*/
  height: 36px;
  width: 56px;
  line-height: 100%;
  cursor: pointer;
  z-index: 2;
  color: #999999;
  background-color: #ffffff;
  -webkit-border-radius: 4px;
  -moz-border-radius: 4px;
  border-radius: 4px;
  font-size: 18px;
  border: 1px dashed #e2e0dc;
}
.icon-saoyisao- {
  font-size: 14px;
  color: #4E86FF;
  cursor: pointer;
}
.list-img {
  width: 68px;
  max-height: 70px;
  height: auto;
  margin-right: 10px;
}
.a-list-download {
  padding: 4px 0;
  display: flex;
  justify-content: space-between;
}
.a-list {
  color: #333333;
  text-decoration: none;
}
.a-list:hover {
  color: #cf7500;
  text-decoration: underline;
}
.a-list-download-span,
.el-dropdown-link {
  color: #4e86ff;
  text-decoration: none;
  cursor: pointer;
}
.details-textarea-right {
  text-align: right;
  font-size: 14px;
  color: #999999;
  /*position: absolute;*/
  /*bottom: 0;*/
  /*right: 10px;*/
}
.text-c {
  text-align: center;
}
.text-r {
  text-align: right;
  border-right-color: transparent;
}
.pad-5 {
  padding-top: 5px;
  padding-bottom: 5px;
}
:deep(.el-image-viewer__wrapper) {
  width: 91%;
  height: 90%;
  top: 6%;
  left: 4%;
}
.textarea-table {
  :deep(textarea) {
    height: auto !important;
  }
}
.relation-user-wrap {
  position: relative;
  .drop-down {
    position: absolute;
    top: 42px;
    width: 100%;
  }
  :deep(.el-input__inner) {
    padding: 0 0 0 5px;
    border: none !important;
  }
  .fast-btn {
    display: none;
    position: absolute;
    right: 0;
    top: 0;
    a {
      position: relative;
      float: left;
      display: block;
      width: 38px;
      height: 38px;
      line-height: 38px;
      text-align: center;
      color: #4e86ff;
      cursor: pointer;
      &::after{
        content: "";
        position: absolute;
        top: 9px;
        left: 0;
        width: 1px;
        height: 20px;
        background-color: #ccc;
      }
    }
  }
}
.relation-default {
  .relation-user {
    position: relative;
    padding-right: 77px;
  }
  .fast-btn {
    display: block;
  }
}
</style>
